import { Locale } from "@/lib/i18n";

const item = (title: string, description: string) => ({ title, description });
const step = (number: string, title: string, description: string) => ({ number, title, description });
const quote = (text: string, author: string, role: string) => ({ text, author, role });
const section = (title: string, body?: string, bullets?: string[]) => ({
  title,
  ...(body ? { body } : {}),
  ...(bullets ? { bullets } : {}),
});

const firstHalf: Partial<Record<Locale, unknown>> = {
  vi: {
    landing: {
      toolsDescription: "Khám phá những công cụ trực tuyến miễn phí được dùng nhiều nhất. An toàn, nhanh và dễ sử dụng.",
      useCasesTitle: "Trường hợp sử dụng",
      useCasesDescription: "Xem cách Dogufy hỗ trợ nhiều nhóm người dùng hoàn thành công việc nhanh hơn.",
      useCases: [
        item("Dành cho sinh viên và học thuật", "Gộp bài tập, nén tệp luận văn và chuyển tài liệu nghiên cứu sang định dạng có thể chỉnh sửa."),
        item("Dành cho chuyên gia kinh doanh", "Ký hợp đồng, gộp báo cáo và chuyển bảng tính thành tệp PDF dễ chia sẻ."),
        item("Dành cho nhà thiết kế và sáng tạo", "Tối ưu hình ảnh, xóa nền và chuyển đổi tài sản số nhanh hơn."),
        item("Dành cho nhóm pháp lý", "Quản lý tài liệu nhạy cảm với quy trình riêng tư hơn và bố cục tài liệu gọn gàng hơn."),
        item("Dành cho môi giới bất động sản", "Chuẩn bị brochure, hồ sơ bất động sản và tài sản niêm yết hiệu quả hơn."),
      ],
      useCasesCta: "Dùng công cụ",
      processDescription: "Đơn giản, nhanh và an toàn. Chuẩn bị tài liệu của bạn chỉ với 4 bước.",
      processSteps: [
        step("01", "Chọn công cụ", "Chọn quy trình phù hợp từ bộ công cụ PDF, hình ảnh và văn bản của chúng tôi."),
        step("02", "Tải tệp lên", "Thả tệp trực tiếp vào trình duyệt và chỉnh các tùy chọn có sẵn."),
        step("03", "Xử lý trong vài giây", "Chạy tác vụ ngay mà không cần cài thêm phần mềm."),
        step("04", "Tải xuống và chia sẻ", "Nhận kết quả ngay lập tức và tiếp tục công việc của bạn."),
      ],
      featuresDescription: "Chúng tôi cung cấp các công cụ miễn phí được xây dựng cho tốc độ, quyền riêng tư và quy trình thực tế.",
      features: [
        item("Miễn phí mãi mãi", "Sử dụng công cụ mà không cần đăng ký, phí ẩn hoặc tường thanh toán."),
        item("An toàn và riêng tư", "Quy trình chú trọng quyền riêng tư giúp kiểm soát tốt hơn các tệp nhạy cảm."),
        item("Cực nhanh", "Quy trình trên trình duyệt giúp giảm thời gian cho các tác vụ lặp lại."),
        item("Dễ sử dụng", "Giao diện được thiết kế thân thiện cả với người không chuyên kỹ thuật."),
        item("Thân thiện di động", "Trải nghiệm hoạt động tốt trên desktop, tablet và di động."),
        item("Chất lượng cao", "Chúng tôi cố gắng giữ chất lượng đầu ra hữu ích trong khi vẫn đơn giản hóa quy trình."),
      ],
      testimonialsDescription: "Xem người dùng nói gì về Dogufy.",
      testimonials: [
        quote("Dogufy giúp tôi gộp các chương luận văn nhanh chóng mà không rắc rối.", "Sarah J.", "Học viên cao học"),
        quote("Tôi dùng bộ công cụ hình ảnh thường xuyên cho công việc web vì chúng nhanh và tiện.", "Mike T.", "Lập trình viên frontend"),
        quote("Các công cụ chuyển đổi tài liệu giúp tiết kiệm thời gian khi chuẩn bị bản có thể chỉnh sửa.", "Emily R.", "Trợ lý pháp lý"),
      ],
      landingContactDescription: "Liên hệ với chúng tôi nếu bạn muốn góp ý, đặt câu hỏi hoặc thảo luận về sản phẩm.",
      sayHi: "Chào hỏi",
      getQuote: "Nhận báo giá",
      name: "Tên",
      email: "Email",
      message: "Tin nhắn",
      send: "Gửi tin nhắn",
    },
    about: {
      intro: "Chào mừng bạn đến với Dogufy, nơi đáp ứng nhu cầu xử lý tài liệu, hình ảnh và văn bản trong một điểm đến duy nhất.",
      missionBody: "Chúng tôi tin rằng các công cụ năng suất mạnh mẽ nên dễ tiếp cận với mọi người. Sứ mệnh của chúng tôi là cung cấp các công cụ trực tuyến miễn phí, chất lượng cao giúp người dùng làm việc nhanh hơn mà không cần phần mềm đắt tiền hay thiết lập phức tạp.",
      offers: [
        "Công cụ PDF để chuyển đổi, gộp, tách, nén và chỉnh sửa tài liệu.",
        "Công cụ hình ảnh để đổi kích thước, nén, chuyển định dạng và làm sạch tài sản trực quan.",
        "Công cụ văn bản để định dạng, chuyển đổi và phân tích nội dung.",
        "Tiện ích cho lập trình viên như tạo QR, tạo UUID và các công cụ nhanh khác.",
      ],
      privacyTitle: "Ưu tiên quyền riêng tư",
      privacyBody: "Phần lớn việc xử lý tệp diễn ra trực tiếp trong trình duyệt. Tệp của bạn vẫn nằm trong tầm kiểm soát để quy trình nhanh hơn, riêng tư hơn và an toàn hơn.",
      freeTitle: "Miễn phí 100%",
      freeBody: "Các công cụ của chúng tôi có sẵn mà không cần đăng ký, chi phí ẩn hay rào cản tạo tài khoản.",
    },
    contact: {
      sentTitle: "Đã gửi tin nhắn!",
      sentBody: "Cảm ơn bạn đã liên hệ. Chúng tôi sẽ phản hồi sớm.",
      labels: { name: "Tên", email: "Email", subject: "Chủ đề", message: "Tin nhắn" },
      placeholders: {
        name: "Tên của bạn",
        email: "email@vi-du.com",
        subject: "Nội dung liên hệ là gì?",
        message: "Hãy chia sẻ chi tiết hơn...",
      },
      github: "GitHub",
      githubBody: "Phát hiện lỗi hoặc muốn đóng góp? Hãy xem kho mã nguồn của chúng tôi.",
      viewRepo: "Xem kho mã nguồn",
    },
    privacy: {
      sections: [
        section("Quyền riêng tư của bạn rất quan trọng", "Chúng tôi coi trọng quyền riêng tư và cố gắng giảm thiểu việc thu thập dữ liệu không cần thiết."),
        section("Xử lý dữ liệu", "Hầu hết công cụ xử lý tệp ngay trong trình duyệt. Một số chuyển đổi nâng cao có thể cần xử lý tạm thời ở máy chủ.", [
          "Tệp thường vẫn nằm trên thiết bị của bạn trong quá trình xử lý.",
          "Các tác vụ tạm thời phía máy chủ sẽ bị xóa sau khi hoàn tất.",
          "Chúng tôi không chủ ý lưu nội dung tài liệu.",
        ]),
        section("Thông tin chúng tôi thu thập", undefined, [
          "Phân tích ẩn danh chỉ sau khi có sự đồng ý.",
          "Không cần tạo tài khoản để dùng các công cụ cốt lõi.",
          "Không lưu trữ vĩnh viễn tệp đã tải lên.",
        ]),
        section("Cookie", undefined, [
          "Lưu lựa chọn đồng ý cookie.",
          "Bảo mật và chức năng thiết yếu của trang web.",
          "Phân tích tùy chọn sau khi bạn cấp phép rõ ràng.",
        ]),
        section("Quyền của bạn", "Bạn có thể từ chối phân tích, xóa dữ liệu cục bộ trong trình duyệt và ngừng sử dụng dịch vụ bất kỳ lúc nào."),
      ],
    },
    terms: {
      sections: [
        section("1. Chấp nhận điều khoản", "Khi sử dụng Dogufy, bạn đồng ý với các điều khoản này."),
        section("2. Sử dụng dịch vụ", "Dịch vụ được cung cấp cho nhu cầu năng suất cá nhân và thương mại.", [
          "Sử dụng dịch vụ một cách hợp pháp.",
          "Không làm quá tải, khai thác hoặc lạm dụng nền tảng.",
          "Không dùng công cụ cho mục đích gây hại hoặc độc hại.",
        ]),
        section("3. Tính sẵn sàng của dịch vụ", "Chúng tôi cố gắng duy trì độ ổn định nhưng không thể đảm bảo truy cập liên tục hoặc không có lỗi."),
        section("4. Giới hạn trách nhiệm", "Việc sử dụng dịch vụ là rủi ro của riêng bạn, bao gồm kiểm tra chất lượng tệp đầu ra và mức độ phù hợp của quy trình."),
        section("5. Trách nhiệm của người dùng", "Bạn vẫn chịu trách nhiệm đối với tệp của mình và quyền xử lý các tệp đó.", [
          "Luôn sao lưu bản gốc quan trọng.",
          "Kiểm tra chất lượng đầu ra trước khi dùng cho nhu cầu quan trọng.",
          "Tôn trọng bản quyền và các nghĩa vụ pháp lý khác.",
        ]),
        section("6. Liên hệ", "Nếu bạn có câu hỏi về các điều khoản này, vui lòng liên hệ với chúng tôi qua website."),
      ],
    },
    blog: {
      description: "Đọc các bài viết mới nhất của chúng tôi về công cụ PDF, xử lý hình ảnh và năng suất làm việc.",
      intro: "Khám phá các bài viết thực tế về tài liệu, hình ảnh và quy trình số.",
      noTools: "Không tìm thấy kết quả nào.",
      clear: "Xóa tìm kiếm",
    },
    toolsPage: {
      description: "Duyệt toàn bộ bộ sưu tập công cụ trực tuyến miễn phí của chúng tôi và tìm đúng quy trình bạn cần.",
      intro: "Trang trung tâm này giúp người dùng và công cụ tìm kiếm hiểu rõ toàn bộ thư viện công cụ của Dogufy và nhanh chóng đi đến trang phù hợp.",
      searchPlaceholder: "Tìm công cụ (ví dụ: merge, image, pdf)...",
      noResultsTitle: "Không tìm thấy công cụ",
      noResultsBody: "Chúng tôi không tìm thấy công cụ phù hợp với từ khóa của bạn. Hãy thử từ khóa hoặc danh mục khác.",
      didYouKnow: "Bạn có biết không?",
      didYouKnowBody: "Nhiều quy trình chạy trực tiếp trong trình duyệt, giúp xử lý tài liệu nhanh hơn và riêng tư hơn.",
      whatMakesUseful: "Điều gì khiến công cụ này hữu ích?",
      howToOnline: "Cách dùng công cụ này trực tuyến",
      uploadOrEnter: "Tải lên hoặc nhập dữ liệu",
      configure: "Cấu hình thiết lập",
      processDownload: "Xử lý và tải xuống",
      bestUseCases: "Trường hợp sử dụng tốt nhất",
      whyChoose: "Vì sao nên dùng Dogufy cho công cụ này?",
      fastFree: "Nhanh và miễn phí",
      fastFreeBody: "Thực hiện quy trình nhanh chóng mà không cần đăng ký.",
      securePrivate: "An toàn và riêng tư",
      securePrivateBody: "Trải nghiệm được thiết kế để giảm thiểu việc lộ tệp không cần thiết.",
      highQuality: "Chất lượng cao",
      highQualityBody: "Chúng tôi cố gắng duy trì chất lượng đầu ra hữu ích trong khi đơn giản hóa quy trình.",
      relatedCategory: "Công cụ liên quan",
      removeFile: "Xóa tệp",
      convertedImages: "Ảnh đã chuyển đổi",
      downloadAll: "Tải tất cả",
      downloadPage: "Tải trang",
      pageLabel: "Trang",
      convertingPdf: "Đang chuyển đổi PDF...",
      convertingPdfToImages: "Đang chuyển PDF thành hình ảnh...",
      complete: "hoàn tất",
      completed: "đã hoàn tất",
      convertToPng: "Chuyển sang PNG",
      convertToPngDescription: "Chuyển từng trang PDF thành ảnh PNG chất lượng cao với hỗ trợ nền trong suốt.",
      convertToJpg: "Chuyển sang JPG",
      convertToJpgDescription: "Chuyển từng trang PDF thành ảnh JPG chất lượng cao.",
      invalidPdfFile: "Vui lòng chọn tệp PDF.",
      pdfToPngError: "Có lỗi khi chuyển PDF sang PNG",
      pdfConversionError: "Có lỗi khi chuyển đổi PDF. Vui lòng thử lại.",
      convertToWord: "Chuyển sang Word",
      convertToWordDescription: "Chuyển tệp PDF thành tài liệu Word có thể chỉnh sửa (DOCX).",
      convertToWordButton: "Chuyển sang Word (.docx)",
      convertingToWord: "Đang chuyển sang Word...",
      pdfToWordError: "Có lỗi khi chuyển PDF sang Word. Vui lòng thử lại.",
      convertToPdf: "Chuyển sang PDF",
      convertingToPdf: "Đang chuyển sang PDF...",
      wordToPdfError: "Có lỗi khi chuyển Word sang PDF. Vui lòng thử lại.",
      mergePdfTitle: "Gộp tệp PDF",
      mergePdfDescription: "Kết hợp nhiều tệp PDF thành một tài liệu. Kéo thả để đổi thứ tự tệp.",
      mergePdfHint: "Chọn từ 2 tệp PDF trở lên để gộp",
      filesToMerge: "Tệp cần gộp",
      clearAll: "Xóa tất cả",
      moveUp: "Di chuyển lên",
      moveDown: "Di chuyển xuống",
      merging: "Đang gộp...",
      mergePdfs: "Gộp PDF",
      mergePdfError: "Có lỗi khi gộp PDF. Hãy chắc chắn mọi tệp đều là PDF hợp lệ.",
    },
  },
  cs: {
    landing: {
      toolsDescription: "Prozkoumejte naše nejpoužívanější bezplatné online nástroje. Bezpečné, rychlé a snadno použitelné.",
      useCasesTitle: "Případy použití",
      useCasesDescription: "Podívejte se, jak Dogufy pomáhá různým profesionálům dosahovat jejich cílů.",
      useCases: [
        item("Pro studenty a akademiky", "Slučujte úkoly, komprimujte diplomové práce a převádějte výzkumné dokumenty do upravitelných formátů."),
        item("Pro firemní profesionály", "Podepisujte smlouvy, spojujte reporty a převádějte tabulky do sdílitelných PDF souborů."),
        item("Pro designéry a kreativce", "Optimalizujte obrázky, odstraňujte pozadí a převádějte assety rychleji."),
        item("Pro právní týmy", "Pracujte s citlivými dokumenty pomocí soukromějších workflow a přehlednější organizace."),
        item("Pro realitní makléře", "Připravujte brožury, podklady k nemovitostem a listingové assety efektivněji."),
      ],
      useCasesCta: "Vyzkoušet nástroje",
      processDescription: "Jednoduché, rychlé a bezpečné. Připravte dokumenty ve 4 snadných krocích.",
      processSteps: [
        step("01", "Vyberte nástroj", "Zvolte správný workflow z naší kolekce PDF, obrázkových a textových nástrojů."),
        step("02", "Nahrajte soubory", "Přetáhněte soubor do prohlížeče a upravte dostupné možnosti."),
        step("03", "Zpracujte během sekund", "Spusťte úlohu okamžitě bez instalace dalšího softwaru."),
        step("04", "Stáhněte a sdílejte", "Získejte výsledek ihned a pokračujte v práci."),
      ],
      featuresDescription: "Nabízíme bezplatné online nástroje vytvořené pro rychlost, soukromí a praktické workflow.",
      features: [
        item("Navždy zdarma", "Používejte nástroje bez předplatného, skrytých poplatků a paywallu."),
        item("Bezpečné a soukromé", "Workflow zaměřený na soukromí pomáhá udržet citlivé soubory pod kontrolou."),
        item("Bleskově rychlé", "Workflow v prohlížeči zkracují čas strávený opakovanými úkoly."),
        item("Snadné použití", "Rozhraní je navrženo tak, aby bylo přístupné i pro netechnické uživatele."),
        item("Vhodné pro mobil", "Zážitek funguje na desktopu, tabletu i mobilu."),
        item("Vysoká kvalita", "Snažíme se zachovat užitečnou kvalitu výstupu a současně workflow zjednodušit."),
      ],
      testimonialsDescription: "Podívejte se, co uživatelé říkají o Dogufy.",
      testimonials: [
        quote("Dogufy mi pomohl rychle spojit kapitoly diplomové práce bez zbytečné složitosti.", "Sarah J.", "Studentka magisterského studia"),
        quote("Obrázkové nástroje používám pravidelně pro webovou práci, protože jsou rychlé a praktické.", "Mike T.", "Frontend vývojář"),
        quote("Nástroje pro převod dokumentů šetří čas při přípravě upravitelných verzí souborů.", "Emily R.", "Právní asistentka"),
      ],
      landingContactDescription: "Spojte se s námi, pokud chcete prodiskutovat produkt, navrhnout zlepšení nebo položit otázku.",
      sayHi: "Napsat ahoj",
      getQuote: "Získat nabídku",
      name: "Jméno",
      email: "E-mail",
      message: "Zpráva",
      send: "Odeslat zprávu",
    },
    about: {
      intro: "Vítejte v Dogufy, vašem místě pro zpracování dokumentů, obrázků a textu.",
      missionBody: "Věříme, že výkonné produktivní nástroje by měly být dostupné každému. Naším cílem je poskytovat bezplatné kvalitní online nástroje, které lidem pomohou pracovat rychleji bez drahého softwaru a složitého nastavování.",
      offers: [
        "PDF nástroje pro převod, spojování, dělení, kompresi a úpravy dokumentů.",
        "Obrázkové nástroje pro změnu velikosti, kompresi, konverzi a čištění vizuálních podkladů.",
        "Textové nástroje pro formátování, převod a analýzu obsahu.",
        "Vývojářské utility jako generátor QR kódů, UUID a další rychlí pomocníci.",
      ],
      privacyTitle: "Soukromí na prvním místě",
      privacyBody: "Většina zpracování souborů probíhá přímo v prohlížeči. Vaše soubory zůstávají pod vaší kontrolou, což pomáhá udržet workflow rychlé, soukromé a bezpečné.",
      freeTitle: "100% zdarma",
      freeBody: "Naše nástroje jsou dostupné bez předplatného, skrytých poplatků nebo nutnosti registrace.",
    },
    contact: {
      sentTitle: "Zpráva odeslána!",
      sentBody: "Děkujeme, že jste nás kontaktovali. Ozveme se vám co nejdříve.",
      labels: { name: "Jméno", email: "E-mail", subject: "Předmět", message: "Zpráva" },
      placeholders: {
        name: "Vaše jméno",
        email: "email@priklad.cz",
        subject: "Čeho se to týká?",
        message: "Napište nám více podrobností...",
      },
      github: "GitHub",
      githubBody: "Našli jste chybu nebo chcete přispět? Podívejte se do repozitáře.",
      viewRepo: "Zobrazit repozitář",
    },
    privacy: {
      sections: [
        section("Na vašem soukromí záleží", "Bereme soukromí vážně a snažíme se minimalizovat zbytečný sběr dat."),
        section("Zpracování dat", "Většina nástrojů zpracovává soubory lokálně v prohlížeči. Některé pokročilé převody mohou vyžadovat dočasné zpracování na serveru.", [
          "Soubory obvykle během zpracování zůstávají na vašem zařízení.",
          "Dočasné serverové úlohy se po dokončení mažou.",
          "Obsah dokumentů záměrně neukládáme.",
        ]),
        section("Jaké informace shromažďujeme", undefined, [
          "Anonymní analytika pouze po udělení souhlasu.",
          "Pro základní nástroje není potřeba účet.",
          "Žádné trvalé ukládání nahraných souborů.",
        ]),
        section("Cookies", undefined, [
          "Uložení preference souhlasu.",
          "Bezpečnost a základní funkce webu.",
          "Volitelná analytika po výslovném souhlasu.",
        ]),
        section("Vaše práva", "Můžete odmítnout analytiku, vymazat lokální data v prohlížeči a kdykoli přestat službu používat."),
      ],
    },
    terms: {
      sections: [
        section("1. Přijetí podmínek", "Používáním Dogufy souhlasíte s těmito podmínkami."),
        section("2. Použití služby", "Služba je poskytována pro osobní i komerční produktivní použití.", [
          "Používejte službu v souladu se zákonem.",
          "Nepřetěžujte, nezneužívejte ani nevyužívejte platformu škodlivým způsobem.",
          "Nepoužívejte nástroje k nebezpečným nebo škodlivým účelům.",
        ]),
        section("3. Dostupnost služby", "Snažíme se o spolehlivost, ale nemůžeme zaručit nepřerušený přístup nebo provoz bez chyb."),
        section("4. Omezení odpovědnosti", "Službu používáte na vlastní riziko, včetně kontroly kvality výstupu a vhodnosti workflow."),
        section("5. Odpovědnost uživatele", "Za své soubory a právo je zpracovávat odpovídáte vy.", [
          "Uchovávejte si zálohy důležitých originálů.",
          "Před kritickým použitím ověřte kvalitu výstupu.",
          "Respektujte autorská práva a další právní povinnosti.",
        ]),
        section("6. Kontakt", "Máte-li otázky k těmto podmínkám, kontaktujte nás prosím prostřednictvím webu."),
      ],
    },
    blog: {
      description: "Čtěte naše nejnovější články o PDF nástrojích, práci s obrázky a produktivitě.",
      intro: "Objevujte praktické články o dokumentech, obrázcích a digitálních workflow.",
      noTools: "Nebyly nalezeny žádné výsledky.",
      clear: "Vymazat hledání",
    },
    toolsPage: {
      description: "Procházejte naši kompletní kolekci bezplatných online nástrojů a najděte přesně to, co potřebujete.",
      intro: "Tento rozcestník pomáhá návštěvníkům i vyhledávačům porozumět celé knihovně nástrojů Dogufy a rychle přejít na správnou stránku.",
      searchPlaceholder: "Hledat nástroj (např. merge, image, pdf)...",
      noResultsTitle: "Žádné nástroje nenalezeny",
      noResultsBody: "Nenašli jsme žádné nástroje odpovídající vašemu hledání. Zkuste jiné klíčové slovo nebo kategorii.",
      didYouKnow: "Věděli jste, že?",
      didYouKnowBody: "Mnoho workflow běží přímo v prohlížeči, což pomáhá držet práci s dokumenty rychlou a soukromou.",
      whatMakesUseful: "Co dělá tento nástroj užitečným?",
      howToOnline: "Jak používat tento nástroj online",
      uploadOrEnter: "Nahrajte nebo zadejte data",
      configure: "Nastavte volby",
      processDownload: "Zpracujte a stáhněte",
      bestUseCases: "Nejlepší případy použití",
      whyChoose: "Proč zvolit Dogufy pro tento nástroj?",
      fastFree: "Rychlé a zdarma",
      fastFreeBody: "Workflow použijete rychle bez registračních překážek.",
      securePrivate: "Bezpečné a soukromé",
      securePrivateBody: "Zážitek je navržen tak, aby omezil zbytečné vystavení uživatelských souborů.",
      highQuality: "Vysoká kvalita",
      highQualityBody: "Snažíme se zachovat užitečnou kvalitu výstupu a zároveň proces zjednodušit.",
      relatedCategory: "Související nástroje",
      removeFile: "Odebrat soubor",
      convertedImages: "Převedené obrázky",
      downloadAll: "Stáhnout vše",
      downloadPage: "Stáhnout stránku",
      pageLabel: "Stránka",
      convertingPdf: "Převádím PDF...",
      convertingPdfToImages: "Převádím PDF na obrázky...",
      complete: "hotovo",
      completed: "dokončeno",
      convertToPng: "Převést na PNG",
      convertToPngDescription: "Převeďte stránky PDF na kvalitní PNG obrázky s podporou průhlednosti.",
      convertToJpg: "Převést na JPG",
      convertToJpgDescription: "Převeďte stránky PDF na kvalitní JPG obrázky.",
      invalidPdfFile: "Vyberte prosím PDF soubor.",
      pdfToPngError: "Chyba při převodu PDF na PNG",
      pdfConversionError: "Došlo k chybě při převodu PDF. Zkuste to prosím znovu.",
      convertToWord: "Převést do Wordu",
      convertToWordDescription: "Převeďte své PDF soubory do upravitelných dokumentů Word (DOCX).",
      convertToWordButton: "Převést do Wordu (.docx)",
      convertingToWord: "Převádím do Wordu...",
      pdfToWordError: "Chyba při převodu PDF do Wordu. Zkuste to prosím znovu.",
      convertToPdf: "Převést do PDF",
      convertingToPdf: "Převádím do PDF...",
      wordToPdfError: "Chyba při převodu Wordu do PDF. Zkuste to prosím znovu.",
      mergePdfTitle: "Sloučit PDF soubory",
      mergePdfDescription: "Spojte více PDF souborů do jednoho dokumentu. Přetahujte je pro změnu pořadí.",
      mergePdfHint: "Vyberte 2 nebo více PDF souborů ke sloučení",
      filesToMerge: "Soubory ke sloučení",
      clearAll: "Vymazat vše",
      moveUp: "Posunout nahoru",
      moveDown: "Posunout dolů",
      merging: "Slučuji...",
      mergePdfs: "Sloučit PDF",
      mergePdfError: "Chyba při slučování PDF. Ujistěte se, že všechny soubory jsou platné PDF.",
    },
  },
  es: {
    landing: {
      toolsDescription: "Explora nuestras herramientas online gratis más usadas. Seguras, rápidas y fáciles de usar.",
      useCasesTitle: "Casos de uso",
      useCasesDescription: "Descubre cómo Dogufy ayuda a distintos perfiles profesionales a avanzar más rápido.",
      useCases: [
        item("Para estudiantes y académicos", "Une tareas, comprime tesis y convierte documentos de investigación a formatos editables."),
        item("Para profesionales de negocio", "Firma contratos, combina informes y convierte hojas de cálculo en archivos PDF fáciles de compartir."),
        item("Para diseñadores y creativos", "Optimiza imágenes, elimina fondos y convierte recursos visuales con más rapidez."),
        item("Para equipos legales", "Gestiona documentos sensibles con flujos más privados y una organización más clara."),
        item("Para agentes inmobiliarios", "Prepara folletos, archivos de propiedad y materiales de anuncios de forma más eficiente."),
      ],
      useCasesCta: "Probar herramientas",
      processDescription: "Simple, rápido y seguro. Deja tus documentos listos en 4 pasos.",
      processSteps: [
        step("01", "Elige tu herramienta", "Selecciona el flujo adecuado de nuestra colección de herramientas PDF, imagen y texto."),
        step("02", "Sube tus archivos", "Arrastra el archivo al navegador y ajusta las opciones disponibles."),
        step("03", "Procesa en segundos", "Ejecuta la tarea al instante sin instalar software adicional."),
        step("04", "Descarga y comparte", "Obtén el resultado de inmediato y continúa tu trabajo."),
      ],
      featuresDescription: "Ofrecemos herramientas gratuitas pensadas para la velocidad, la privacidad y flujos de trabajo prácticos.",
      features: [
        item("Gratis para siempre", "Usa las herramientas sin suscripciones, costes ocultos ni muros de pago."),
        item("Seguro y privado", "Los flujos centrados en la privacidad ayudan a mantener los archivos sensibles bajo control."),
        item("Muy rápido", "Los flujos en el navegador reducen el tiempo dedicado a tareas repetitivas."),
        item("Fácil de usar", "La interfaz está diseñada para que cualquiera la use con comodidad."),
        item("Compatible con móvil", "La experiencia funciona bien en escritorio, tablet y móvil."),
        item("Alta calidad", "Buscamos mantener una salida útil y de buena calidad sin complicar el proceso."),
      ],
      testimonialsDescription: "Mira lo que dicen los usuarios sobre Dogufy.",
      testimonials: [
        quote("Dogufy me ayudó a unir capítulos de mi tesis rápidamente y sin complicaciones.", "Sarah J.", "Estudiante de posgrado"),
        quote("Uso las herramientas de imagen con frecuencia para trabajo web porque son rápidas y prácticas.", "Mike T.", "Desarrollador frontend"),
        quote("Las herramientas de conversión documental me ahorran tiempo al preparar versiones editables.", "Emily R.", "Asistente legal"),
      ],
      landingContactDescription: "Habla con nosotros si quieres comentar el producto, sugerir mejoras o hacer una pregunta.",
      sayHi: "Saludar",
      getQuote: "Pedir presupuesto",
      name: "Nombre",
      email: "Correo electrónico",
      message: "Mensaje",
      send: "Enviar mensaje",
    },
    about: {
      intro: "Bienvenido a Dogufy, tu solución integral para necesidades de documentos, imágenes y texto.",
      missionBody: "Creemos que las herramientas de productividad potentes deben estar al alcance de todos. Nuestra misión es ofrecer herramientas online gratuitas y de alta calidad para trabajar más rápido sin software caro ni configuraciones complejas.",
      offers: [
        "Herramientas PDF para convertir, unir, dividir, comprimir y editar documentos.",
        "Herramientas de imagen para redimensionar, comprimir, convertir y limpiar recursos visuales.",
        "Herramientas de texto para formatear, convertir y analizar contenido.",
        "Utilidades para desarrolladores como generador QR, UUID y otros atajos útiles.",
      ],
      privacyTitle: "Privacidad primero",
      privacyBody: "La mayor parte del procesamiento ocurre directamente en el navegador. Tus archivos permanecen bajo tu control para mantener el flujo rápido, privado y seguro.",
      freeTitle: "100% gratis",
      freeBody: "Nuestras herramientas están disponibles sin suscripciones, costes ocultos ni barreras de registro.",
    },
    contact: {
      sentTitle: "¡Mensaje enviado!",
      sentBody: "Gracias por escribirnos. Te responderemos en breve.",
      labels: { name: "Nombre", email: "Correo electrónico", subject: "Asunto", message: "Mensaje" },
      placeholders: {
        name: "Tu nombre",
        email: "tu.email@ejemplo.com",
        subject: "¿De qué se trata?",
        message: "Cuéntanos más...",
      },
      github: "GitHub",
      githubBody: "¿Has encontrado un error o quieres contribuir? Revisa el repositorio.",
      viewRepo: "Ver repositorio",
    },
    privacy: {
      sections: [
        section("Tu privacidad importa", "Nos tomamos la privacidad en serio e intentamos minimizar la recopilación innecesaria de datos."),
        section("Procesamiento de datos", "La mayoría de las herramientas procesa archivos localmente en tu navegador. Algunas conversiones avanzadas pueden requerir procesamiento temporal del lado del servidor.", [
          "Los archivos suelen permanecer en tu dispositivo durante el proceso.",
          "Las tareas temporales del servidor se eliminan tras completarse.",
          "No almacenamos intencionadamente el contenido de tus documentos.",
        ]),
        section("Información que recopilamos", undefined, [
          "Analítica anónima solo después del consentimiento.",
          "No es necesario crear una cuenta para usar las herramientas principales.",
          "No hay almacenamiento permanente para los archivos subidos.",
        ]),
        section("Cookies", undefined, [
          "Almacenamiento de la preferencia de consentimiento.",
          "Seguridad y funcionalidad esencial del sitio.",
          "Analítica opcional tras autorización explícita.",
        ]),
        section("Tus derechos", "Puedes rechazar la analítica, borrar el almacenamiento local del navegador y dejar de usar el servicio en cualquier momento."),
      ],
    },
    terms: {
      sections: [
        section("1. Aceptación de las condiciones", "Al usar Dogufy, aceptas estas condiciones."),
        section("2. Uso del servicio", "El servicio se ofrece para necesidades de productividad personales y comerciales.", [
          "Usa el servicio de forma legal.",
          "No sobrecargues, explotes ni abuses de la plataforma.",
          "No utilices las herramientas con fines dañinos o maliciosos.",
        ]),
        section("3. Disponibilidad del servicio", "Buscamos fiabilidad, pero no podemos garantizar acceso ininterrumpido ni funcionamiento sin errores."),
        section("4. Limitación de responsabilidad", "El uso del servicio es bajo tu propio riesgo, incluida la comprobación de calidad del archivo y la idoneidad del flujo."),
        section("5. Responsabilidades del usuario", "Sigues siendo responsable de tus archivos y de tu derecho a procesarlos.", [
          "Conserva copias de seguridad de los originales importantes.",
          "Verifica la calidad del resultado antes de usos críticos.",
          "Respeta los derechos de autor y otras obligaciones legales.",
        ]),
        section("6. Contacto", "Si tienes preguntas sobre estas condiciones, ponte en contacto con nosotros a través del sitio web."),
      ],
    },
    blog: {
      description: "Lee nuestros últimos artículos sobre herramientas PDF, procesamiento de imágenes y productividad.",
      intro: "Explora artículos prácticos sobre documentos, imágenes y flujos de trabajo digitales.",
      noTools: "No se encontraron resultados.",
      clear: "Limpiar búsqueda",
    },
    toolsPage: {
      description: "Consulta nuestra colección completa de herramientas online gratuitas y encuentra exactamente lo que necesitas.",
      intro: "Este centro ayuda tanto a usuarios como a buscadores a comprender toda la biblioteca de herramientas de Dogufy y llegar rápido a la página adecuada.",
      searchPlaceholder: "Buscar una herramienta (por ejemplo: merge, image, pdf)...",
      noResultsTitle: "No se encontraron herramientas",
      noResultsBody: "No encontramos herramientas que coincidan con tu búsqueda. Prueba otra palabra clave o categoría.",
      didYouKnow: "¿Sabías que...?",
      didYouKnowBody: "Muchos flujos se ejecutan directamente en el navegador, lo que ayuda a mantener el manejo de documentos más rápido y privado.",
      whatMakesUseful: "¿Qué hace útil esta herramienta?",
      howToOnline: "Cómo usar esta herramienta en línea",
      uploadOrEnter: "Sube o introduce datos",
      configure: "Configura los ajustes",
      processDownload: "Procesa y descarga",
      bestUseCases: "Mejores casos de uso",
      whyChoose: "¿Por qué elegir Dogufy para esta herramienta?",
      fastFree: "Rápido y gratis",
      fastFreeBody: "Usa el flujo rápidamente sin barreras de registro.",
      securePrivate: "Seguro y privado",
      securePrivateBody: "La experiencia está diseñada para reducir la exposición innecesaria de archivos del usuario.",
      highQuality: "Alta calidad",
      highQualityBody: "Buscamos mantener una calidad de salida útil mientras simplificamos el proceso.",
      relatedCategory: "Herramientas relacionadas",
      removeFile: "Eliminar archivo",
      convertedImages: "Imágenes convertidas",
      downloadAll: "Descargar todo",
      downloadPage: "Descargar página",
      pageLabel: "Página",
      convertingPdf: "Convirtiendo PDF...",
      convertingPdfToImages: "Convirtiendo PDF a imágenes...",
      complete: "completo",
      completed: "completado",
      convertToPng: "Convertir a PNG",
      convertToPngDescription: "Convierte páginas PDF en imágenes PNG de alta calidad con soporte de transparencia.",
      convertToJpg: "Convertir a JPG",
      convertToJpgDescription: "Convierte páginas PDF en imágenes JPG de alta calidad.",
      invalidPdfFile: "Selecciona un archivo PDF.",
      pdfToPngError: "Error al convertir PDF a PNG",
      pdfConversionError: "Error al convertir el PDF. Inténtalo de nuevo.",
      convertToWord: "Convertir a Word",
      convertToWordDescription: "Convierte tus archivos PDF en documentos Word editables (DOCX).",
      convertToWordButton: "Convertir a Word (.docx)",
      convertingToWord: "Convirtiendo a Word...",
      pdfToWordError: "Error al convertir PDF a Word. Inténtalo de nuevo.",
      convertToPdf: "Convertir a PDF",
      convertingToPdf: "Convirtiendo a PDF...",
      wordToPdfError: "Error al convertir Word a PDF. Inténtalo de nuevo.",
      mergePdfTitle: "Unir archivos PDF",
      mergePdfDescription: "Combina varios archivos PDF en un solo documento. Arrastra y suelta para reordenar.",
      mergePdfHint: "Selecciona 2 o más archivos PDF para unir",
      filesToMerge: "Archivos para unir",
      clearAll: "Borrar todo",
      moveUp: "Mover arriba",
      moveDown: "Mover abajo",
      merging: "Uniendo...",
      mergePdfs: "Unir PDFs",
      mergePdfError: "Error al unir PDFs. Asegúrate de que todos los archivos sean PDF válidos.",
    },
  },
  fr: {
    landing: {
      toolsDescription: "Explorez nos outils en ligne gratuits les plus utilisés. Sécurisés, rapides et simples à utiliser.",
      useCasesTitle: "Cas d’usage",
      useCasesDescription: "Découvrez comment Dogufy aide différents profils à atteindre leurs objectifs plus vite.",
      useCases: [
        item("Pour les étudiants et le monde académique", "Fusionnez des devoirs, compressez des mémoires et convertissez des documents de recherche en formats modifiables."),
        item("Pour les professionnels", "Signez des contrats, fusionnez des rapports et transformez des feuilles de calcul en PDF partageables."),
        item("Pour les designers et créatifs", "Optimisez les images, supprimez les arrière-plans et convertissez vos assets plus rapidement."),
        item("Pour les équipes juridiques", "Gérez des documents sensibles avec des workflows plus privés et une organisation plus claire."),
        item("Pour les agents immobiliers", "Préparez brochures, dossiers de biens et supports d’annonces plus efficacement."),
      ],
      useCasesCta: "Essayer les outils",
      processDescription: "Simple, rapide et sécurisé. Préparez vos documents en 4 étapes faciles.",
      processSteps: [
        step("01", "Choisissez votre outil", "Sélectionnez le bon workflow dans notre collection d’outils PDF, image et texte."),
        step("02", "Téléversez vos fichiers", "Déposez votre fichier dans le navigateur et ajustez les options disponibles."),
        step("03", "Traitez en quelques secondes", "Lancez la tâche immédiatement sans installer de logiciel supplémentaire."),
        step("04", "Téléchargez et partagez", "Obtenez le résultat tout de suite et poursuivez votre travail."),
      ],
      featuresDescription: "Nous proposons des outils gratuits conçus pour la vitesse, la confidentialité et des workflows concrets.",
      features: [
        item("Gratuit pour toujours", "Utilisez les outils sans abonnement, frais cachés ni mur payant."),
        item("Sécurisé et privé", "Des workflows pensés pour la confidentialité aident à garder les fichiers sensibles sous contrôle."),
        item("Ultra rapide", "Les workflows dans le navigateur réduisent le temps passé sur les tâches répétitives."),
        item("Facile à utiliser", "L’interface est pensée pour rester accessible même aux non-techniciens."),
        item("Compatible mobile", "L’expérience fonctionne sur ordinateur, tablette et mobile."),
        item("Haute qualité", "Nous cherchons à préserver une qualité de sortie utile tout en simplifiant le processus."),
      ],
      testimonialsDescription: "Découvrez ce que les utilisateurs disent de Dogufy.",
      testimonials: [
        quote("Dogufy m’a aidée à fusionner les chapitres de mon mémoire rapidement et sans complexité inutile.", "Sarah J.", "Étudiante en master"),
        quote("J’utilise régulièrement les outils image pour le web parce qu’ils sont rapides et pratiques.", "Mike T.", "Développeur frontend"),
        quote("Les outils de conversion de documents me font gagner du temps pour préparer des versions modifiables.", "Emily R.", "Assistante juridique"),
      ],
      landingContactDescription: "Contactez-nous si vous souhaitez parler du produit, proposer des améliorations ou poser une question.",
      sayHi: "Dire bonjour",
      getQuote: "Demander un devis",
      name: "Nom",
      email: "E-mail",
      message: "Message",
      send: "Envoyer le message",
    },
    about: {
      intro: "Bienvenue sur Dogufy, votre solution tout-en-un pour les documents, les images et le texte.",
      missionBody: "Nous pensons que des outils de productivité puissants doivent être accessibles à tous. Notre mission est de fournir des outils en ligne gratuits et de qualité qui aident à travailler plus vite sans logiciel coûteux ni configuration complexe.",
      offers: [
        "Des outils PDF pour convertir, fusionner, scinder, compresser et modifier des documents.",
        "Des outils image pour redimensionner, compresser, convertir et nettoyer les assets visuels.",
        "Des outils texte pour formater, convertir et analyser le contenu.",
        "Des utilitaires développeur comme générateur QR, UUID et autres aides rapides.",
      ],
      privacyTitle: "La confidentialité d’abord",
      privacyBody: "La plupart des traitements de fichiers se font directement dans le navigateur. Vos fichiers restent sous votre contrôle, ce qui aide à garder le workflow rapide, privé et sécurisé.",
      freeTitle: "100 % gratuit",
      freeBody: "Nos outils sont disponibles sans abonnement, frais cachés ni obligation d’inscription.",
    },
    contact: {
      sentTitle: "Message envoyé !",
      sentBody: "Merci de nous avoir contactés. Nous vous répondrons rapidement.",
      labels: { name: "Nom", email: "E-mail", subject: "Sujet", message: "Message" },
      placeholders: {
        name: "Votre nom",
        email: "votre.email@exemple.com",
        subject: "Quel est le sujet ?",
        message: "Dites-nous en plus...",
      },
      github: "GitHub",
      githubBody: "Vous avez trouvé un bug ou voulez contribuer ? Consultez le dépôt.",
      viewRepo: "Voir le dépôt",
    },
    privacy: {
      sections: [
        section("Votre confidentialité compte", "Nous prenons la confidentialité au sérieux et cherchons à minimiser la collecte de données inutile."),
        section("Traitement des données", "La plupart des outils traitent les fichiers localement dans votre navigateur. Certaines conversions avancées peuvent nécessiter un traitement temporaire côté serveur.", [
          "Les fichiers restent généralement sur votre appareil pendant le traitement.",
          "Les tâches temporaires côté serveur sont supprimées après exécution.",
          "Nous ne stockons pas volontairement le contenu de vos documents.",
        ]),
        section("Informations que nous collectons", undefined, [
          "Analyse anonyme uniquement après consentement.",
          "Aucun compte n’est requis pour les outils principaux.",
          "Aucun stockage permanent des fichiers téléversés.",
        ]),
        section("Cookies", undefined, [
          "Stockage des préférences de consentement.",
          "Sécurité et fonctionnalités essentielles du site.",
          "Analyse optionnelle après accord explicite.",
        ]),
        section("Vos droits", "Vous pouvez refuser l’analyse, effacer le stockage local du navigateur et arrêter d’utiliser le service à tout moment."),
      ],
    },
    terms: {
      sections: [
        section("1. Acceptation des conditions", "En utilisant Dogufy, vous acceptez ces conditions."),
        section("2. Utilisation du service", "Le service est fourni pour des besoins de productivité personnels et professionnels.", [
          "Utilisez le service légalement.",
          "Ne surchargez pas, n’exploitez pas et n’abusez pas de la plateforme.",
          "N’utilisez pas les outils à des fins nuisibles ou malveillantes.",
        ]),
        section("3. Disponibilité du service", "Nous visons la fiabilité, mais nous ne pouvons pas garantir un accès ininterrompu ni un fonctionnement sans erreur."),
        section("4. Limitation de responsabilité", "L’utilisation du service se fait à vos propres risques, y compris la vérification de la qualité des fichiers générés et la pertinence du workflow."),
        section("5. Responsabilités de l’utilisateur", "Vous restez responsable de vos fichiers et de votre droit à les traiter.", [
          "Conservez des sauvegardes des originaux importants.",
          "Vérifiez la qualité du résultat avant un usage critique.",
          "Respectez le droit d’auteur et les autres obligations légales.",
        ]),
        section("6. Contact", "Si vous avez des questions sur ces conditions, contactez-nous via le site web."),
      ],
    },
    blog: {
      description: "Lisez nos derniers articles sur les outils PDF, le traitement d’images et la productivité.",
      intro: "Explorez des articles pratiques sur les documents, les images et les workflows numériques.",
      noTools: "Aucun résultat trouvé.",
      clear: "Effacer la recherche",
    },
    toolsPage: {
      description: "Parcourez notre collection complète d’outils en ligne gratuits et trouvez exactement ce qu’il vous faut.",
      intro: "Cette page centrale aide les visiteurs et les moteurs de recherche à comprendre toute la bibliothèque d’outils de Dogufy et à trouver la bonne page rapidement.",
      searchPlaceholder: "Rechercher un outil (ex. : merge, image, pdf)...",
      noResultsTitle: "Aucun outil trouvé",
      noResultsBody: "Nous n’avons trouvé aucun outil correspondant à votre recherche. Essayez un autre mot-clé ou une autre catégorie.",
      didYouKnow: "Le saviez-vous ?",
      didYouKnowBody: "De nombreux workflows se déroulent directement dans le navigateur, ce qui aide à garder le traitement des documents plus rapide et plus privé.",
      whatMakesUseful: "Qu’est-ce qui rend cet outil utile ?",
      howToOnline: "Comment utiliser cet outil en ligne",
      uploadOrEnter: "Téléverser ou saisir des données",
      configure: "Configurer les réglages",
      processDownload: "Traiter et télécharger",
      bestUseCases: "Meilleurs cas d’usage",
      whyChoose: "Pourquoi choisir Dogufy pour cet outil ?",
      fastFree: "Rapide et gratuit",
      fastFreeBody: "Utilisez le workflow rapidement sans barrière d’inscription.",
      securePrivate: "Sécurisé et privé",
      securePrivateBody: "L’expérience est pensée pour réduire l’exposition inutile des fichiers utilisateur.",
      highQuality: "Haute qualité",
      highQualityBody: "Nous cherchons à préserver une qualité de sortie utile tout en simplifiant le processus.",
      relatedCategory: "Outils associés",
      removeFile: "Retirer le fichier",
      convertedImages: "Images converties",
      downloadAll: "Tout télécharger",
      downloadPage: "Télécharger la page",
      pageLabel: "Page",
      convertingPdf: "Conversion du PDF...",
      convertingPdfToImages: "Conversion du PDF en images...",
      complete: "terminé",
      completed: "terminé",
      convertToPng: "Convertir en PNG",
      convertToPngDescription: "Convertissez les pages PDF en images PNG de haute qualité avec prise en charge de la transparence.",
      convertToJpg: "Convertir en JPG",
      convertToJpgDescription: "Convertissez les pages PDF en images JPG de haute qualité.",
      invalidPdfFile: "Veuillez sélectionner un fichier PDF.",
      pdfToPngError: "Erreur lors de la conversion du PDF en PNG",
      pdfConversionError: "Erreur lors de la conversion du PDF. Veuillez réessayer.",
      convertToWord: "Convertir en Word",
      convertToWordDescription: "Convertissez vos fichiers PDF en documents Word modifiables (DOCX).",
      convertToWordButton: "Convertir en Word (.docx)",
      convertingToWord: "Conversion en Word...",
      pdfToWordError: "Erreur lors de la conversion du PDF en Word. Veuillez réessayer.",
      convertToPdf: "Convertir en PDF",
      convertingToPdf: "Conversion en PDF...",
      wordToPdfError: "Erreur lors de la conversion de Word en PDF. Veuillez réessayer.",
      mergePdfTitle: "Fusionner des fichiers PDF",
      mergePdfDescription: "Combinez plusieurs fichiers PDF dans un seul document. Glissez-déposez pour réorganiser les fichiers.",
      mergePdfHint: "Sélectionnez 2 fichiers PDF ou plus à fusionner",
      filesToMerge: "Fichiers à fusionner",
      clearAll: "Tout effacer",
      moveUp: "Déplacer vers le haut",
      moveDown: "Déplacer vers le bas",
      merging: "Fusion en cours...",
      mergePdfs: "Fusionner les PDF",
      mergePdfError: "Erreur lors de la fusion des PDF. Assurez-vous que tous les fichiers sont des PDF valides.",
    },
  },
  de: {
    landing: {
      toolsDescription: "Entdecke unsere meistgenutzten kostenlosen Online-Tools. Sicher, schnell und einfach zu verwenden.",
      useCasesTitle: "Einsatzbereiche",
      useCasesDescription: "Erfahre, wie Dogufy unterschiedlichen Nutzergruppen hilft, ihre Aufgaben schneller zu erledigen.",
      useCases: [
        item("Für Studierende und Forschung", "Führe Abgaben zusammen, komprimiere Thesis-Dateien und konvertiere Forschungsdokumente in bearbeitbare Formate."),
        item("Für Business-Profis", "Unterschreibe Verträge, kombiniere Berichte und wandle Tabellen in teilbare PDF-Dateien um."),
        item("Für Designer und Kreative", "Optimiere Bilder, entferne Hintergründe und konvertiere Assets schneller."),
        item("Für Rechtsteams", "Bearbeite sensible Dokumente mit datenschutzfreundlicheren Workflows und besserer Dokumentenorganisation."),
        item("Für Immobilienmakler", "Bereite Broschüren, Objektunterlagen und Listing-Assets effizienter vor."),
      ],
      useCasesCta: "Tools ausprobieren",
      processDescription: "Einfach, schnell und sicher. Bereite deine Dokumente in 4 leichten Schritten vor.",
      processSteps: [
        step("01", "Tool auswählen", "Wähle den passenden Workflow aus unserer Sammlung von PDF-, Bild- und Texttools."),
        step("02", "Dateien hochladen", "Ziehe deine Datei direkt in den Browser und passe verfügbare Optionen an."),
        step("03", "In Sekunden verarbeiten", "Starte die Aufgabe sofort, ohne zusätzliche Software zu installieren."),
        step("04", "Herunterladen und teilen", "Erhalte das Ergebnis direkt und arbeite ohne Unterbrechung weiter."),
      ],
      featuresDescription: "Wir bieten kostenlose Online-Tools, die auf Geschwindigkeit, Datenschutz und praktische Workflows ausgelegt sind.",
      features: [
        item("Für immer kostenlos", "Nutze die Tools ohne Abo, versteckte Gebühren oder Paywall."),
        item("Sicher und privat", "Datenschutzbewusste Workflows helfen, sensible Dateien besser unter Kontrolle zu halten."),
        item("Blitzschnell", "Browserbasierte Workflows sparen Zeit bei wiederkehrenden Aufgaben."),
        item("Einfach zu bedienen", "Die Oberfläche ist auch für nicht technische Nutzer leicht zugänglich."),
        item("Mobilfreundlich", "Das Erlebnis funktioniert auf Desktop, Tablet und Smartphone."),
        item("Hohe Qualität", "Wir möchten eine nützliche Ausgabequalität erhalten und den Prozess trotzdem einfach halten."),
      ],
      testimonialsDescription: "Das sagen Nutzer über Dogufy.",
      testimonials: [
        quote("Dogufy hat mir geholfen, Thesis-Kapitel schnell und ohne unnötige Komplexität zusammenzuführen.", "Sarah J.", "Masterstudentin"),
        quote("Ich nutze die Bildtools regelmäßig für Webarbeit, weil sie schnell und praktisch sind.", "Mike T.", "Frontend-Entwickler"),
        quote("Die Dokumentkonvertierung spart Zeit, wenn ich bearbeitbare Versionen vorbereiten muss.", "Emily R.", "Rechtsassistenz"),
      ],
      landingContactDescription: "Sprich mit uns, wenn du Fragen hast, Verbesserungen vorschlagen oder über das Produkt sprechen möchtest.",
      sayHi: "Hallo sagen",
      getQuote: "Angebot anfragen",
      name: "Name",
      email: "E-Mail",
      message: "Nachricht",
      send: "Nachricht senden",
    },
    about: {
      intro: "Willkommen bei Dogufy, deiner zentralen Lösung für Dokument-, Bild- und Textverarbeitung.",
      missionBody: "Wir glauben, dass leistungsstarke Produktivitätswerkzeuge für alle zugänglich sein sollten. Unsere Mission ist es, kostenlose hochwertige Online-Tools bereitzustellen, mit denen Menschen ohne teure Software und komplizierte Einrichtung schneller arbeiten können.",
      offers: [
        "PDF-Tools zum Konvertieren, Zusammenführen, Teilen, Komprimieren und Bearbeiten von Dokumenten.",
        "Bildtools zum Ändern der Größe, Komprimieren, Konvertieren und Bereinigen visueller Assets.",
        "Texttools zum Formatieren, Umwandeln und Analysieren von Inhalten.",
        "Entwickler-Helfer wie QR-Generator, UUID-Generator und weitere Schnelltools.",
      ],
      privacyTitle: "Datenschutz zuerst",
      privacyBody: "Die meisten Dateiverarbeitungen finden direkt im Browser statt. Deine Dateien bleiben unter deiner Kontrolle, was den Workflow schneller, privater und sicherer macht.",
      freeTitle: "100 % kostenlos",
      freeBody: "Unsere Tools sind ohne Abonnement, versteckte Gebühren oder Registrierungshürden verfügbar.",
    },
    contact: {
      sentTitle: "Nachricht gesendet!",
      sentBody: "Danke für deine Nachricht. Wir melden uns so schnell wie möglich.",
      labels: { name: "Name", email: "E-Mail", subject: "Betreff", message: "Nachricht" },
      placeholders: {
        name: "Dein Name",
        email: "deine.email@beispiel.de",
        subject: "Worum geht es?",
        message: "Erzähl uns mehr...",
      },
      github: "GitHub",
      githubBody: "Fehler gefunden oder möchtest du beitragen? Schau dir das Repository an.",
      viewRepo: "Repository ansehen",
    },
    privacy: {
      sections: [
        section("Deine Privatsphäre ist wichtig", "Wir nehmen Datenschutz ernst und versuchen, unnötige Datenerfassung zu minimieren."),
        section("Datenverarbeitung", "Die meisten Tools verarbeiten Dateien lokal im Browser. Einige fortgeschrittene Konvertierungen können eine temporäre serverseitige Verarbeitung benötigen.", [
          "Dateien bleiben während der Verarbeitung normalerweise auf deinem Gerät.",
          "Temporäre Serverjobs werden nach Abschluss gelöscht.",
          "Wir speichern den Inhalt deiner Dokumente nicht absichtlich.",
        ]),
        section("Welche Informationen wir erfassen", undefined, [
          "Anonyme Analytik nur nach Zustimmung.",
          "Für die Kern-Tools ist kein Konto erforderlich.",
          "Keine dauerhafte Speicherung hochgeladener Dateien.",
        ]),
        section("Cookies", undefined, [
          "Speicherung der Einwilligungspräferenz.",
          "Sicherheit und wesentliche Website-Funktionen.",
          "Optionale Analytik nach ausdrücklicher Zustimmung.",
        ]),
        section("Deine Rechte", "Du kannst Analytik ablehnen, lokalen Browser-Speicher löschen und die Nutzung des Dienstes jederzeit beenden."),
      ],
    },
    terms: {
      sections: [
        section("1. Annahme der Bedingungen", "Durch die Nutzung von Dogufy stimmst du diesen Bedingungen zu."),
        section("2. Nutzung des Dienstes", "Der Dienst wird für persönliche und geschäftliche Produktivitätszwecke bereitgestellt.", [
          "Nutze den Dienst rechtmäßig.",
          "Überlaste, missbrauche oder exploitiere die Plattform nicht.",
          "Verwende die Tools nicht für schädliche oder böswillige Zwecke.",
        ]),
        section("3. Verfügbarkeit des Dienstes", "Wir streben Zuverlässigkeit an, können aber keinen unterbrechungsfreien oder fehlerfreien Zugriff garantieren."),
        section("4. Haftungsbeschränkung", "Die Nutzung des Dienstes erfolgt auf eigenes Risiko, einschließlich der Prüfung von Ergebnisqualität und Workflow-Eignung."),
        section("5. Verantwortlichkeiten des Nutzers", "Du bleibst für deine Dateien und dein Recht, sie zu verarbeiten, verantwortlich.", [
          "Bewahre Backups wichtiger Originale auf.",
          "Prüfe die Ausgabequalität vor kritischer Nutzung.",
          "Beachte Urheberrechte und andere rechtliche Pflichten.",
        ]),
        section("6. Kontakt", "Wenn du Fragen zu diesen Bedingungen hast, kontaktiere uns bitte über die Website."),
      ],
    },
    blog: {
      description: "Lies unsere neuesten Artikel über PDF-Tools, Bildverarbeitung und Produktivität.",
      intro: "Entdecke praxisnahe Artikel über Dokumente, Bilder und digitale Workflows.",
      noTools: "Keine Ergebnisse gefunden.",
      clear: "Suche löschen",
    },
    toolsPage: {
      description: "Durchsuche unsere vollständige Sammlung kostenloser Online-Tools und finde genau den Workflow, den du brauchst.",
      intro: "Diese Übersichtsseite hilft Nutzern und Suchmaschinen, die gesamte Tool-Bibliothek von Dogufy zu verstehen und schnell zur passenden Seite zu gelangen.",
      searchPlaceholder: "Nach einem Tool suchen (z. B. merge, image, pdf)...",
      noResultsTitle: "Keine Tools gefunden",
      noResultsBody: "Wir konnten keine passenden Tools zu deiner Suche finden. Versuche ein anderes Stichwort oder eine andere Kategorie.",
      didYouKnow: "Schon gewusst?",
      didYouKnowBody: "Viele Workflows laufen direkt im Browser ab, was die Dokumentverarbeitung schneller und privater macht.",
      whatMakesUseful: "Was macht dieses Tool nützlich?",
      howToOnline: "So nutzt du dieses Tool online",
      uploadOrEnter: "Datei hochladen oder Daten eingeben",
      configure: "Einstellungen anpassen",
      processDownload: "Verarbeiten und herunterladen",
      bestUseCases: "Beste Einsatzfälle",
      whyChoose: "Warum Dogufy für dieses Tool wählen?",
      fastFree: "Schnell und kostenlos",
      fastFreeBody: "Nutze den Workflow schnell und ohne Registrierungshürden.",
      securePrivate: "Sicher und privat",
      securePrivateBody: "Das Erlebnis ist darauf ausgelegt, unnötige Offenlegung von Nutzerdateien zu reduzieren.",
      highQuality: "Hohe Qualität",
      highQualityBody: "Wir wollen eine nützliche Ausgabequalität erhalten und gleichzeitig den Ablauf vereinfachen.",
      relatedCategory: "Ähnliche Tools",
      removeFile: "Datei entfernen",
      convertedImages: "Konvertierte Bilder",
      downloadAll: "Alle herunterladen",
      downloadPage: "Seite herunterladen",
      pageLabel: "Seite",
      convertingPdf: "PDF wird konvertiert...",
      convertingPdfToImages: "PDF wird in Bilder konvertiert...",
      complete: "fertig",
      completed: "abgeschlossen",
      convertToPng: "In PNG konvertieren",
      convertToPngDescription: "Wandle PDF-Seiten in hochwertige PNG-Bilder mit Transparenzunterstützung um.",
      convertToJpg: "In JPG konvertieren",
      convertToJpgDescription: "Wandle PDF-Seiten in hochwertige JPG-Bilder um.",
      invalidPdfFile: "Bitte wähle eine PDF-Datei aus.",
      pdfToPngError: "Fehler beim Konvertieren von PDF zu PNG",
      pdfConversionError: "Fehler beim Konvertieren des PDFs. Bitte versuche es erneut.",
      convertToWord: "In Word konvertieren",
      convertToWordDescription: "Wandle deine PDF-Dateien in bearbeitbare Word-Dokumente (DOCX) um.",
      convertToWordButton: "In Word konvertieren (.docx)",
      convertingToWord: "Wird in Word konvertiert...",
      pdfToWordError: "Fehler beim Konvertieren von PDF in Word. Bitte versuche es erneut.",
      convertToPdf: "In PDF konvertieren",
      convertingToPdf: "Wird in PDF konvertiert...",
      wordToPdfError: "Fehler beim Konvertieren von Word in PDF. Bitte versuche es erneut.",
      mergePdfTitle: "PDF-Dateien zusammenführen",
      mergePdfDescription: "Kombiniere mehrere PDF-Dateien zu einem Dokument. Ziehe Dateien per Drag-and-drop in die gewünschte Reihenfolge.",
      mergePdfHint: "Wähle 2 oder mehr PDF-Dateien zum Zusammenführen",
      filesToMerge: "Zu kombinierende Dateien",
      clearAll: "Alles löschen",
      moveUp: "Nach oben verschieben",
      moveDown: "Nach unten verschieben",
      merging: "Wird zusammengeführt...",
      mergePdfs: "PDFs zusammenführen",
      mergePdfError: "Fehler beim Zusammenführen der PDFs. Bitte stelle sicher, dass alle Dateien gültige PDFs sind.",
    },
  },
  it: {
    landing: {
      toolsDescription: "Esplora i nostri strumenti online gratuiti più usati. Sicuri, veloci e facili da utilizzare.",
      useCasesTitle: "Casi d’uso",
      useCasesDescription: "Scopri come Dogufy aiuta diversi professionisti a lavorare meglio e più velocemente.",
      useCases: [
        item("Per studenti e mondo accademico", "Unisci compiti, comprimi tesi e converti documenti di ricerca in formati modificabili."),
        item("Per professionisti business", "Firma contratti, unisci report e converti fogli di calcolo in PDF facili da condividere."),
        item("Per designer e creativi", "Ottimizza immagini, rimuovi sfondi e converti asset più rapidamente."),
        item("Per team legali", "Gestisci documenti sensibili con workflow più privati e una struttura documentale più ordinata."),
        item("Per agenti immobiliari", "Prepara brochure, file immobiliari e materiali per annunci in modo più efficiente."),
      ],
      useCasesCta: "Prova gli strumenti",
      processDescription: "Semplice, veloce e sicuro. Prepara i tuoi documenti in 4 passaggi.",
      processSteps: [
        step("01", "Scegli lo strumento", "Seleziona il workflow giusto dalla nostra raccolta di strumenti PDF, immagine e testo."),
        step("02", "Carica i file", "Trascina il file nel browser e imposta le opzioni disponibili."),
        step("03", "Elabora in pochi secondi", "Esegui l’attività subito senza installare software aggiuntivo."),
        step("04", "Scarica e condividi", "Ottieni subito il risultato e continua il tuo lavoro."),
      ],
      featuresDescription: "Offriamo strumenti gratuiti pensati per velocità, privacy e flussi di lavoro pratici.",
      features: [
        item("Gratis per sempre", "Usa gli strumenti senza abbonamenti, costi nascosti o paywall."),
        item("Sicuro e privato", "Workflow attenti alla privacy aiutano a tenere sotto controllo i file sensibili."),
        item("Molto veloce", "I workflow nel browser riducono il tempo speso nelle attività ripetitive."),
        item("Facile da usare", "L’interfaccia è pensata per essere semplice anche per chi non è tecnico."),
        item("Ottimo su mobile", "L’esperienza funziona su desktop, tablet e smartphone."),
        item("Alta qualità", "Puntiamo a mantenere una qualità di output utile semplificando il processo."),
      ],
      testimonialsDescription: "Scopri cosa dicono gli utenti di Dogufy.",
      testimonials: [
        quote("Dogufy mi ha aiutata a unire rapidamente i capitoli della tesi senza inutili complicazioni.", "Sarah J.", "Studentessa magistrale"),
        quote("Uso spesso gli strumenti immagine per il lavoro web perché sono rapidi e pratici.", "Mike T.", "Sviluppatore frontend"),
        quote("Gli strumenti di conversione documenti fanno risparmiare tempo quando preparo versioni modificabili.", "Emily R.", "Assistente legale"),
      ],
      landingContactDescription: "Contattaci se vuoi parlare del prodotto, suggerire miglioramenti o fare una domanda.",
      sayHi: "Di’ ciao",
      getQuote: "Richiedi un preventivo",
      name: "Nome",
      email: "Email",
      message: "Messaggio",
      send: "Invia messaggio",
    },
    about: {
      intro: "Benvenuto su Dogufy, la tua soluzione completa per documenti, immagini e testo.",
      missionBody: "Crediamo che strumenti di produttività potenti debbano essere accessibili a tutti. La nostra missione è offrire strumenti online gratuiti e di alta qualità che aiutino a lavorare più velocemente senza software costosi o configurazioni complicate.",
      offers: [
        "Strumenti PDF per convertire, unire, dividere, comprimere e modificare documenti.",
        "Strumenti immagine per ridimensionare, comprimere, convertire e pulire asset visivi.",
        "Strumenti testo per formattare, convertire e analizzare contenuti.",
        "Utility per sviluppatori come generatori QR, UUID e altri helper rapidi.",
      ],
      privacyTitle: "Privacy al primo posto",
      privacyBody: "La maggior parte dell’elaborazione avviene direttamente nel browser. I tuoi file restano sotto il tuo controllo per mantenere il workflow rapido, privato e sicuro.",
      freeTitle: "100% gratuito",
      freeBody: "I nostri strumenti sono disponibili senza abbonamenti, costi nascosti o barriere di registrazione.",
    },
    contact: {
      sentTitle: "Messaggio inviato!",
      sentBody: "Grazie per averci contattato. Ti risponderemo al più presto.",
      labels: { name: "Nome", email: "Email", subject: "Oggetto", message: "Messaggio" },
      placeholders: {
        name: "Il tuo nome",
        email: "tuo.email@esempio.it",
        subject: "Di cosa si tratta?",
        message: "Raccontaci di più...",
      },
      github: "GitHub",
      githubBody: "Hai trovato un bug o vuoi contribuire? Dai un’occhiata al repository.",
      viewRepo: "Vedi repository",
    },
    privacy: {
      sections: [
        section("La tua privacy conta", "Prendiamo la privacy sul serio e cerchiamo di ridurre al minimo la raccolta di dati non necessaria."),
        section("Trattamento dei dati", "La maggior parte degli strumenti elabora i file localmente nel browser. Alcune conversioni avanzate possono richiedere un’elaborazione temporanea lato server.", [
          "I file di solito restano sul tuo dispositivo durante l’elaborazione.",
          "I job temporanei lato server vengono eliminati una volta completati.",
          "Non memorizziamo intenzionalmente il contenuto dei documenti.",
        ]),
        section("Informazioni che raccogliamo", undefined, [
          "Analisi anonima solo dopo il consenso.",
          "Nessun account richiesto per gli strumenti principali.",
          "Nessuna archiviazione permanente dei file caricati.",
        ]),
        section("Cookie", undefined, [
          "Memorizzazione della preferenza di consenso.",
          "Sicurezza e funzionalità essenziali del sito.",
          "Analisi opzionale dopo autorizzazione esplicita.",
        ]),
        section("I tuoi diritti", "Puoi rifiutare l’analisi, cancellare i dati locali del browser e interrompere l’uso del servizio in qualsiasi momento."),
      ],
    },
    terms: {
      sections: [
        section("1. Accettazione dei termini", "Usando Dogufy accetti questi termini."),
        section("2. Uso del servizio", "Il servizio è fornito per esigenze di produttività personali e commerciali.", [
          "Usa il servizio in modo legale.",
          "Non sovraccaricare, sfruttare o abusare della piattaforma.",
          "Non usare gli strumenti per scopi dannosi o malevoli.",
        ]),
        section("3. Disponibilità del servizio", "Puntiamo all’affidabilità, ma non possiamo garantire accesso continuo o funzionamento privo di errori."),
        section("4. Limitazione di responsabilità", "L’uso del servizio è a tuo rischio, inclusa la verifica della qualità dei file e dell’idoneità del workflow."),
        section("5. Responsabilità dell’utente", "Rimani responsabile dei tuoi file e del tuo diritto a elaborarli.", [
          "Conserva copie di backup degli originali importanti.",
          "Verifica la qualità dell’output prima di usi critici.",
          "Rispetta copyright e altri obblighi legali.",
        ]),
        section("6. Contatto", "Se hai domande su questi termini, contattaci tramite il sito."),
      ],
    },
    blog: {
      description: "Leggi i nostri ultimi articoli su strumenti PDF, elaborazione immagini e produttività.",
      intro: "Esplora articoli pratici su documenti, immagini e workflow digitali.",
      noTools: "Nessun risultato trovato.",
      clear: "Cancella ricerca",
    },
    toolsPage: {
      description: "Sfoglia la nostra raccolta completa di strumenti online gratuiti e trova esattamente quello che ti serve.",
      intro: "Questa pagina hub aiuta utenti e motori di ricerca a comprendere l’intera libreria di strumenti Dogufy e a raggiungere rapidamente la pagina giusta.",
      searchPlaceholder: "Cerca uno strumento (es. merge, image, pdf)...",
      noResultsTitle: "Nessuno strumento trovato",
      noResultsBody: "Non abbiamo trovato strumenti corrispondenti alla tua ricerca. Prova un’altra parola chiave o categoria.",
      didYouKnow: "Lo sapevi?",
      didYouKnowBody: "Molti workflow avvengono direttamente nel browser, aiutando a mantenere la gestione dei documenti più veloce e privata.",
      whatMakesUseful: "Cosa rende utile questo strumento?",
      howToOnline: "Come usare questo strumento online",
      uploadOrEnter: "Carica o inserisci dati",
      configure: "Configura le impostazioni",
      processDownload: "Elabora e scarica",
      bestUseCases: "Migliori casi d’uso",
      whyChoose: "Perché scegliere Dogufy per questo strumento?",
      fastFree: "Veloce e gratuito",
      fastFreeBody: "Usa il workflow rapidamente senza barriere di registrazione.",
      securePrivate: "Sicuro e privato",
      securePrivateBody: "L’esperienza è progettata per ridurre l’esposizione non necessaria dei file utente.",
      highQuality: "Alta qualità",
      highQualityBody: "Puntiamo a mantenere una qualità di output utile semplificando il processo.",
      relatedCategory: "Strumenti correlati",
      removeFile: "Rimuovi file",
      convertedImages: "Immagini convertite",
      downloadAll: "Scarica tutto",
      downloadPage: "Scarica pagina",
      pageLabel: "Pagina",
      convertingPdf: "Conversione PDF in corso...",
      convertingPdfToImages: "Conversione PDF in immagini in corso...",
      complete: "completo",
      completed: "completato",
      convertToPng: "Converti in PNG",
      convertToPngDescription: "Converti le pagine PDF in immagini PNG di alta qualità con supporto alla trasparenza.",
      convertToJpg: "Converti in JPG",
      convertToJpgDescription: "Converti le pagine PDF in immagini JPG di alta qualità.",
      invalidPdfFile: "Seleziona un file PDF.",
      pdfToPngError: "Errore durante la conversione da PDF a PNG",
      pdfConversionError: "Errore durante la conversione del PDF. Riprova.",
      convertToWord: "Converti in Word",
      convertToWordDescription: "Converti i tuoi file PDF in documenti Word modificabili (DOCX).",
      convertToWordButton: "Converti in Word (.docx)",
      convertingToWord: "Conversione in Word...",
      pdfToWordError: "Errore durante la conversione da PDF a Word. Riprova.",
      convertToPdf: "Converti in PDF",
      convertingToPdf: "Conversione in PDF...",
      wordToPdfError: "Errore durante la conversione da Word a PDF. Riprova.",
      mergePdfTitle: "Unisci file PDF",
      mergePdfDescription: "Combina più file PDF in un unico documento. Trascina per riordinare i file.",
      mergePdfHint: "Seleziona 2 o più file PDF da unire",
      filesToMerge: "File da unire",
      clearAll: "Cancella tutto",
      moveUp: "Sposta su",
      moveDown: "Sposta giù",
      merging: "Unione in corso...",
      mergePdfs: "Unisci PDF",
      mergePdfError: "Errore durante l’unione dei PDF. Assicurati che tutti i file siano PDF validi.",
    },
  },
  hu: {
    landing: {
      toolsDescription: "Fedezd fel leggyakrabban használt ingyenes online eszközeinket. Biztonságosak, gyorsak és könnyen használhatók.",
      useCasesTitle: "Felhasználási esetek",
      useCasesDescription: "Nézd meg, hogyan segít a Dogufy különböző szakmai csoportoknak gyorsabban célba érni.",
      useCases: [
        item("Diákoknak és akadémiai munkához", "Egyesíts beadandókat, tömöríts szakdolgozatokat és alakíts kutatási dokumentumokat szerkeszthető formátumba."),
        item("Üzleti szakembereknek", "Írj alá szerződéseket, egyesíts jelentéseket, és alakíts táblázatokat megosztható PDF-fájlokká."),
        item("Tervezőknek és kreatívoknak", "Optimalizálj képeket, távolíts el háttereket és konvertálj asseteket gyorsabban."),
        item("Jogi csapatoknak", "Kezelj érzékeny dokumentumokat privátabb workflow-val és rendezettebb struktúrával."),
        item("Ingatlanügynököknek", "Készíts brosúrákat, ingatlananyagokat és hirdetési asseteket hatékonyabban."),
      ],
      useCasesCta: "Eszközök kipróbálása",
      processDescription: "Egyszerű, gyors és biztonságos. Készítsd elő dokumentumaidat 4 könnyű lépésben.",
      processSteps: [
        step("01", "Válassz eszközt", "Válaszd ki a megfelelő workflow-t PDF-, kép- és szöveges eszközeink közül."),
        step("02", "Töltsd fel a fájlokat", "Húzd a fájlt a böngészőbe, majd állítsd be az elérhető opciókat."),
        step("03", "Feldolgozás másodpercek alatt", "Futtasd a feladatot azonnal extra szoftver telepítése nélkül."),
        step("04", "Letöltés és megosztás", "Az eredményt azonnal megkapod, és folytathatod a munkát."),
      ],
      featuresDescription: "Ingyenes online eszközöket kínálunk, amelyek sebességre, adatvédelemre és gyakorlati workflow-kra épülnek.",
      features: [
        item("Mindig ingyenes", "Használd az eszközöket előfizetés, rejtett díjak vagy fizetőfal nélkül."),
        item("Biztonságos és privát", "Az adatvédelemre figyelő workflow-k segítenek kordában tartani az érzékeny fájlokat."),
        item("Villámgyors", "A böngészőalapú munkafolyamatok csökkentik az ismétlődő feladatokra fordított időt."),
        item("Könnyen használható", "A felületet úgy terveztük, hogy technikai háttér nélkül is kényelmes legyen."),
        item("Mobilbarát", "Az élmény asztali gépen, tableten és mobilon is jól működik."),
        item("Magas minőség", "Hasznos kimeneti minőségre törekszünk, miközben egyszerű marad a folyamat."),
      ],
      testimonialsDescription: "Nézd meg, mit mondanak a felhasználók a Dogufyról.",
      testimonials: [
        quote("A Dogufy gyorsan segített összefűzni a szakdolgozatom fejezeteit felesleges bonyolultság nélkül.", "Sarah J.", "Mesterszakos hallgató"),
        quote("Rendszeresen használom a képes eszközöket webes munkához, mert gyorsak és kényelmesek.", "Mike T.", "Frontend fejlesztő"),
        quote("A dokumentumkonvertáló eszközök időt spórolnak, amikor szerkeszthető verziókat kell előkészítenem.", "Emily R.", "Jogi asszisztens"),
      ],
      landingContactDescription: "Lépj velünk kapcsolatba, ha kérdésed van, fejlesztési ötleted van, vagy beszélnél a termékről.",
      sayHi: "Köszönj be",
      getQuote: "Árajánlat kérése",
      name: "Név",
      email: "E-mail",
      message: "Üzenet",
      send: "Üzenet küldése",
    },
    about: {
      intro: "Üdvözlünk a Dogufynál, ahol dokumentum-, kép- és szövegfeldolgozási igényeid egy helyen megoldhatók.",
      missionBody: "Hiszünk abban, hogy a hatékony produktivitási eszközöknek mindenki számára elérhetőnek kell lenniük. Küldetésünk, hogy ingyenes, magas minőségű online eszközöket adjunk, amelyekkel drága szoftver és bonyolult beállítás nélkül lehet gyorsabban dolgozni.",
      offers: [
        "PDF-eszközök dokumentumok konvertálásához, egyesítéséhez, szétválasztásához, tömörítéséhez és szerkesztéséhez.",
        "Képes eszközök átméretezéshez, tömörítéshez, konvertáláshoz és vizuális assetek tisztításához.",
        "Szöveges eszközök formázáshoz, konvertáláshoz és tartalomelemzéshez.",
        "Fejlesztői segédek, például QR-generátor, UUID-generátor és további gyors utilok.",
      ],
      privacyTitle: "Adatvédelem az első",
      privacyBody: "A legtöbb feldolgozás közvetlenül a böngészőben történik. A fájljaid nálad maradnak, ami gyorsabbá, privátabbá és biztonságosabbá teszi a munkafolyamatot.",
      freeTitle: "100%-ban ingyenes",
      freeBody: "Eszközeink előfizetés, rejtett díjak és regisztrációs akadályok nélkül használhatók.",
    },
    contact: {
      sentTitle: "Üzenet elküldve!",
      sentBody: "Köszönjük, hogy írtál nekünk. Hamarosan válaszolunk.",
      labels: { name: "Név", email: "E-mail", subject: "Tárgy", message: "Üzenet" },
      placeholders: {
        name: "A neved",
        email: "email@pelda.hu",
        subject: "Miről van szó?",
        message: "Írj részletesebben...",
      },
      github: "GitHub",
      githubBody: "Találtál hibát vagy hozzájárulnál? Nézd meg a repositoryt.",
      viewRepo: "Repository megtekintése",
    },
    privacy: {
      sections: [
        section("A te adatvédelmed számít", "Komolyan vesszük az adatvédelmet, és igyekszünk minimalizálni a szükségtelen adatgyűjtést."),
        section("Adatfeldolgozás", "A legtöbb eszköz helyben, a böngészőben dolgozza fel a fájlokat. Néhány haladó konverzió átmeneti szerveroldali feldolgozást igényelhet.", [
          "A fájlok általában az eszközödön maradnak a feldolgozás alatt.",
          "Az átmeneti szerverfeladatokat a befejezés után töröljük.",
          "A dokumentumtartalmat nem tároljuk szándékosan.",
        ]),
        section("Milyen információkat gyűjtünk", undefined, [
          "Anonim analitika csak hozzájárulás után.",
          "A fő eszközökhöz nincs szükség fiókra.",
          "A feltöltött fájlokat nem tároljuk tartósan.",
        ]),
        section("Cookie-k", undefined, [
          "Hozzájárulási beállítás tárolása.",
          "Biztonság és alapvető webhelyfunkciók.",
          "Opcionális analitika kifejezett engedély után.",
        ]),
        section("A jogaid", "Elutasíthatod az analitikát, törölheted a böngésző helyi adatait, és bármikor abbahagyhatod a szolgáltatás használatát."),
      ],
    },
    terms: {
      sections: [
        section("1. A feltételek elfogadása", "A Dogufy használatával elfogadod ezeket a feltételeket."),
        section("2. A szolgáltatás használata", "A szolgáltatás személyes és üzleti produktivitási célokra érhető el.", [
          "Használd jogszerűen a szolgáltatást.",
          "Ne terheld túl, ne használd ki és ne élj vissza a platformmal.",
          "Ne használd az eszközöket káros vagy rosszindulatú célokra.",
        ]),
        section("3. Szolgáltatás rendelkezésre állása", "A megbízhatóságra törekszünk, de nem tudunk megszakításmentes vagy hibamentes hozzáférést garantálni."),
        section("4. Felelősség korlátozása", "A szolgáltatást saját felelősségedre használod, beleértve az eredmény minőségének ellenőrzését és a workflow alkalmasságát."),
        section("5. Felhasználói felelősség", "A fájljaidért és azok feldolgozási jogáért továbbra is te felelsz.", [
          "Tarts biztonsági mentést a fontos eredetikről.",
          "Ellenőrizd a kimeneti minőséget fontos felhasználás előtt.",
          "Tartsd tiszteletben a szerzői jogot és egyéb jogi kötelezettségeket.",
        ]),
        section("6. Kapcsolat", "Ha kérdésed van ezekkel a feltételekkel kapcsolatban, kérjük, vedd fel velünk a kapcsolatot a weboldalon keresztül."),
      ],
    },
    blog: {
      description: "Olvasd el legfrissebb cikkeinket PDF-eszközökről, képfeldolgozásról és produktivitásról.",
      intro: "Fedezz fel gyakorlati cikkeket dokumentumokról, képekről és digitális workflow-król.",
      noTools: "Nincs találat.",
      clear: "Keresés törlése",
    },
    toolsPage: {
      description: "Böngészd át teljes ingyenes online eszköztárunkat, és találd meg pontosan, amire szükséged van.",
      intro: "Ez a központi oldal segít a látogatóknak és a keresőknek megérteni a Dogufy teljes eszközkönyvtárát, és gyorsan a megfelelő oldalra jutni.",
      searchPlaceholder: "Eszköz keresése (pl. merge, image, pdf)...",
      noResultsTitle: "Nem található eszköz",
      noResultsBody: "Nem találtunk a keresésednek megfelelő eszközt. Próbálj más kulcsszót vagy kategóriát.",
      didYouKnow: "Tudtad?",
      didYouKnowBody: "Sok workflow közvetlenül a böngészőben fut, ami gyorsabbá és privátabbá teszi a dokumentumkezelést.",
      whatMakesUseful: "Miért hasznos ez az eszköz?",
      howToOnline: "Hogyan használd ezt az eszközt online",
      uploadOrEnter: "Fájl feltöltése vagy adatok megadása",
      configure: "Beállítások konfigurálása",
      processDownload: "Feldolgozás és letöltés",
      bestUseCases: "Legjobb felhasználási esetek",
      whyChoose: "Miért a Dogufy-t válaszd ehhez az eszközhöz?",
      fastFree: "Gyors és ingyenes",
      fastFreeBody: "Használd gyorsan a workflow-t regisztrációs akadályok nélkül.",
      securePrivate: "Biztonságos és privát",
      securePrivateBody: "Az élmény célja a felhasználói fájlok felesleges kitettségének csökkentése.",
      highQuality: "Magas minőség",
      highQualityBody: "Arra törekszünk, hogy hasznos kimeneti minőséget tartsunk meg egyszerű folyamat mellett.",
      relatedCategory: "Kapcsolódó eszközök",
      removeFile: "Fájl eltávolítása",
      convertedImages: "Konvertált képek",
      downloadAll: "Összes letöltése",
      downloadPage: "Oldal letöltése",
      pageLabel: "Oldal",
      convertingPdf: "PDF konvertálása...",
      convertingPdfToImages: "PDF képekké alakítása...",
      complete: "kész",
      completed: "befejezve",
      convertToPng: "Konvertálás PNG-be",
      convertToPngDescription: "Alakítsd a PDF-oldalakat kiváló minőségű PNG-képekké átlátszósági támogatással.",
      convertToJpg: "Konvertálás JPG-be",
      convertToJpgDescription: "Alakítsd a PDF-oldalakat kiváló minőségű JPG-képekké.",
      invalidPdfFile: "Kérjük, válassz PDF-fájlt.",
      pdfToPngError: "Hiba történt a PDF PNG-vé alakításakor",
      pdfConversionError: "Hiba történt a PDF konvertálásakor. Próbáld újra.",
      convertToWord: "Konvertálás Wordbe",
      convertToWordDescription: "Alakítsd a PDF-fájlokat szerkeszthető Word-dokumentumokká (DOCX).",
      convertToWordButton: "Konvertálás Wordbe (.docx)",
      convertingToWord: "Konvertálás Wordbe...",
      pdfToWordError: "Hiba történt a PDF Worddé alakításakor. Próbáld újra.",
      convertToPdf: "Konvertálás PDF-be",
      convertingToPdf: "Konvertálás PDF-be...",
      wordToPdfError: "Hiba történt a Word PDF-fé alakításakor. Próbáld újra.",
      mergePdfTitle: "PDF-fájlok egyesítése",
      mergePdfDescription: "Több PDF-fájlt egyetlen dokumentummá kombinálhatsz. Húzd át a fájlokat az újrarendezéshez.",
      mergePdfHint: "Válassz 2 vagy több PDF-fájlt az egyesítéshez",
      filesToMerge: "Egyesítendő fájlok",
      clearAll: "Összes törlése",
      moveUp: "Mozgatás fel",
      moveDown: "Mozgatás le",
      merging: "Egyesítés...",
      mergePdfs: "PDF-ek egyesítése",
      mergePdfError: "Hiba történt a PDF-ek egyesítésekor. Ellenőrizd, hogy minden fájl érvényes PDF legyen.",
    },
  },
  ms: {
    landing: {
      toolsDescription: "Terokai alat dalam talian percuma kami yang paling kerap digunakan. Selamat, pantas dan mudah digunakan.",
      useCasesTitle: "Kegunaan utama",
      useCasesDescription: "Lihat bagaimana Dogufy membantu pelbagai jenis pengguna menyelesaikan kerja dengan lebih cepat.",
      useCases: [
        item("Untuk pelajar dan akademik", "Gabungkan tugasan, mampatkan tesis, dan tukar dokumen penyelidikan kepada format yang boleh disunting."),
        item("Untuk profesional perniagaan", "Tandatangani kontrak, gabungkan laporan, dan tukar hamparan kepada PDF yang mudah dikongsi."),
        item("Untuk pereka dan kreatif", "Optimumkan imej, buang latar belakang, dan tukar aset dengan lebih pantas."),
        item("Untuk pasukan undang-undang", "Urus dokumen sensitif dengan aliran kerja yang lebih privasi dan tersusun."),
        item("Untuk ejen hartanah", "Sediakan risalah, fail hartanah dan aset penyenaraian dengan lebih cekap."),
      ],
      useCasesCta: "Cuba alat",
      processDescription: "Mudah, pantas dan selamat. Siapkan dokumen anda dalam 4 langkah.",
      processSteps: [
        step("01", "Pilih alat", "Pilih aliran kerja yang betul daripada koleksi alat PDF, imej dan teks kami."),
        step("02", "Muat naik fail", "Seret fail ke dalam pelayar dan tetapkan pilihan yang tersedia."),
        step("03", "Proses dalam beberapa saat", "Jalankan tugasan serta-merta tanpa memasang perisian tambahan."),
        step("04", "Muat turun dan kongsi", "Dapatkan hasil dengan segera dan teruskan kerja anda."),
      ],
      featuresDescription: "Kami menyediakan alat percuma yang dibina untuk kelajuan, privasi dan aliran kerja yang praktikal.",
      features: [
        item("Percuma selamanya", "Gunakan alat tanpa langganan, caj tersembunyi atau tembok bayaran."),
        item("Selamat dan peribadi", "Aliran kerja yang peka privasi membantu memastikan fail sensitif kekal terkawal."),
        item("Sangat pantas", "Aliran kerja dalam pelayar mengurangkan masa untuk tugasan berulang."),
        item("Mudah digunakan", "Antara muka direka agar selesa walaupun untuk pengguna bukan teknikal."),
        item("Mesra mudah alih", "Pengalaman ini berfungsi di desktop, tablet dan telefon."),
        item("Kualiti tinggi", "Kami mahu mengekalkan kualiti output yang berguna sambil memudahkan proses."),
      ],
      testimonialsDescription: "Lihat apa yang pengguna katakan tentang Dogufy.",
      testimonials: [
        quote("Dogufy membantu saya menggabungkan bab tesis dengan cepat tanpa kerumitan yang tidak perlu.", "Sarah J.", "Pelajar siswazah"),
        quote("Saya kerap menggunakan alat imej untuk kerja web kerana ia pantas dan mudah.", "Mike T.", "Pembangun frontend"),
        quote("Alat penukaran dokumen menjimatkan masa apabila saya perlu menyediakan versi yang boleh disunting.", "Emily R.", "Pembantu undang-undang"),
      ],
      landingContactDescription: "Hubungi kami jika anda mahu berbincang tentang produk, mencadangkan penambahbaikan atau bertanya soalan.",
      sayHi: "Sapa kami",
      getQuote: "Minta sebut harga",
      name: "Nama",
      email: "E-mel",
      message: "Mesej",
      send: "Hantar mesej",
    },
    about: {
      intro: "Selamat datang ke Dogufy, penyelesaian sehenti untuk keperluan dokumen, imej dan teks anda.",
      missionBody: "Kami percaya alat produktiviti yang berkuasa patut boleh diakses oleh semua orang. Misi kami ialah menyediakan alat dalam talian percuma dan berkualiti tinggi yang membantu pengguna bekerja lebih pantas tanpa perisian mahal atau persediaan rumit.",
      offers: [
        "Alat PDF untuk menukar, menggabung, memisah, memampatkan dan menyunting dokumen.",
        "Alat imej untuk menukar saiz, memampatkan, menukar format dan membersihkan aset visual.",
        "Alat teks untuk pemformatan, penukaran dan analisis kandungan.",
        "Utiliti pembangun seperti penjana QR, penjana UUID dan pembantu pantas lain.",
      ],
      privacyTitle: "Privasi diutamakan",
      privacyBody: "Kebanyakan pemprosesan fail berlaku terus dalam pelayar. Fail anda kekal di bawah kawalan anda supaya aliran kerja lebih pantas, peribadi dan selamat.",
      freeTitle: "100% percuma",
      freeBody: "Alat kami tersedia tanpa langganan, caj tersembunyi atau halangan pendaftaran.",
    },
    contact: {
      sentTitle: "Mesej dihantar!",
      sentBody: "Terima kasih kerana menghubungi kami. Kami akan membalas secepat mungkin.",
      labels: { name: "Nama", email: "E-mel", subject: "Subjek", message: "Mesej" },
      placeholders: {
        name: "Nama anda",
        email: "email@contoh.my",
        subject: "Perkara ini tentang apa?",
        message: "Ceritakan lebih lanjut...",
      },
      github: "GitHub",
      githubBody: "Jumpa pepijat atau mahu menyumbang? Lihat repositori kami.",
      viewRepo: "Lihat repositori",
    },
    privacy: {
      sections: [
        section("Privasi anda penting", "Kami mengambil serius soal privasi dan berusaha meminimumkan pengumpulan data yang tidak perlu."),
        section("Pemprosesan data", "Kebanyakan alat memproses fail secara tempatan dalam pelayar anda. Sesetengah penukaran lanjutan mungkin memerlukan pemprosesan sementara di pelayan.", [
          "Fail biasanya kekal pada peranti anda semasa pemprosesan.",
          "Kerja sementara di pelayan dipadam selepas selesai.",
          "Kami tidak sengaja menyimpan kandungan dokumen anda.",
        ]),
        section("Maklumat yang kami kumpulkan", undefined, [
          "Analitik tanpa nama hanya selepas persetujuan.",
          "Tiada akaun diperlukan untuk alat teras.",
          "Tiada storan kekal untuk fail yang dimuat naik.",
        ]),
        section("Kuki", undefined, [
          "Penyimpanan pilihan persetujuan.",
          "Keselamatan dan fungsi asas laman.",
          "Analitik pilihan selepas kebenaran jelas.",
        ]),
        section("Hak anda", "Anda boleh menolak analitik, memadam storan tempatan pelayar dan berhenti menggunakan perkhidmatan pada bila-bila masa."),
      ],
    },
    terms: {
      sections: [
        section("1. Penerimaan terma", "Dengan menggunakan Dogufy, anda bersetuju dengan terma ini."),
        section("2. Penggunaan perkhidmatan", "Perkhidmatan ini disediakan untuk kegunaan produktiviti peribadi dan komersial.", [
          "Gunakan perkhidmatan secara sah.",
          "Jangan membebankan, mengeksploitasi atau menyalahgunakan platform.",
          "Jangan gunakan alat untuk tujuan berbahaya atau berniat jahat.",
        ]),
        section("3. Ketersediaan perkhidmatan", "Kami berusaha untuk kebolehpercayaan tetapi tidak dapat menjamin akses tanpa gangguan atau operasi bebas ralat."),
        section("4. Had liabiliti", "Penggunaan perkhidmatan adalah atas risiko anda sendiri, termasuk semakan kualiti fail dan kesesuaian aliran kerja."),
        section("5. Tanggungjawab pengguna", "Anda kekal bertanggungjawab terhadap fail anda dan hak anda untuk memprosesnya.", [
          "Simpan salinan sandaran fail asal yang penting.",
          "Semak kualiti output sebelum kegunaan kritikal.",
          "Patuhi hak cipta dan kewajipan undang-undang lain.",
        ]),
        section("6. Hubungi kami", "Jika anda mempunyai soalan tentang terma ini, sila hubungi kami melalui laman web."),
      ],
    },
    blog: {
      description: "Baca artikel terkini kami tentang alat PDF, pemprosesan imej dan produktiviti.",
      intro: "Terokai artikel praktikal tentang dokumen, imej dan aliran kerja digital.",
      noTools: "Tiada hasil ditemui.",
      clear: "Kosongkan carian",
    },
    toolsPage: {
      description: "Semak keseluruhan koleksi alat dalam talian percuma kami dan cari aliran kerja yang tepat untuk anda.",
      intro: "Halaman hab ini membantu pengguna dan enjin carian memahami keseluruhan perpustakaan alat Dogufy serta menuju ke halaman yang betul dengan cepat.",
      searchPlaceholder: "Cari alat (contohnya merge, image, pdf)...",
      noResultsTitle: "Tiada alat ditemui",
      noResultsBody: "Kami tidak menjumpai alat yang sepadan dengan carian anda. Cuba kata kunci atau kategori lain.",
      didYouKnow: "Tahukah anda?",
      didYouKnowBody: "Banyak aliran kerja berlaku terus dalam pelayar, membantu pengendalian dokumen menjadi lebih pantas dan lebih peribadi.",
      whatMakesUseful: "Apa yang menjadikan alat ini berguna?",
      howToOnline: "Cara menggunakan alat ini dalam talian",
      uploadOrEnter: "Muat naik atau masukkan data",
      configure: "Tetapkan pilihan",
      processDownload: "Proses dan muat turun",
      bestUseCases: "Kegunaan terbaik",
      whyChoose: "Mengapa pilih Dogufy untuk alat ini?",
      fastFree: "Pantas dan percuma",
      fastFreeBody: "Gunakan aliran kerja dengan cepat tanpa halangan pendaftaran.",
      securePrivate: "Selamat dan peribadi",
      securePrivateBody: "Pengalaman ini direka untuk mengurangkan pendedahan fail pengguna yang tidak perlu.",
      highQuality: "Kualiti tinggi",
      highQualityBody: "Kami berusaha mengekalkan kualiti output yang berguna sambil memudahkan proses.",
      relatedCategory: "Alat berkaitan",
      removeFile: "Buang fail",
      convertedImages: "Imej yang ditukar",
      downloadAll: "Muat turun semua",
      downloadPage: "Muat turun halaman",
      pageLabel: "Halaman",
      convertingPdf: "Sedang menukar PDF...",
      convertingPdfToImages: "Sedang menukar PDF kepada imej...",
      complete: "selesai",
      completed: "diselesaikan",
      convertToPng: "Tukar ke PNG",
      convertToPngDescription: "Tukar halaman PDF kepada imej PNG berkualiti tinggi dengan sokongan ketelusan.",
      convertToJpg: "Tukar ke JPG",
      convertToJpgDescription: "Tukar halaman PDF kepada imej JPG berkualiti tinggi.",
      invalidPdfFile: "Sila pilih fail PDF.",
      pdfToPngError: "Ralat semasa menukar PDF ke PNG",
      pdfConversionError: "Ralat semasa menukar PDF. Sila cuba lagi.",
      convertToWord: "Tukar ke Word",
      convertToWordDescription: "Tukar fail PDF anda kepada dokumen Word yang boleh disunting (DOCX).",
      convertToWordButton: "Tukar ke Word (.docx)",
      convertingToWord: "Sedang menukar ke Word...",
      pdfToWordError: "Ralat semasa menukar PDF ke Word. Sila cuba lagi.",
      convertToPdf: "Tukar ke PDF",
      convertingToPdf: "Sedang menukar ke PDF...",
      wordToPdfError: "Ralat semasa menukar Word ke PDF. Sila cuba lagi.",
      mergePdfTitle: "Gabungkan fail PDF",
      mergePdfDescription: "Gabungkan beberapa fail PDF menjadi satu dokumen. Seret dan lepas untuk menyusun semula fail.",
      mergePdfHint: "Pilih 2 atau lebih fail PDF untuk digabungkan",
      filesToMerge: "Fail untuk digabungkan",
      clearAll: "Kosongkan semua",
      moveUp: "Alih ke atas",
      moveDown: "Alih ke bawah",
      merging: "Sedang menggabung...",
      mergePdfs: "Gabungkan PDF",
      mergePdfError: "Ralat semasa menggabungkan PDF. Pastikan semua fail ialah PDF yang sah.",
    },
  },
  nl: {
    landing: {
      toolsDescription: "Ontdek onze populairste gratis online tools. Veilig, snel en eenvoudig in gebruik.",
      useCasesTitle: "Gebruikssituaties",
      useCasesDescription: "Bekijk hoe Dogufy verschillende gebruikers helpt hun werk sneller af te ronden.",
      useCases: [
        item("Voor studenten en academici", "Voeg opdrachten samen, comprimeer scripties en zet onderzoeksdocumenten om naar bewerkbare formaten."),
        item("Voor zakelijke professionals", "Onderteken contracten, combineer rapporten en zet spreadsheets om in deelbare PDF-bestanden."),
        item("Voor designers en creatieven", "Optimaliseer afbeeldingen, verwijder achtergronden en converteer assets sneller."),
        item("Voor juridische teams", "Werk met gevoelige documenten via privacyvriendelijke workflows en overzichtelijkere documentorganisatie."),
        item("Voor makelaars", "Bereid brochures, woningdossiers en listing-assets efficiënter voor."),
      ],
      useCasesCta: "Tools proberen",
      processDescription: "Simpel, snel en veilig. Maak je documenten klaar in 4 eenvoudige stappen.",
      processSteps: [
        step("01", "Kies je tool", "Selecteer de juiste workflow uit onze verzameling PDF-, afbeeldings- en teksttools."),
        step("02", "Upload je bestanden", "Sleep je bestand naar de browser en stel de beschikbare opties in."),
        step("03", "Verwerk in seconden", "Voer de taak direct uit zonder extra software te installeren."),
        step("04", "Download en deel", "Ontvang het resultaat meteen en ga verder met je werk."),
      ],
      featuresDescription: "Wij bieden gratis tools die zijn gebouwd voor snelheid, privacy en praktische workflows.",
      features: [
        item("Altijd gratis", "Gebruik de tools zonder abonnement, verborgen kosten of betaalmuur."),
        item("Veilig en privé", "Privacygerichte workflows helpen gevoelige bestanden beter onder controle te houden."),
        item("Razendsnel", "Browserworkflows verkorten de tijd voor terugkerende taken."),
        item("Makkelijk te gebruiken", "De interface is ontworpen om ook voor niet-technische gebruikers prettig te zijn."),
        item("Mobielvriendelijk", "De ervaring werkt op desktop, tablet en mobiel."),
        item("Hoge kwaliteit", "We streven naar bruikbare outputkwaliteit terwijl het proces eenvoudig blijft."),
      ],
      testimonialsDescription: "Lees wat gebruikers zeggen over Dogufy.",
      testimonials: [
        quote("Dogufy hielp me om scriptiehoofdstukken snel samen te voegen zonder onnodige complexiteit.", "Sarah J.", "Masterstudent"),
        quote("Ik gebruik de afbeeldings-tools regelmatig voor webwerk omdat ze snel en praktisch zijn.", "Mike T.", "Frontend developer"),
        quote("De documentconversie-tools besparen tijd wanneer ik bewerkbare versies moet voorbereiden.", "Emily R.", "Juridisch assistent"),
      ],
      landingContactDescription: "Neem contact met ons op als je vragen hebt, verbeteringen wilt voorstellen of over het product wilt praten.",
      sayHi: "Zeg hallo",
      getQuote: "Offerte aanvragen",
      name: "Naam",
      email: "E-mail",
      message: "Bericht",
      send: "Bericht verzenden",
    },
    about: {
      intro: "Welkom bij Dogufy, jouw centrale oplossing voor documenten, afbeeldingen en tekst.",
      missionBody: "Wij geloven dat krachtige productiviteitstools voor iedereen toegankelijk moeten zijn. Onze missie is om gratis online tools van hoge kwaliteit aan te bieden waarmee gebruikers sneller kunnen werken zonder dure software of ingewikkelde setup.",
      offers: [
        "PDF-tools voor converteren, samenvoegen, splitsen, comprimeren en bewerken van documenten.",
        "Afbeeldingstools voor formaat wijzigen, comprimeren, converteren en opschonen van visuele assets.",
        "Teksttools voor formatteren, converteren en analyseren van inhoud.",
        "Developer utilities zoals QR-generatoren, UUID-generatoren en andere snelle helpers.",
      ],
      privacyTitle: "Privacy eerst",
      privacyBody: "De meeste bestandsverwerking gebeurt direct in de browser. Je bestanden blijven onder jouw controle, wat helpt om workflows snel, privé en veilig te houden.",
      freeTitle: "100% gratis",
      freeBody: "Onze tools zijn beschikbaar zonder abonnement, verborgen kosten of registratiebarrières.",
    },
    contact: {
      sentTitle: "Bericht verzonden!",
      sentBody: "Bedankt voor je bericht. We reageren zo snel mogelijk.",
      labels: { name: "Naam", email: "E-mail", subject: "Onderwerp", message: "Bericht" },
      placeholders: {
        name: "Jouw naam",
        email: "jouw.email@voorbeeld.nl",
        subject: "Waar gaat het over?",
        message: "Vertel ons meer...",
      },
      github: "GitHub",
      githubBody: "Een bug gevonden of wil je bijdragen? Bekijk de repository.",
      viewRepo: "Repository bekijken",
    },
    privacy: {
      sections: [
        section("Jouw privacy is belangrijk", "We nemen privacy serieus en proberen onnodige gegevensverzameling te minimaliseren."),
        section("Gegevensverwerking", "De meeste tools verwerken bestanden lokaal in je browser. Sommige geavanceerde conversies kunnen tijdelijke serververwerking vereisen.", [
          "Bestanden blijven meestal op je apparaat tijdens de verwerking.",
          "Tijdelijke servertaken worden na voltooiing verwijderd.",
          "We slaan de inhoud van documenten niet bewust op.",
        ]),
        section("Welke informatie we verzamelen", undefined, [
          "Anonieme analytics alleen na toestemming.",
          "Geen account nodig voor de kernfunctionaliteit.",
          "Geen permanente opslag van geüploade bestanden.",
        ]),
        section("Cookies", undefined, [
          "Opslag van toestemmingsvoorkeuren.",
          "Beveiliging en essentiële sitefunctionaliteit.",
          "Optionele analytics na expliciete toestemming.",
        ]),
        section("Jouw rechten", "Je kunt analytics weigeren, lokale browsergegevens wissen en op elk moment stoppen met het gebruik van de dienst."),
      ],
    },
    terms: {
      sections: [
        section("1. Acceptatie van de voorwaarden", "Door Dogufy te gebruiken ga je akkoord met deze voorwaarden."),
        section("2. Gebruik van de dienst", "De dienst wordt aangeboden voor persoonlijke en zakelijke productiviteitsdoeleinden.", [
          "Gebruik de dienst op een legale manier.",
          "Overbelast, misbruik of exploiteer het platform niet.",
          "Gebruik de tools niet voor schadelijke of kwaadaardige doeleinden.",
        ]),
        section("3. Beschikbaarheid van de dienst", "We streven naar betrouwbaarheid, maar kunnen geen ononderbroken toegang of foutloze werking garanderen."),
        section("4. Beperking van aansprakelijkheid", "Gebruik van de dienst is op eigen risico, inclusief controle van bestandskwaliteit en geschiktheid van de workflow."),
        section("5. Verantwoordelijkheid van de gebruiker", "Je blijft verantwoordelijk voor je bestanden en je recht om ze te verwerken.", [
          "Bewaar back-ups van belangrijke originelen.",
          "Controleer de kwaliteit van het resultaat voor kritisch gebruik.",
          "Respecteer auteursrecht en andere wettelijke verplichtingen.",
        ]),
        section("6. Contact", "Als je vragen hebt over deze voorwaarden, neem dan contact met ons op via de website."),
      ],
    },
    blog: {
      description: "Lees onze nieuwste artikelen over PDF-tools, beeldverwerking en productiviteit.",
      intro: "Ontdek praktische artikelen over documenten, afbeeldingen en digitale workflows.",
      noTools: "Geen resultaten gevonden.",
      clear: "Zoekopdracht wissen",
    },
    toolsPage: {
      description: "Blader door onze volledige collectie gratis online tools en vind precies de workflow die je nodig hebt.",
      intro: "Deze hub helpt bezoekers en zoekmachines de volledige toolbibliotheek van Dogufy te begrijpen en snel de juiste pagina te vinden.",
      searchPlaceholder: "Zoek een tool (bijv. merge, image, pdf)...",
      noResultsTitle: "Geen tools gevonden",
      noResultsBody: "We konden geen tools vinden die overeenkomen met je zoekopdracht. Probeer een ander trefwoord of categorie.",
      didYouKnow: "Wist je dat?",
      didYouKnowBody: "Veel workflows gebeuren direct in de browser, wat documentverwerking sneller en privévriendelijker maakt.",
      whatMakesUseful: "Wat maakt deze tool nuttig?",
      howToOnline: "Zo gebruik je deze tool online",
      uploadOrEnter: "Upload of voer gegevens in",
      configure: "Instellingen configureren",
      processDownload: "Verwerken en downloaden",
      bestUseCases: "Beste gebruikssituaties",
      whyChoose: "Waarom Dogufy kiezen voor deze tool?",
      fastFree: "Snel en gratis",
      fastFreeBody: "Gebruik de workflow snel zonder registratiebarrières.",
      securePrivate: "Veilig en privé",
      securePrivateBody: "De ervaring is ontworpen om onnodige blootstelling van gebruikersbestanden te verminderen.",
      highQuality: "Hoge kwaliteit",
      highQualityBody: "We streven naar bruikbare outputkwaliteit terwijl we het proces eenvoudig houden.",
      relatedCategory: "Gerelateerde tools",
      removeFile: "Bestand verwijderen",
      convertedImages: "Geconverteerde afbeeldingen",
      downloadAll: "Alles downloaden",
      downloadPage: "Pagina downloaden",
      pageLabel: "Pagina",
      convertingPdf: "PDF wordt geconverteerd...",
      convertingPdfToImages: "PDF wordt naar afbeeldingen geconverteerd...",
      complete: "klaar",
      completed: "voltooid",
      convertToPng: "Converteren naar PNG",
      convertToPngDescription: "Converteer PDF-pagina’s naar PNG-afbeeldingen van hoge kwaliteit met transparantie-ondersteuning.",
      convertToJpg: "Converteren naar JPG",
      convertToJpgDescription: "Converteer PDF-pagina’s naar JPG-afbeeldingen van hoge kwaliteit.",
      invalidPdfFile: "Selecteer een PDF-bestand.",
      pdfToPngError: "Fout bij het converteren van PDF naar PNG",
      pdfConversionError: "Fout bij het converteren van de PDF. Probeer het opnieuw.",
      convertToWord: "Converteren naar Word",
      convertToWordDescription: "Converteer je PDF-bestanden naar bewerkbare Word-documenten (DOCX).",
      convertToWordButton: "Converteren naar Word (.docx)",
      convertingToWord: "Word wordt geconverteerd...",
      pdfToWordError: "Fout bij het converteren van PDF naar Word. Probeer het opnieuw.",
      convertToPdf: "Converteren naar PDF",
      convertingToPdf: "Bezig met converteren naar PDF...",
      wordToPdfError: "Fout bij het converteren van Word naar PDF. Probeer het opnieuw.",
      mergePdfTitle: "PDF-bestanden samenvoegen",
      mergePdfDescription: "Combineer meerdere PDF-bestanden tot één document. Sleep om bestanden te herordenen.",
      mergePdfHint: "Selecteer 2 of meer PDF-bestanden om samen te voegen",
      filesToMerge: "Bestanden om samen te voegen",
      clearAll: "Alles wissen",
      moveUp: "Omhoog verplaatsen",
      moveDown: "Omlaag verplaatsen",
      merging: "Bezig met samenvoegen...",
      mergePdfs: "PDF's samenvoegen",
      mergePdfError: "Fout bij het samenvoegen van PDF's. Controleer of alle bestanden geldige PDF's zijn.",
    },
  },
  pl: {
    landing: {
      toolsDescription: "Poznaj nasze najczęściej używane darmowe narzędzia online. Bezpieczne, szybkie i łatwe w użyciu.",
      useCasesTitle: "Zastosowania",
      useCasesDescription: "Sprawdź, jak Dogufy pomaga różnym grupom użytkowników szybciej osiągać cele.",
      useCases: [
        item("Dla studentów i środowiska akademickiego", "Łącz zadania, kompresuj prace dyplomowe i zamieniaj dokumenty badawcze na edytowalne formaty."),
        item("Dla profesjonalistów biznesowych", "Podpisuj umowy, łącz raporty i zamieniaj arkusze kalkulacyjne w łatwe do udostępnienia pliki PDF."),
        item("Dla projektantów i twórców", "Optymalizuj obrazy, usuwaj tło i szybciej konwertuj zasoby."),
        item("Dla zespołów prawnych", "Pracuj z wrażliwymi dokumentami dzięki bardziej prywatnym workflow i lepszej organizacji plików."),
        item("Dla agentów nieruchomości", "Przygotowuj broszury, materiały o nieruchomościach i zasoby do ofert sprawniej."),
      ],
      useCasesCta: "Wypróbuj narzędzia",
      processDescription: "Prosto, szybko i bezpiecznie. Przygotuj dokumenty w 4 prostych krokach.",
      processSteps: [
        step("01", "Wybierz narzędzie", "Wybierz odpowiedni workflow z naszej kolekcji narzędzi PDF, obrazów i tekstu."),
        step("02", "Prześlij pliki", "Przeciągnij plik do przeglądarki i ustaw dostępne opcje."),
        step("03", "Przetwórz w kilka sekund", "Uruchom zadanie od razu bez instalowania dodatkowego oprogramowania."),
        step("04", "Pobierz i udostępnij", "Odbierz wynik natychmiast i kontynuuj pracę."),
      ],
      featuresDescription: "Oferujemy darmowe narzędzia online tworzone z myślą o szybkości, prywatności i praktycznych workflow.",
      features: [
        item("Zawsze za darmo", "Korzystaj z narzędzi bez abonamentu, ukrytych opłat i paywalla."),
        item("Bezpiecznie i prywatnie", "Workflow nastawiony na prywatność pomaga lepiej kontrolować wrażliwe pliki."),
        item("Błyskawicznie", "Workflow w przeglądarce skraca czas poświęcany na powtarzalne zadania."),
        item("Łatwe w użyciu", "Interfejs zaprojektowano tak, aby był wygodny również dla osób nietechnicznych."),
        item("Przyjazne dla mobile", "Doświadczenie działa na desktopie, tablecie i telefonie."),
        item("Wysoka jakość", "Dążymy do zachowania użytecznej jakości wyjściowej przy jednoczesnym uproszczeniu procesu."),
      ],
      testimonialsDescription: "Zobacz, co użytkownicy mówią o Dogufy.",
      testimonials: [
        quote("Dogufy pomógł mi szybko połączyć rozdziały pracy dyplomowej bez zbędnej złożoności.", "Sarah J.", "Studentka studiów magisterskich"),
        quote("Regularnie używam narzędzi obrazkowych do pracy webowej, bo są szybkie i wygodne.", "Mike T.", "Programista frontend"),
        quote("Narzędzia do konwersji dokumentów oszczędzają czas przy przygotowywaniu edytowalnych wersji plików.", "Emily R.", "Asystentka prawna"),
      ],
      landingContactDescription: "Skontaktuj się z nami, jeśli chcesz porozmawiać o produkcie, zgłosić ulepszenie lub zadać pytanie.",
      sayHi: "Przywitaj się",
      getQuote: "Poproś o wycenę",
      name: "Imię",
      email: "E-mail",
      message: "Wiadomość",
      send: "Wyślij wiadomość",
    },
    about: {
      intro: "Witamy w Dogufy, Twoim miejscu do pracy z dokumentami, obrazami i tekstem.",
      missionBody: "Wierzymy, że skuteczne narzędzia produktywności powinny być dostępne dla wszystkich. Naszą misją jest dostarczanie darmowych, wysokiej jakości narzędzi online, które pomagają pracować szybciej bez drogiego oprogramowania i skomplikowanej konfiguracji.",
      offers: [
        "Narzędzia PDF do konwersji, łączenia, dzielenia, kompresji i edycji dokumentów.",
        "Narzędzia obrazkowe do zmiany rozmiaru, kompresji, konwersji i czyszczenia zasobów wizualnych.",
        "Narzędzia tekstowe do formatowania, konwersji i analizy treści.",
        "Narzędzia dla deweloperów, takie jak generator QR, generator UUID i inne szybkie utility.",
      ],
      privacyTitle: "Najpierw prywatność",
      privacyBody: "Większość przetwarzania plików odbywa się bezpośrednio w przeglądarce. Twoje pliki pozostają pod Twoją kontrolą, co pomaga utrzymać workflow szybkim, prywatnym i bezpiecznym.",
      freeTitle: "100% za darmo",
      freeBody: "Nasze narzędzia są dostępne bez subskrypcji, ukrytych opłat i barier rejestracji.",
    },
    contact: {
      sentTitle: "Wiadomość wysłana!",
      sentBody: "Dziękujemy za kontakt. Odpowiemy tak szybko, jak to możliwe.",
      labels: { name: "Imię", email: "E-mail", subject: "Temat", message: "Wiadomość" },
      placeholders: {
        name: "Twoje imię",
        email: "twoj.email@przyklad.pl",
        subject: "Czego dotyczy wiadomość?",
        message: "Powiedz nam więcej...",
      },
      github: "GitHub",
      githubBody: "Znalazłeś błąd lub chcesz pomóc? Zobacz repozytorium.",
      viewRepo: "Zobacz repozytorium",
    },
    privacy: {
      sections: [
        section("Twoja prywatność ma znaczenie", "Traktujemy prywatność poważnie i staramy się minimalizować zbieranie niepotrzebnych danych."),
        section("Przetwarzanie danych", "Większość narzędzi przetwarza pliki lokalnie w przeglądarce. Niektóre zaawansowane konwersje mogą wymagać tymczasowego przetwarzania po stronie serwera.", [
          "Pliki zwykle pozostają na Twoim urządzeniu podczas przetwarzania.",
          "Tymczasowe zadania serwerowe są usuwane po zakończeniu.",
          "Nie przechowujemy celowo treści Twoich dokumentów.",
        ]),
        section("Jakie informacje zbieramy", undefined, [
          "Anonimowa analityka tylko po wyrażeniu zgody.",
          "Brak konieczności tworzenia konta do korzystania z podstawowych narzędzi.",
          "Brak trwałego przechowywania przesłanych plików.",
        ]),
        section("Pliki cookie", undefined, [
          "Przechowywanie preferencji zgody.",
          "Bezpieczeństwo i niezbędne funkcje strony.",
          "Opcjonalna analityka po wyraźnej zgodzie.",
        ]),
        section("Twoje prawa", "Możesz odrzucić analitykę, wyczyścić lokalne dane przeglądarki i w dowolnym momencie przestać korzystać z usługi."),
      ],
    },
    terms: {
      sections: [
        section("1. Akceptacja warunków", "Korzystając z Dogufy, akceptujesz te warunki."),
        section("2. Korzystanie z usługi", "Usługa jest przeznaczona do osobistego i komercyjnego użytku zwiększającego produktywność.", [
          "Korzystaj z usługi zgodnie z prawem.",
          "Nie przeciążaj, nie wykorzystuj ani nie nadużywaj platformy.",
          "Nie używaj narzędzi do celów szkodliwych lub złośliwych.",
        ]),
        section("3. Dostępność usługi", "Dążymy do niezawodności, ale nie możemy zagwarantować nieprzerwanego dostępu ani działania bez błędów."),
        section("4. Ograniczenie odpowiedzialności", "Korzystasz z usługi na własne ryzyko, w tym w zakresie kontroli jakości plików wynikowych i dopasowania workflow."),
        section("5. Obowiązki użytkownika", "Nadal odpowiadasz za swoje pliki i za prawo do ich przetwarzania.", [
          "Przechowuj kopie zapasowe ważnych oryginałów.",
          "Sprawdź jakość wyniku przed krytycznym użyciem.",
          "Szanuj prawa autorskie i inne obowiązki prawne.",
        ]),
        section("6. Kontakt", "Jeśli masz pytania dotyczące tych warunków, skontaktuj się z nami przez stronę internetową."),
      ],
    },
    blog: {
      description: "Czytaj nasze najnowsze artykuły o narzędziach PDF, obróbce obrazów i produktywności.",
      intro: "Poznaj praktyczne artykuły o dokumentach, obrazach i cyfrowych workflow.",
      noTools: "Nie znaleziono wyników.",
      clear: "Wyczyść wyszukiwanie",
    },
    toolsPage: {
      description: "Przeglądaj pełną kolekcję naszych darmowych narzędzi online i znajdź dokładnie to, czego potrzebujesz.",
      intro: "Ta strona centralna pomaga użytkownikom i wyszukiwarkom zrozumieć całą bibliotekę narzędzi Dogufy i szybko dotrzeć do właściwej strony.",
      searchPlaceholder: "Szukaj narzędzia (np. merge, image, pdf)...",
      noResultsTitle: "Nie znaleziono narzędzi",
      noResultsBody: "Nie znaleźliśmy narzędzi pasujących do Twojego wyszukiwania. Spróbuj innego słowa kluczowego lub kategorii.",
      didYouKnow: "Czy wiesz, że?",
      didYouKnowBody: "Wiele workflow działa bezpośrednio w przeglądarce, co pomaga zachować szybką i bardziej prywatną obsługę dokumentów.",
      whatMakesUseful: "Co sprawia, że to narzędzie jest przydatne?",
      howToOnline: "Jak używać tego narzędzia online",
      uploadOrEnter: "Prześlij plik lub wpisz dane",
      configure: "Skonfiguruj ustawienia",
      processDownload: "Przetwórz i pobierz",
      bestUseCases: "Najlepsze zastosowania",
      whyChoose: "Dlaczego wybrać Dogufy do tego narzędzia?",
      fastFree: "Szybko i za darmo",
      fastFreeBody: "Skorzystaj z workflow szybko, bez barier rejestracyjnych.",
      securePrivate: "Bezpiecznie i prywatnie",
      securePrivateBody: "To doświadczenie zostało zaprojektowane tak, aby ograniczać niepotrzebne ujawnianie plików użytkowników.",
      highQuality: "Wysoka jakość",
      highQualityBody: "Staramy się zachować użyteczną jakość wyjściową przy jednoczesnym uproszczeniu procesu.",
      relatedCategory: "Powiązane narzędzia",
      removeFile: "Usuń plik",
      convertedImages: "Przekonwertowane obrazy",
      downloadAll: "Pobierz wszystko",
      downloadPage: "Pobierz stronę",
      pageLabel: "Strona",
      convertingPdf: "Konwertowanie PDF...",
      convertingPdfToImages: "Konwertowanie PDF na obrazy...",
      complete: "gotowe",
      completed: "ukończono",
      convertToPng: "Konwertuj do PNG",
      convertToPngDescription: "Konwertuj strony PDF na wysokiej jakości obrazy PNG z obsługą przezroczystości.",
      convertToJpg: "Konwertuj do JPG",
      convertToJpgDescription: "Konwertuj strony PDF na wysokiej jakości obrazy JPG.",
      invalidPdfFile: "Wybierz plik PDF.",
      pdfToPngError: "Błąd podczas konwersji PDF do PNG",
      pdfConversionError: "Wystąpił błąd podczas konwersji PDF. Spróbuj ponownie.",
      convertToWord: "Konwertuj do Worda",
      convertToWordDescription: "Zamień pliki PDF na edytowalne dokumenty Word (DOCX).",
      convertToWordButton: "Konwertuj do Worda (.docx)",
      convertingToWord: "Konwertowanie do Worda...",
      pdfToWordError: "Błąd podczas konwersji PDF do Worda. Spróbuj ponownie.",
      convertToPdf: "Konwertuj do PDF",
      convertingToPdf: "Konwertowanie do PDF...",
      wordToPdfError: "Błąd podczas konwersji Worda do PDF. Spróbuj ponownie.",
      mergePdfTitle: "Scal pliki PDF",
      mergePdfDescription: "Połącz wiele plików PDF w jeden dokument. Przeciągnij i upuść, aby zmienić kolejność plików.",
      mergePdfHint: "Wybierz 2 lub więcej plików PDF do scalenia",
      filesToMerge: "Pliki do scalenia",
      clearAll: "Wyczyść wszystko",
      moveUp: "Przesuń w górę",
      moveDown: "Przesuń w dół",
      merging: "Scalanie...",
      mergePdfs: "Scal PDF-y",
      mergePdfError: "Błąd podczas scalania PDF-ów. Upewnij się, że wszystkie pliki są prawidłowymi PDF-ami.",
    },
  },
};

const secondHalf: Partial<Record<Locale, unknown>> = {
  pt: {
    landing: {
      toolsDescription: "Explore as nossas ferramentas online gratuitas mais usadas. Seguras, rápidas e fáceis de utilizar.",
      useCasesTitle: "Casos de uso",
      useCasesDescription: "Veja como a Dogufy ajuda diferentes perfis a trabalhar com mais rapidez.",
      useCases: [
        item("Para estudantes e academia", "Junte trabalhos, comprima dissertações e converta documentos de investigação em formatos editáveis."),
        item("Para profissionais de negócio", "Assine contratos, una relatórios e converta folhas de cálculo em PDF fáceis de partilhar."),
        item("Para designers e criativos", "Otimize imagens, remova fundos e converta assets com mais rapidez."),
        item("Para equipas jurídicas", "Trabalhe com documentos sensíveis através de fluxos mais privados e melhor organização."),
        item("Para agentes imobiliários", "Prepare brochuras, dossiês de imóveis e materiais de listagem com mais eficiência."),
      ],
      useCasesCta: "Experimentar ferramentas",
      processDescription: "Simples, rápido e seguro. Prepare os seus documentos em 4 passos fáceis.",
      processSteps: [
        step("01", "Escolha a ferramenta", "Selecione o workflow certo da nossa coleção de ferramentas PDF, imagem e texto."),
        step("02", "Carregue os ficheiros", "Arraste o ficheiro para o navegador e ajuste as opções disponíveis."),
        step("03", "Processe em segundos", "Execute a tarefa imediatamente sem instalar software extra."),
        step("04", "Transfira e partilhe", "Receba o resultado de imediato e continue o seu trabalho."),
      ],
      featuresDescription: "Disponibilizamos ferramentas gratuitas criadas para velocidade, privacidade e workflows práticos.",
      features: [
        item("Grátis para sempre", "Use as ferramentas sem subscrições, custos escondidos ou paywall."),
        item("Seguro e privado", "Workflows orientados para privacidade ajudam a manter ficheiros sensíveis sob controlo."),
        item("Muito rápido", "Workflows no navegador reduzem o tempo gasto em tarefas repetitivas."),
        item("Fácil de usar", "A interface foi pensada para ser clara mesmo para utilizadores não técnicos."),
        item("Compatível com mobile", "A experiência funciona em desktop, tablet e telemóvel."),
        item("Alta qualidade", "Queremos manter uma qualidade de saída útil enquanto simplificamos o processo."),
      ],
      testimonialsDescription: "Veja o que os utilizadores dizem sobre a Dogufy.",
      testimonials: [
        quote("A Dogufy ajudou-me a juntar capítulos da minha dissertação rapidamente e sem complicações.", "Sarah J.", "Estudante de mestrado"),
        quote("Uso regularmente as ferramentas de imagem para trabalho web porque são rápidas e práticas.", "Mike T.", "Programador frontend"),
        quote("As ferramentas de conversão de documentos poupam tempo quando preciso de versões editáveis.", "Emily R.", "Assistente jurídica"),
      ],
      landingContactDescription: "Fale connosco se quiser discutir o produto, sugerir melhorias ou colocar uma questão.",
      sayHi: "Dizer olá",
      getQuote: "Pedir orçamento",
      name: "Nome",
      email: "E-mail",
      message: "Mensagem",
      send: "Enviar mensagem",
    },
    about: {
      intro: "Bem-vindo à Dogufy, a sua solução completa para documentos, imagens e texto.",
      missionBody: "Acreditamos que ferramentas de produtividade poderosas devem ser acessíveis a todos. A nossa missão é disponibilizar ferramentas online gratuitas e de alta qualidade para trabalhar mais depressa sem software caro nem configuração complicada.",
      offers: [
        "Ferramentas PDF para converter, unir, dividir, comprimir e editar documentos.",
        "Ferramentas de imagem para redimensionar, comprimir, converter e limpar assets visuais.",
        "Ferramentas de texto para formatar, converter e analisar conteúdo.",
        "Utilitários de desenvolvimento como gerador de QR, gerador de UUID e outros atalhos rápidos.",
      ],
      privacyTitle: "Privacidade em primeiro lugar",
      privacyBody: "A maior parte do processamento acontece diretamente no navegador. Os seus ficheiros ficam sob o seu controlo, ajudando a manter o workflow rápido, privado e seguro.",
      freeTitle: "100% gratuito",
      freeBody: "As nossas ferramentas estão disponíveis sem subscrições, custos escondidos ou barreiras de registo.",
    },
    contact: {
      sentTitle: "Mensagem enviada!",
      sentBody: "Obrigado pelo seu contacto. Responderemos assim que possível.",
      labels: { name: "Nome", email: "E-mail", subject: "Assunto", message: "Mensagem" },
      placeholders: {
        name: "O seu nome",
        email: "o.seu.email@exemplo.pt",
        subject: "Sobre o que é isto?",
        message: "Conte-nos mais...",
      },
      github: "GitHub",
      githubBody: "Encontrou um erro ou quer contribuir? Veja o repositório.",
      viewRepo: "Ver repositório",
    },
    privacy: {
      sections: [
        section("A sua privacidade importa", "Levamos a privacidade a sério e tentamos minimizar a recolha desnecessária de dados."),
        section("Tratamento de dados", "A maioria das ferramentas processa ficheiros localmente no navegador. Algumas conversões avançadas podem exigir processamento temporário no servidor.", [
          "Os ficheiros normalmente permanecem no seu dispositivo durante o processamento.",
          "As tarefas temporárias do servidor são eliminadas após a conclusão.",
          "Não armazenamos intencionalmente o conteúdo dos seus documentos.",
        ]),
        section("Informações que recolhemos", undefined, [
          "Analítica anónima apenas após consentimento.",
          "Não é necessária conta para usar as ferramentas principais.",
          "Não existe armazenamento permanente dos ficheiros enviados.",
        ]),
        section("Cookies", undefined, [
          "Armazenamento da preferência de consentimento.",
          "Segurança e funcionalidades essenciais do site.",
          "Analítica opcional após autorização explícita.",
        ]),
        section("Os seus direitos", "Pode rejeitar a analítica, limpar o armazenamento local do navegador e deixar de usar o serviço a qualquer momento."),
      ],
    },
    terms: {
      sections: [
        section("1. Aceitação dos termos", "Ao utilizar a Dogufy, aceita estes termos."),
        section("2. Uso do serviço", "O serviço é fornecido para necessidades de produtividade pessoais e comerciais.", [
          "Utilize o serviço de forma legal.",
          "Não sobrecarregue, explore nem abuse da plataforma.",
          "Não utilize as ferramentas para fins nocivos ou maliciosos.",
        ]),
        section("3. Disponibilidade do serviço", "Procuramos fiabilidade, mas não podemos garantir acesso ininterrupto nem funcionamento sem erros."),
        section("4. Limitação de responsabilidade", "A utilização do serviço é por sua conta e risco, incluindo a verificação da qualidade do ficheiro e da adequação do workflow."),
        section("5. Responsabilidades do utilizador", "Continua a ser responsável pelos seus ficheiros e pelo direito de os processar.", [
          "Guarde cópias de segurança dos originais importantes.",
          "Verifique a qualidade do resultado antes de uso crítico.",
          "Respeite direitos de autor e outras obrigações legais.",
        ]),
        section("6. Contacto", "Se tiver dúvidas sobre estes termos, contacte-nos através do website."),
      ],
    },
    blog: {
      description: "Leia os nossos artigos mais recentes sobre ferramentas PDF, processamento de imagem e produtividade.",
      intro: "Explore artigos práticos sobre documentos, imagens e workflows digitais.",
      noTools: "Nenhum resultado encontrado.",
      clear: "Limpar pesquisa",
    },
    toolsPage: {
      description: "Consulte a nossa coleção completa de ferramentas online gratuitas e encontre exatamente o que precisa.",
      intro: "Esta página central ajuda visitantes e motores de busca a compreender toda a biblioteca de ferramentas da Dogufy e a chegar rapidamente à página certa.",
      searchPlaceholder: "Pesquisar uma ferramenta (ex.: merge, image, pdf)...",
      noResultsTitle: "Nenhuma ferramenta encontrada",
      noResultsBody: "Não encontrámos ferramentas que correspondam à sua pesquisa. Tente outra palavra-chave ou categoria.",
      didYouKnow: "Sabia que?",
      didYouKnowBody: "Muitos workflows acontecem diretamente no navegador, ajudando a manter o tratamento de documentos mais rápido e mais privado.",
      whatMakesUseful: "O que torna esta ferramenta útil?",
      howToOnline: "Como utilizar esta ferramenta online",
      uploadOrEnter: "Carregue ou introduza dados",
      configure: "Configurar definições",
      processDownload: "Processar e descarregar",
      bestUseCases: "Melhores casos de uso",
      whyChoose: "Porque escolher a Dogufy para esta ferramenta?",
      fastFree: "Rápido e gratuito",
      fastFreeBody: "Use o workflow rapidamente sem barreiras de registo.",
      securePrivate: "Seguro e privado",
      securePrivateBody: "A experiência foi concebida para reduzir a exposição desnecessária dos ficheiros do utilizador.",
      highQuality: "Alta qualidade",
      highQualityBody: "Procuramos manter uma qualidade de saída útil enquanto simplificamos o processo.",
      relatedCategory: "Ferramentas relacionadas",
      removeFile: "Remover ficheiro",
      convertedImages: "Imagens convertidas",
      downloadAll: "Descarregar tudo",
      downloadPage: "Descarregar página",
      pageLabel: "Página",
      convertingPdf: "A converter PDF...",
      convertingPdfToImages: "A converter PDF em imagens...",
      complete: "concluído",
      completed: "concluído",
      convertToPng: "Converter para PNG",
      convertToPngDescription: "Converta páginas PDF em imagens PNG de alta qualidade com suporte a transparência.",
      convertToJpg: "Converter para JPG",
      convertToJpgDescription: "Converta páginas PDF em imagens JPG de alta qualidade.",
      invalidPdfFile: "Selecione um ficheiro PDF.",
      pdfToPngError: "Erro ao converter PDF para PNG",
      pdfConversionError: "Erro ao converter o PDF. Tente novamente.",
      convertToWord: "Converter para Word",
      convertToWordDescription: "Converta os seus ficheiros PDF em documentos Word editáveis (DOCX).",
      convertToWordButton: "Converter para Word (.docx)",
      convertingToWord: "A converter para Word...",
      pdfToWordError: "Erro ao converter PDF para Word. Tente novamente.",
      convertToPdf: "Converter para PDF",
      convertingToPdf: "A converter para PDF...",
      wordToPdfError: "Erro ao converter Word para PDF. Tente novamente.",
      mergePdfTitle: "Unir ficheiros PDF",
      mergePdfDescription: "Combine vários ficheiros PDF num único documento. Arraste e solte para reordenar.",
      mergePdfHint: "Selecione 2 ou mais ficheiros PDF para unir",
      filesToMerge: "Ficheiros para unir",
      clearAll: "Limpar tudo",
      moveUp: "Mover para cima",
      moveDown: "Mover para baixo",
      merging: "A unir...",
      mergePdfs: "Unir PDFs",
      mergePdfError: "Erro ao unir PDFs. Certifique-se de que todos os ficheiros são PDFs válidos.",
    },
  },
  th: {
    landing: {
      toolsDescription: "สำรวจเครื่องมือออนไลน์ฟรีที่มีคนใช้มากที่สุดของเรา ปลอดภัย รวดเร็ว และใช้งานง่าย",
      useCasesTitle: "การใช้งานที่เหมาะสม",
      useCasesDescription: "ดูว่า Dogufy ช่วยผู้ใช้งานแต่ละกลุ่มให้ทำงานเสร็จเร็วขึ้นได้อย่างไร",
      useCases: [
        item("สำหรับนักเรียนและงานวิชาการ", "รวมงาน ส่งบีบอัดไฟล์วิทยานิพนธ์ และแปลงเอกสารวิจัยเป็นไฟล์ที่แก้ไขได้"),
        item("สำหรับมืออาชีพด้านธุรกิจ", "เซ็นสัญญา รวมรายงาน และแปลงสเปรดชีตเป็น PDF ที่แชร์ได้ง่าย"),
        item("สำหรับนักออกแบบและสายครีเอทีฟ", "ปรับแต่งภาพ ลบพื้นหลัง และแปลงไฟล์งานให้เร็วขึ้น"),
        item("สำหรับทีมกฎหมาย", "จัดการเอกสารสำคัญด้วย workflow ที่เป็นส่วนตัวและเป็นระเบียบมากขึ้น"),
        item("สำหรับนายหน้าอสังหาริมทรัพย์", "เตรียมโบรชัวร์ เอกสารทรัพย์สิน และสื่อประกาศขายได้มีประสิทธิภาพกว่าเดิม"),
      ],
      useCasesCta: "ลองใช้เครื่องมือ",
      processDescription: "ง่าย เร็ว และปลอดภัย เตรียมเอกสารของคุณให้พร้อมใน 4 ขั้นตอน",
      processSteps: [
        step("01", "เลือกเครื่องมือ", "เลือก workflow ที่เหมาะสมจากชุดเครื่องมือ PDF รูปภาพ และข้อความของเรา"),
        step("02", "อัปโหลดไฟล์", "ลากไฟล์ลงในเบราว์เซอร์และตั้งค่าตัวเลือกที่มีให้"),
        step("03", "ประมวลผลในไม่กี่วินาที", "เริ่มงานได้ทันทีโดยไม่ต้องติดตั้งซอฟต์แวร์เพิ่ม"),
        step("04", "ดาวน์โหลดและแชร์", "รับผลลัพธ์ทันทีและทำงานต่อได้เลย"),
      ],
      featuresDescription: "เราให้บริการเครื่องมือฟรีที่ออกแบบมาเพื่อความเร็ว ความเป็นส่วนตัว และ workflow ที่ใช้งานได้จริง",
      features: [
        item("ฟรีตลอดไป", "ใช้งานได้โดยไม่มีค่าสมาชิก ค่าธรรมเนียมแอบแฝง หรือกำแพงการชำระเงิน"),
        item("ปลอดภัยและเป็นส่วนตัว", "workflow ที่คำนึงถึงความเป็นส่วนตัวช่วยให้ไฟล์สำคัญอยู่ในการควบคุม"),
        item("เร็วมาก", "workflow บนเบราว์เซอร์ช่วยลดเวลาที่เสียไปกับงานซ้ำ ๆ"),
        item("ใช้งานง่าย", "อินเทอร์เฟซออกแบบให้ใช้งานได้สบายแม้กับผู้ใช้ที่ไม่ใช่สายเทคนิค"),
        item("รองรับมือถือ", "ประสบการณ์ใช้งานทำงานได้ดีบนเดสก์ท็อป แท็บเล็ต และมือถือ"),
        item("คุณภาพสูง", "เราพยายามรักษาคุณภาพผลลัพธ์ที่ใช้งานได้จริงพร้อมทำให้ขั้นตอนง่ายขึ้น"),
      ],
      testimonialsDescription: "ดูว่าผู้ใช้พูดถึง Dogufy อย่างไรบ้าง",
      testimonials: [
        quote("Dogufy ช่วยให้ฉันรวมบทวิทยานิพนธ์ได้รวดเร็วโดยไม่ต้องยุ่งยากเกินจำเป็น", "Sarah J.", "นักศึกษาปริญญาโท"),
        quote("ฉันใช้เครื่องมือภาพเป็นประจำสำหรับงานเว็บ เพราะมันเร็วและสะดวกมาก", "Mike T.", "นักพัฒนา Frontend"),
        quote("เครื่องมือแปลงเอกสารช่วยประหยัดเวลามากเวลาที่ต้องเตรียมไฟล์เวอร์ชันแก้ไขได้", "Emily R.", "ผู้ช่วยฝ่ายกฎหมาย"),
      ],
      landingContactDescription: "ติดต่อเราได้หากคุณอยากคุยเรื่องโปรดักต์ เสนอแนะแนวทางปรับปรุง หรือมีคำถาม",
      sayHi: "ทักทาย",
      getQuote: "ขอใบเสนอราคา",
      name: "ชื่อ",
      email: "อีเมล",
      message: "ข้อความ",
      send: "ส่งข้อความ",
    },
    about: {
      intro: "ยินดีต้อนรับสู่ Dogufy โซลูชันครบวงจรสำหรับงานเอกสาร รูปภาพ และข้อความ",
      missionBody: "เราเชื่อว่าเครื่องมือเพิ่มประสิทธิภาพที่ทรงพลังควรเข้าถึงได้สำหรับทุกคน ภารกิจของเราคือมอบเครื่องมือออนไลน์ฟรีคุณภาพสูงที่ช่วยให้ผู้ใช้ทำงานได้เร็วขึ้นโดยไม่ต้องพึ่งซอฟต์แวร์ราคาแพงหรือการตั้งค่าที่ยุ่งยาก",
      offers: [
        "เครื่องมือ PDF สำหรับแปลงไฟล์ รวมไฟล์ แยกไฟล์ บีบอัด และแก้ไขเอกสาร",
        "เครื่องมือภาพสำหรับปรับขนาด บีบอัด แปลงไฟล์ และทำความสะอาด asset ภาพ",
        "เครื่องมือข้อความสำหรับจัดรูปแบบ แปลง และวิเคราะห์เนื้อหา",
        "ยูทิลิตี้สำหรับนักพัฒนา เช่น ตัวสร้าง QR ตัวสร้าง UUID และเครื่องมือช่วยงานอื่น ๆ",
      ],
      privacyTitle: "ให้ความสำคัญกับความเป็นส่วนตัว",
      privacyBody: "การประมวลผลส่วนใหญ่เกิดขึ้นในเบราว์เซอร์โดยตรง ไฟล์ของคุณยังอยู่ในการควบคุมของคุณ ช่วยให้ workflow รวดเร็ว เป็นส่วนตัว และปลอดภัย",
      freeTitle: "ฟรี 100%",
      freeBody: "เครื่องมือของเราใช้งานได้โดยไม่มีค่าสมาชิก ค่าใช้จ่ายแอบแฝง หรือกำแพงการสมัครสมาชิก",
    },
    contact: {
      sentTitle: "ส่งข้อความแล้ว!",
      sentBody: "ขอบคุณที่ติดต่อเรา เราจะตอบกลับโดยเร็วที่สุด",
      labels: { name: "ชื่อ", email: "อีเมล", subject: "หัวข้อ", message: "ข้อความ" },
      placeholders: {
        name: "ชื่อของคุณ",
        email: "your.email@example.com",
        subject: "ติดต่อเรื่องอะไร?",
        message: "เล่าให้เราฟังเพิ่มเติม...",
      },
      github: "GitHub",
      githubBody: "พบปัญหาหรืออยากมีส่วนร่วม? ไปดูที่ repository ของเราได้เลย",
      viewRepo: "ดู repository",
    },
    privacy: {
      sections: [
        section("ความเป็นส่วนตัวของคุณสำคัญ", "เราให้ความสำคัญกับความเป็นส่วนตัวอย่างจริงจังและพยายามลดการเก็บข้อมูลที่ไม่จำเป็น"),
        section("การประมวลผลข้อมูล", "เครื่องมือส่วนใหญ่ประมวลผลไฟล์ในเบราว์เซอร์ของคุณโดยตรง บางงานแปลงขั้นสูงอาจต้องใช้การประมวลผลชั่วคราวบนเซิร์ฟเวอร์", [
          "โดยทั่วไปไฟล์จะยังอยู่บนอุปกรณ์ของคุณระหว่างการประมวลผล",
          "งานชั่วคราวบนเซิร์ฟเวอร์จะถูกลบหลังจากเสร็จสิ้น",
          "เราไม่ได้ตั้งใจเก็บเนื้อหาเอกสารของคุณไว้",
        ]),
        section("ข้อมูลที่เราเก็บ", undefined, [
          "การวิเคราะห์แบบไม่ระบุตัวตนจะเปิดใช้งานหลังจากได้รับความยินยอมเท่านั้น",
          "ไม่ต้องสร้างบัญชีเพื่อใช้เครื่องมือหลัก",
          "ไม่มีการเก็บไฟล์ที่อัปโหลดแบบถาวร",
        ]),
        section("คุกกี้", undefined, [
          "การบันทึกตัวเลือกความยินยอม",
          "ความปลอดภัยและฟังก์ชันหลักของเว็บไซต์",
          "การวิเคราะห์เพิ่มเติมหลังจากได้รับอนุญาตอย่างชัดเจน",
        ]),
        section("สิทธิของคุณ", "คุณสามารถปฏิเสธการวิเคราะห์ ล้างข้อมูลในเบราว์เซอร์ และหยุดใช้บริการได้ทุกเมื่อ"),
      ],
    },
    terms: {
      sections: [
        section("1. การยอมรับเงื่อนไข", "เมื่อใช้ Dogufy คุณตกลงตามเงื่อนไขเหล่านี้"),
        section("2. การใช้บริการ", "บริการนี้จัดทำขึ้นเพื่อการใช้งานด้านประสิทธิภาพส่วนบุคคลและเชิงพาณิชย์", [
          "ใช้บริการอย่างถูกกฎหมาย",
          "ห้ามทำให้แพลตฟอร์มทำงานหนักเกิน ใช้ประโยชน์ในทางที่ผิด หรือโจมตีแพลตฟอร์ม",
          "ห้ามใช้เครื่องมือเพื่อจุดประสงค์ที่เป็นอันตรายหรือมุ่งร้าย",
        ]),
        section("3. ความพร้อมใช้งานของบริการ", "เราพยายามให้บริการมีความเสถียร แต่ไม่สามารถรับประกันการเข้าถึงแบบต่อเนื่องหรือปราศจากข้อผิดพลาดได้"),
        section("4. ข้อจำกัดความรับผิด", "การใช้บริการเป็นความเสี่ยงของผู้ใช้เอง รวมถึงการตรวจสอบคุณภาพไฟล์ผลลัพธ์และความเหมาะสมของ workflow"),
        section("5. ความรับผิดชอบของผู้ใช้", "คุณยังคงเป็นผู้รับผิดชอบไฟล์ของคุณและสิทธิ์ในการประมวลผลไฟล์เหล่านั้น", [
          "เก็บสำรองต้นฉบับที่สำคัญไว้เสมอ",
          "ตรวจสอบคุณภาพผลลัพธ์ก่อนใช้งานในงานสำคัญ",
          "เคารพลิขสิทธิ์และข้อผูกพันทางกฎหมายอื่น ๆ",
        ]),
        section("6. การติดต่อ", "หากคุณมีคำถามเกี่ยวกับเงื่อนไขเหล่านี้ โปรดติดต่อเราผ่านเว็บไซต์"),
      ],
    },
    blog: {
      description: "อ่านบทความล่าสุดของเราเกี่ยวกับเครื่องมือ PDF การประมวลผลภาพ และงานเพิ่มประสิทธิภาพ",
      intro: "สำรวจบทความเชิงปฏิบัติเกี่ยวกับเอกสาร รูปภาพ และ workflow ดิจิทัล",
      noTools: "ไม่พบผลลัพธ์",
      clear: "ล้างการค้นหา",
    },
    toolsPage: {
      description: "ดูชุดเครื่องมือออนไลน์ฟรีทั้งหมดของเราและค้นหา workflow ที่คุณต้องการได้อย่างแม่นยำ",
      intro: "หน้าศูนย์รวมนี้ช่วยให้ผู้ใช้และเครื่องมือค้นหาเข้าใจคลังเครื่องมือทั้งหมดของ Dogufy และไปยังหน้าที่ถูกต้องได้รวดเร็ว",
      searchPlaceholder: "ค้นหาเครื่องมือ (เช่น merge, image, pdf)...",
      noResultsTitle: "ไม่พบเครื่องมือ",
      noResultsBody: "เราไม่พบเครื่องมือที่ตรงกับการค้นหาของคุณ ลองใช้คีย์เวิร์ดหรือหมวดหมู่อื่น",
      didYouKnow: "คุณรู้ไหมว่า",
      didYouKnowBody: "หลาย workflow ทำงานได้โดยตรงในเบราว์เซอร์ ช่วยให้การจัดการเอกสารเร็วขึ้นและเป็นส่วนตัวมากขึ้น",
      whatMakesUseful: "อะไรทำให้เครื่องมือนี้มีประโยชน์",
      howToOnline: "วิธีใช้เครื่องมือนี้ออนไลน์",
      uploadOrEnter: "อัปโหลดหรือกรอกข้อมูล",
      configure: "ตั้งค่าตัวเลือก",
      processDownload: "ประมวลผลและดาวน์โหลด",
      bestUseCases: "เคสการใช้งานที่เหมาะที่สุด",
      whyChoose: "ทำไมต้องเลือก Dogufy สำหรับเครื่องมือนี้",
      fastFree: "เร็วและฟรี",
      fastFreeBody: "ใช้งาน workflow ได้รวดเร็วโดยไม่ต้องเจอกำแพงการสมัคร",
      securePrivate: "ปลอดภัยและเป็นส่วนตัว",
      securePrivateBody: "ประสบการณ์นี้ออกแบบมาเพื่อลดการเปิดเผยไฟล์ของผู้ใช้โดยไม่จำเป็น",
      highQuality: "คุณภาพสูง",
      highQualityBody: "เราพยายามรักษาคุณภาพผลลัพธ์ที่ใช้งานได้จริงพร้อมทำให้ขั้นตอนง่ายขึ้น",
      relatedCategory: "เครื่องมือที่เกี่ยวข้อง",
      removeFile: "ลบไฟล์",
      convertedImages: "รูปภาพที่แปลงแล้ว",
      downloadAll: "ดาวน์โหลดทั้งหมด",
      downloadPage: "ดาวน์โหลดหน้า",
      pageLabel: "หน้า",
      convertingPdf: "กำลังแปลง PDF...",
      convertingPdfToImages: "กำลังแปลง PDF เป็นรูปภาพ...",
      complete: "เสร็จสิ้น",
      completed: "เสร็จแล้ว",
      convertToPng: "แปลงเป็น PNG",
      convertToPngDescription: "แปลงหน้า PDF เป็นภาพ PNG คุณภาพสูงพร้อมรองรับความโปร่งใส",
      convertToJpg: "แปลงเป็น JPG",
      convertToJpgDescription: "แปลงหน้า PDF เป็นภาพ JPG คุณภาพสูง",
      invalidPdfFile: "กรุณาเลือกไฟล์ PDF",
      pdfToPngError: "เกิดข้อผิดพลาดในการแปลง PDF เป็น PNG",
      pdfConversionError: "เกิดข้อผิดพลาดในการแปลง PDF กรุณาลองอีกครั้ง",
      convertToWord: "แปลงเป็น Word",
      convertToWordDescription: "แปลงไฟล์ PDF ของคุณเป็นเอกสาร Word ที่แก้ไขได้ (DOCX)",
      convertToWordButton: "แปลงเป็น Word (.docx)",
      convertingToWord: "กำลังแปลงเป็น Word...",
      pdfToWordError: "เกิดข้อผิดพลาดในการแปลง PDF เป็น Word กรุณาลองอีกครั้ง",
      convertToPdf: "แปลงเป็น PDF",
      convertingToPdf: "กำลังแปลงเป็น PDF...",
      wordToPdfError: "เกิดข้อผิดพลาดในการแปลง Word เป็น PDF กรุณาลองอีกครั้ง",
      mergePdfTitle: "รวมไฟล์ PDF",
      mergePdfDescription: "รวมไฟล์ PDF หลายไฟล์เป็นเอกสารเดียว ลากเพื่อจัดเรียงลำดับไฟล์ใหม่",
      mergePdfHint: "เลือกไฟล์ PDF อย่างน้อย 2 ไฟล์เพื่อรวม",
      filesToMerge: "ไฟล์ที่จะรวม",
      clearAll: "ล้างทั้งหมด",
      moveUp: "ย้ายขึ้น",
      moveDown: "ย้ายลง",
      merging: "กำลังรวม...",
      mergePdfs: "รวม PDF",
      mergePdfError: "เกิดข้อผิดพลาดในการรวม PDF โปรดตรวจสอบว่าไฟล์ทั้งหมดเป็น PDF ที่ถูกต้อง",
    },
  },
  tr: {
    landing: {
      toolsDescription: "En çok kullanılan ücretsiz çevrimiçi araçlarımızı keşfedin. Güvenli, hızlı ve kullanımı kolay.",
      useCasesTitle: "Kullanım senaryoları",
      useCasesDescription: "Dogufy'nin farklı kullanıcı gruplarına nasıl daha hızlı sonuç aldırdığını görün.",
      useCases: [
        item("Öğrenciler ve akademisyenler için", "Ödevleri birleştirin, tez dosyalarını sıkıştırın ve araştırma belgelerini düzenlenebilir formatlara dönüştürün."),
        item("İş profesyonelleri için", "Sözleşme imzalayın, raporları birleştirin ve tabloları paylaşılabilir PDF dosyalarına dönüştürün."),
        item("Tasarımcılar ve kreatif ekipler için", "Görselleri optimize edin, arka planları kaldırın ve varlıkları daha hızlı dönüştürün."),
        item("Hukuk ekipleri için", "Hassas belgeleri daha özel workflow'lar ve daha düzenli dosya yapısıyla yönetin."),
        item("Emlak danışmanları için", "Broşürleri, mülk dosyalarını ve ilan görsellerini daha verimli hazırlayın."),
      ],
      useCasesCta: "Araçları dene",
      processDescription: "Basit, hızlı ve güvenli. Belgelerinizi 4 kolay adımda hazır hale getirin.",
      processSteps: [
        step("01", "Aracı seçin", "PDF, görsel ve metin araç koleksiyonumuzdan doğru workflow'u seçin."),
        step("02", "Dosyaları yükleyin", "Dosyanızı tarayıcıya sürükleyin ve mevcut seçenekleri ayarlayın."),
        step("03", "Saniyeler içinde işleyin", "Ek yazılım kurmadan görevi hemen çalıştırın."),
        step("04", "İndirin ve paylaşın", "Sonucu anında alın ve işinize devam edin."),
      ],
      featuresDescription: "Hız, gizlilik ve pratik kullanım için oluşturulmuş ücretsiz çevrimiçi araçlar sunuyoruz.",
      features: [
        item("Her zaman ücretsiz", "Abonelik, gizli ücret veya ödeme duvarı olmadan araçları kullanın."),
        item("Güvenli ve özel", "Gizlilik odaklı workflow'lar hassas dosyaları daha kontrollü tutmanıza yardımcı olur."),
        item("Çok hızlı", "Tarayıcı tabanlı workflow'lar tekrar eden işlere harcanan süreyi azaltır."),
        item("Kullanımı kolay", "Arayüz, teknik olmayan kullanıcılar için de rahat olacak şekilde tasarlanmıştır."),
        item("Mobil uyumlu", "Deneyim masaüstü, tablet ve mobilde sorunsuz çalışır."),
        item("Yüksek kalite", "Süreci basitleştirirken faydalı çıktı kalitesini korumaya çalışıyoruz."),
      ],
      testimonialsDescription: "Kullanıcıların Dogufy hakkında neler söylediğine bakın.",
      testimonials: [
        quote("Dogufy tez bölümlerimi gereksiz karmaşa olmadan hızlıca birleştirmeme yardımcı oldu.", "Sarah J.", "Yüksek lisans öğrencisi"),
        quote("Web işleri için görsel araçlarını düzenli kullanıyorum çünkü hızlı ve pratikler.", "Mike T.", "Frontend geliştirici"),
        quote("Belge dönüştürme araçları, düzenlenebilir sürümler hazırlarken ciddi zaman kazandırıyor.", "Emily R.", "Hukuk asistanı"),
      ],
      landingContactDescription: "Ürün hakkında konuşmak, geliştirme önermek veya soru sormak isterseniz bize ulaşın.",
      sayHi: "Merhaba de",
      getQuote: "Teklif al",
      name: "Ad",
      email: "E-posta",
      message: "Mesaj",
      send: "Mesaj gönder",
    },
    about: {
      intro: "Dogufy'ye hoş geldiniz. Belge, görsel ve metin ihtiyaçlarınız için tek durak çözümünüz.",
      missionBody: "Güçlü üretkenlik araçlarının herkes için erişilebilir olması gerektiğine inanıyoruz. Misyonumuz, pahalı yazılım veya karmaşık kurulum gerekmeden daha hızlı çalışmayı sağlayan ücretsiz ve yüksek kaliteli çevrimiçi araçlar sunmaktır.",
      offers: [
        "Belgeleri dönüştürmek, birleştirmek, bölmek, sıkıştırmak ve düzenlemek için PDF araçları.",
        "Görselleri yeniden boyutlandırmak, sıkıştırmak, dönüştürmek ve temizlemek için görsel araçları.",
        "İçeriği biçimlendirmek, dönüştürmek ve analiz etmek için metin araçları.",
        "QR oluşturucu, UUID oluşturucu ve diğer hızlı yardımcılar gibi geliştirici araçları.",
      ],
      privacyTitle: "Önce gizlilik",
      privacyBody: "Çoğu dosya işleme doğrudan tarayıcıda gerçekleşir. Dosyalarınız sizin kontrolünüzde kalır; bu da workflow'u daha hızlı, daha özel ve daha güvenli yapar.",
      freeTitle: "Tamamen ücretsiz",
      freeBody: "Araçlarımız abonelik, gizli ücret veya kayıt engeli olmadan kullanılabilir.",
    },
    contact: {
      sentTitle: "Mesaj gönderildi!",
      sentBody: "Bize ulaştığınız için teşekkürler. En kısa sürede dönüş yapacağız.",
      labels: { name: "Ad", email: "E-posta", subject: "Konu", message: "Mesaj" },
      placeholders: {
        name: "Adınız",
        email: "eposta@ornek.com",
        subject: "Bu neyle ilgili?",
        message: "Bize biraz daha anlatın...",
      },
      github: "GitHub",
      githubBody: "Bir hata mı buldunuz veya katkı mı sunmak istiyorsunuz? Depoya göz atın.",
      viewRepo: "Depoyu görüntüle",
    },
    privacy: {
      sections: [
        section("Gizliliğiniz önemlidir", "Gizliliği ciddiye alıyor ve gereksiz veri toplamayı en aza indirmeye çalışıyoruz."),
        section("Veri işleme", "Araçların çoğu dosyaları tarayıcınızda yerel olarak işler. Bazı gelişmiş dönüşümler geçici sunucu tarafı işleme gerektirebilir.", [
          "Dosyalar işleme sırasında genellikle cihazınızda kalır.",
          "Geçici sunucu işleri tamamlandıktan sonra silinir.",
          "Belgelerinizin içeriğini bilerek saklamayız.",
        ]),
        section("Topladığımız bilgiler", undefined, [
          "Anonim analiz yalnızca onay sonrasında etkinleşir.",
          "Temel araçlar için hesap gerekmez.",
          "Yüklenen dosyalar kalıcı olarak saklanmaz.",
        ]),
        section("Çerezler", undefined, [
          "Onay tercihi depolaması.",
          "Güvenlik ve temel site işlevleri.",
          "Açık izin sonrası isteğe bağlı analiz.",
        ]),
        section("Haklarınız", "Analizi reddedebilir, tarayıcıdaki yerel verileri temizleyebilir ve hizmeti dilediğiniz zaman bırakabilirsiniz."),
      ],
    },
    terms: {
      sections: [
        section("1. Şartların kabulü", "Dogufy'yi kullanarak bu şartları kabul etmiş olursunuz."),
        section("2. Hizmetin kullanımı", "Hizmet kişisel ve ticari üretkenlik ihtiyaçları için sunulur.", [
          "Hizmeti yasal şekilde kullanın.",
          "Platformu aşırı yüklemeyin, suistimal etmeyin veya istismar etmeyin.",
          "Araçları zararlı veya kötü niyetli amaçlarla kullanmayın.",
        ]),
        section("3. Hizmet erişilebilirliği", "Güvenilirliği hedefliyoruz ancak kesintisiz erişim veya hatasız çalışma garanti edemeyiz."),
        section("4. Sorumluluğun sınırlandırılması", "Hizmeti kullanmak, çıktı kalitesini ve workflow uygunluğunu kontrol etmek dahil olmak üzere sizin sorumluluğunuzdadır."),
        section("5. Kullanıcı sorumlulukları", "Dosyalarınız ve bunları işleme hakkınızdan siz sorumlusunuz.", [
          "Önemli orijinallerin yedeğini saklayın.",
          "Kritik kullanımdan önce çıktı kalitesini doğrulayın.",
          "Telif hakkı ve diğer yasal yükümlülüklere uyun.",
        ]),
        section("6. İletişim", "Bu şartlarla ilgili sorularınız varsa lütfen web sitesi üzerinden bizimle iletişime geçin."),
      ],
    },
    blog: {
      description: "PDF araçları, görsel işleme ve verimlilik hakkındaki en son makalelerimizi okuyun.",
      intro: "Belgeler, görseller ve dijital workflow'lar hakkında pratik makaleleri keşfedin.",
      noTools: "Sonuç bulunamadı.",
      clear: "Aramayı temizle",
    },
    toolsPage: {
      description: "Ücretsiz çevrimiçi araç koleksiyonumuzun tamamına göz atın ve tam ihtiyacınız olan workflow'u bulun.",
      intro: "Bu merkez sayfa, ziyaretçilerin ve arama motorlarının Dogufy'nin tüm araç kütüphanesini anlamasına ve doğru sayfaya hızla ulaşmasına yardımcı olur.",
      searchPlaceholder: "Bir araç ara (ör. merge, image, pdf)...",
      noResultsTitle: "Araç bulunamadı",
      noResultsBody: "Aramanızla eşleşen bir araç bulamadık. Farklı bir anahtar kelime veya kategori deneyin.",
      didYouKnow: "Biliyor muydunuz?",
      didYouKnowBody: "Birçok workflow doğrudan tarayıcıda gerçekleşir; bu da belge işlemlerini daha hızlı ve daha gizli tutar.",
      whatMakesUseful: "Bu aracı faydalı yapan nedir?",
      howToOnline: "Bu araç çevrimiçi nasıl kullanılır",
      uploadOrEnter: "Veri yükleyin veya girin",
      configure: "Ayarları yapılandırın",
      processDownload: "İşleyin ve indirin",
      bestUseCases: "En iyi kullanım senaryoları",
      whyChoose: "Bu araç için neden Dogufy seçilmeli?",
      fastFree: "Hızlı ve ücretsiz",
      fastFreeBody: "Kayıt engeli olmadan workflow'u hızlıca kullanın.",
      securePrivate: "Güvenli ve özel",
      securePrivateBody: "Deneyim, kullanıcı dosyalarının gereksiz şekilde açığa çıkmasını azaltmak için tasarlanmıştır.",
      highQuality: "Yüksek kalite",
      highQualityBody: "Süreci basitleştirirken faydalı çıktı kalitesini korumaya çalışıyoruz.",
      relatedCategory: "İlgili araçlar",
      removeFile: "Dosyayı kaldır",
      convertedImages: "Dönüştürülen görseller",
      downloadAll: "Tümünü indir",
      downloadPage: "Sayfayı indir",
      pageLabel: "Sayfa",
      convertingPdf: "PDF dönüştürülüyor...",
      convertingPdfToImages: "PDF görsellere dönüştürülüyor...",
      complete: "tamamlandı",
      completed: "bitti",
      convertToPng: "PNG'ye dönüştür",
      convertToPngDescription: "PDF sayfalarını şeffaflık destekli yüksek kaliteli PNG görsellerine dönüştürün.",
      convertToJpg: "JPG'ye dönüştür",
      convertToJpgDescription: "PDF sayfalarını yüksek kaliteli JPG görsellerine dönüştürün.",
      invalidPdfFile: "Lütfen bir PDF dosyası seçin.",
      pdfToPngError: "PDF'yi PNG'ye dönüştürürken hata oluştu",
      pdfConversionError: "PDF dönüştürülürken hata oluştu. Lütfen tekrar deneyin.",
      convertToWord: "Word'e dönüştür",
      convertToWordDescription: "PDF dosyalarınızı düzenlenebilir Word belgelerine (DOCX) dönüştürün.",
      convertToWordButton: "Word'e dönüştür (.docx)",
      convertingToWord: "Word'e dönüştürülüyor...",
      pdfToWordError: "PDF'yi Word'e dönüştürürken hata oluştu. Lütfen tekrar deneyin.",
      convertToPdf: "PDF'ye dönüştür",
      convertingToPdf: "PDF'ye dönüştürülüyor...",
      wordToPdfError: "Word'ü PDF'ye dönüştürürken hata oluştu. Lütfen tekrar deneyin.",
      mergePdfTitle: "PDF dosyalarını birleştir",
      mergePdfDescription: "Birden fazla PDF dosyasını tek belgede birleştirin. Sıralamak için sürükleyip bırakın.",
      mergePdfHint: "Birleştirmek için 2 veya daha fazla PDF dosyası seçin",
      filesToMerge: "Birleştirilecek dosyalar",
      clearAll: "Tümünü temizle",
      moveUp: "Yukarı taşı",
      moveDown: "Aşağı taşı",
      merging: "Birleştiriliyor...",
      mergePdfs: "PDF'leri birleştir",
      mergePdfError: "PDF'ler birleştirilirken hata oluştu. Lütfen tüm dosyaların geçerli PDF olduğundan emin olun.",
    },
  },
  el: {
    landing: {
      toolsDescription: "Εξερευνήστε τα πιο δημοφιλή δωρεάν online εργαλεία μας. Ασφαλή, γρήγορα και εύχρηστα.",
      useCasesTitle: "Περιπτώσεις χρήσης",
      useCasesDescription: "Δείτε πώς το Dogufy βοηθά διαφορετικούς χρήστες να ολοκληρώνουν τη δουλειά τους πιο γρήγορα.",
      useCases: [
        item("Για φοιτητές και ακαδημαϊκούς", "Συγχωνεύστε εργασίες, συμπιέστε διατριβές και μετατρέψτε ερευνητικά έγγραφα σε επεξεργάσιμες μορφές."),
        item("Για επαγγελματίες επιχειρήσεων", "Υπογράψτε συμβόλαια, ενώστε αναφορές και μετατρέψτε υπολογιστικά φύλλα σε PDF που μοιράζονται εύκολα."),
        item("Για designers και δημιουργικούς", "Βελτιστοποιήστε εικόνες, αφαιρέστε φόντο και μετατρέψτε assets πιο γρήγορα."),
        item("Για νομικές ομάδες", "Διαχειριστείτε ευαίσθητα έγγραφα με πιο ιδιωτικά workflow και καλύτερη οργάνωση."),
        item("Για μεσίτες ακινήτων", "Προετοιμάστε φυλλάδια, φακέλους ακινήτων και υλικό listing πιο αποδοτικά."),
      ],
      useCasesCta: "Δοκιμάστε εργαλεία",
      processDescription: "Απλό, γρήγορο και ασφαλές. Ετοιμάστε τα έγγραφά σας σε 4 βήματα.",
      processSteps: [
        step("01", "Επιλέξτε εργαλείο", "Διαλέξτε το σωστό workflow από τη συλλογή εργαλείων PDF, εικόνας και κειμένου."),
        step("02", "Ανεβάστε αρχεία", "Σύρετε το αρχείο στον browser και ρυθμίστε τις διαθέσιμες επιλογές."),
        step("03", "Επεξεργασία σε δευτερόλεπτα", "Εκτελέστε την εργασία άμεσα χωρίς επιπλέον εγκατάσταση."),
        step("04", "Κατεβάστε και μοιραστείτε", "Πάρτε το αποτέλεσμα αμέσως και συνεχίστε τη δουλειά σας."),
      ],
      featuresDescription: "Προσφέρουμε δωρεάν εργαλεία φτιαγμένα για ταχύτητα, ιδιωτικότητα και πρακτικά workflow.",
      features: [
        item("Δωρεάν για πάντα", "Χρησιμοποιήστε τα εργαλεία χωρίς συνδρομές, κρυφές χρεώσεις ή paywall."),
        item("Ασφαλές και ιδιωτικό", "Τα workflow με έμφαση στην ιδιωτικότητα βοηθούν να κρατάτε τα ευαίσθητα αρχεία υπό έλεγχο."),
        item("Πολύ γρήγορο", "Τα workflow στον browser μειώνουν τον χρόνο που ξοδεύεται σε επαναλαμβανόμενες εργασίες."),
        item("Εύκολο στη χρήση", "Το περιβάλλον είναι σχεδιασμένο ώστε να είναι άνετο ακόμη και για μη τεχνικούς χρήστες."),
        item("Φιλικό σε mobile", "Η εμπειρία λειτουργεί σε desktop, tablet και κινητό."),
        item("Υψηλή ποιότητα", "Στόχος μας είναι να διατηρούμε χρήσιμη ποιότητα εξόδου ενώ απλοποιούμε τη διαδικασία."),
      ],
      testimonialsDescription: "Δείτε τι λένε οι χρήστες για το Dogufy.",
      testimonials: [
        quote("Το Dogufy με βοήθησε να ενώσω γρήγορα κεφάλαια της διπλωματικής μου χωρίς περιττή πολυπλοκότητα.", "Sarah J.", "Μεταπτυχιακή φοιτήτρια"),
        quote("Χρησιμοποιώ συχνά τα εργαλεία εικόνας για web δουλειά γιατί είναι γρήγορα και πρακτικά.", "Mike T.", "Frontend developer"),
        quote("Τα εργαλεία μετατροπής εγγράφων μου εξοικονομούν χρόνο όταν ετοιμάζω επεξεργάσιμες εκδόσεις.", "Emily R.", "Νομική βοηθός"),
      ],
      landingContactDescription: "Επικοινωνήστε μαζί μας αν θέλετε να μιλήσετε για το προϊόν, να προτείνετε βελτιώσεις ή να κάνετε μια ερώτηση.",
      sayHi: "Πείτε γεια",
      getQuote: "Ζητήστε προσφορά",
      name: "Όνομα",
      email: "Email",
      message: "Μήνυμα",
      send: "Αποστολή μηνύματος",
    },
    about: {
      intro: "Καλώς ήρθατε στο Dogufy, τη λύση σας για έγγραφα, εικόνες και κείμενο σε ένα μέρος.",
      missionBody: "Πιστεύουμε ότι τα ισχυρά εργαλεία παραγωγικότητας πρέπει να είναι προσβάσιμα σε όλους. Αποστολή μας είναι να προσφέρουμε δωρεάν, ποιοτικά online εργαλεία που βοηθούν τους χρήστες να δουλεύουν πιο γρήγορα χωρίς ακριβό λογισμικό ή πολύπλοκο setup.",
      offers: [
        "Εργαλεία PDF για μετατροπή, συγχώνευση, διαχωρισμό, συμπίεση και επεξεργασία εγγράφων.",
        "Εργαλεία εικόνας για αλλαγή μεγέθους, συμπίεση, μετατροπή και καθαρισμό οπτικών asset.",
        "Εργαλεία κειμένου για μορφοποίηση, μετατροπή και ανάλυση περιεχομένου.",
        "Βοηθητικά εργαλεία για developers όπως generator QR, UUID και άλλα γρήγορα helpers.",
      ],
      privacyTitle: "Πρώτα η ιδιωτικότητα",
      privacyBody: "Η περισσότερη επεξεργασία αρχείων γίνεται απευθείας στον browser. Τα αρχεία σας παραμένουν υπό τον έλεγχό σας, βοηθώντας το workflow να μένει γρήγορο, ιδιωτικό και ασφαλές.",
      freeTitle: "100% δωρεάν",
      freeBody: "Τα εργαλεία μας είναι διαθέσιμα χωρίς συνδρομές, κρυφές χρεώσεις ή εμπόδια εγγραφής.",
    },
    contact: {
      sentTitle: "Το μήνυμα στάλθηκε!",
      sentBody: "Σας ευχαριστούμε που επικοινωνήσατε μαζί μας. Θα απαντήσουμε σύντομα.",
      labels: { name: "Όνομα", email: "Email", subject: "Θέμα", message: "Μήνυμα" },
      placeholders: {
        name: "Το όνομά σας",
        email: "email@example.com",
        subject: "Σχετικά με τι είναι αυτό;",
        message: "Πείτε μας περισσότερα...",
      },
      github: "GitHub",
      githubBody: "Βρήκατε bug ή θέλετε να συνεισφέρετε; Δείτε το repository.",
      viewRepo: "Προβολή repository",
    },
    privacy: {
      sections: [
        section("Η ιδιωτικότητά σας έχει σημασία", "Παίρνουμε την ιδιωτικότητα στα σοβαρά και προσπαθούμε να περιορίσουμε τη μη απαραίτητη συλλογή δεδομένων."),
        section("Επεξεργασία δεδομένων", "Τα περισσότερα εργαλεία επεξεργάζονται αρχεία τοπικά στον browser σας. Ορισμένες προχωρημένες μετατροπές μπορεί να χρειαστούν προσωρινή επεξεργασία στον server.", [
          "Τα αρχεία συνήθως παραμένουν στη συσκευή σας κατά την επεξεργασία.",
          "Οι προσωρινές εργασίες στον server διαγράφονται μετά την ολοκλήρωση.",
          "Δεν αποθηκεύουμε σκόπιμα το περιεχόμενο των εγγράφων σας.",
        ]),
        section("Ποιες πληροφορίες συλλέγουμε", undefined, [
          "Ανώνυμα analytics μόνο μετά από συγκατάθεση.",
          "Δεν απαιτείται λογαριασμός για τα βασικά εργαλεία.",
          "Δεν υπάρχει μόνιμη αποθήκευση των αρχείων που ανεβάζετε.",
        ]),
        section("Cookies", undefined, [
          "Αποθήκευση προτίμησης συγκατάθεσης.",
          "Ασφάλεια και βασική λειτουργικότητα του site.",
          "Προαιρετικά analytics μετά από ρητή άδεια.",
        ]),
        section("Τα δικαιώματά σας", "Μπορείτε να απορρίψετε τα analytics, να καθαρίσετε τα τοπικά δεδομένα του browser και να σταματήσετε να χρησιμοποιείτε την υπηρεσία ανά πάσα στιγμή."),
      ],
    },
    terms: {
      sections: [
        section("1. Αποδοχή όρων", "Χρησιμοποιώντας το Dogufy συμφωνείτε με αυτούς τους όρους."),
        section("2. Χρήση της υπηρεσίας", "Η υπηρεσία παρέχεται για προσωπικές και επαγγελματικές ανάγκες παραγωγικότητας.", [
          "Χρησιμοποιείτε την υπηρεσία νόμιμα.",
          "Μην υπερφορτώνετε, εκμεταλλεύεστε ή καταχράστε την πλατφόρμα.",
          "Μην χρησιμοποιείτε τα εργαλεία για επιβλαβείς ή κακόβουλους σκοπούς.",
        ]),
        section("3. Διαθεσιμότητα υπηρεσίας", "Στόχος μας είναι η αξιοπιστία, αλλά δεν μπορούμε να εγγυηθούμε αδιάλειπτη πρόσβαση ή λειτουργία χωρίς σφάλματα."),
        section("4. Περιορισμός ευθύνης", "Η χρήση της υπηρεσίας γίνεται με δική σας ευθύνη, συμπεριλαμβανομένου του ελέγχου ποιότητας και της καταλληλότητας του workflow."),
        section("5. Ευθύνες χρήστη", "Παραμένετε υπεύθυνοι για τα αρχεία σας και για το δικαίωμά σας να τα επεξεργάζεστε.", [
          "Κρατήστε αντίγραφα ασφαλείας σημαντικών πρωτοτύπων.",
          "Ελέγξτε την ποιότητα του αποτελέσματος πριν από κρίσιμη χρήση.",
          "Σεβαστείτε πνευματικά δικαιώματα και άλλες νομικές υποχρεώσεις.",
        ]),
        section("6. Επικοινωνία", "Αν έχετε ερωτήσεις σχετικά με αυτούς τους όρους, επικοινωνήστε μαζί μας μέσω της ιστοσελίδας."),
      ],
    },
    blog: {
      description: "Διαβάστε τα πιο πρόσφατα άρθρα μας για εργαλεία PDF, επεξεργασία εικόνας και παραγωγικότητα.",
      intro: "Εξερευνήστε πρακτικά άρθρα για έγγραφα, εικόνες και ψηφιακά workflow.",
      noTools: "Δεν βρέθηκαν αποτελέσματα.",
      clear: "Καθαρισμός αναζήτησης",
    },
    toolsPage: {
      description: "Περιηγηθείτε σε όλη τη συλλογή δωρεάν online εργαλείων μας και βρείτε ακριβώς το workflow που χρειάζεστε.",
      intro: "Αυτή η κεντρική σελίδα βοηθά επισκέπτες και μηχανές αναζήτησης να κατανοήσουν ολόκληρη τη βιβλιοθήκη εργαλείων του Dogufy και να φτάσουν γρήγορα στη σωστή σελίδα.",
      searchPlaceholder: "Αναζητήστε εργαλείο (π.χ. merge, image, pdf)...",
      noResultsTitle: "Δεν βρέθηκαν εργαλεία",
      noResultsBody: "Δεν βρήκαμε εργαλεία που να ταιριάζουν με την αναζήτησή σας. Δοκιμάστε άλλη λέξη-κλειδί ή κατηγορία.",
      didYouKnow: "Το γνωρίζατε;",
      didYouKnowBody: "Πολλά workflow εκτελούνται απευθείας στον browser, κάτι που κάνει τη διαχείριση εγγράφων πιο γρήγορη και πιο ιδιωτική.",
      whatMakesUseful: "Τι κάνει αυτό το εργαλείο χρήσιμο;",
      howToOnline: "Πώς να χρησιμοποιήσετε αυτό το εργαλείο online",
      uploadOrEnter: "Ανεβάστε ή εισάγετε δεδομένα",
      configure: "Ρυθμίστε τις επιλογές",
      processDownload: "Επεξεργασία και λήψη",
      bestUseCases: "Καλύτερες περιπτώσεις χρήσης",
      whyChoose: "Γιατί να επιλέξετε το Dogufy για αυτό το εργαλείο;",
      fastFree: "Γρήγορο και δωρεάν",
      fastFreeBody: "Χρησιμοποιήστε το workflow γρήγορα χωρίς εμπόδια εγγραφής.",
      securePrivate: "Ασφαλές και ιδιωτικό",
      securePrivateBody: "Η εμπειρία έχει σχεδιαστεί ώστε να μειώνει την άσκοπη έκθεση των αρχείων χρηστών.",
      highQuality: "Υψηλή ποιότητα",
      highQualityBody: "Στόχος μας είναι να διατηρούμε χρήσιμη ποιότητα εξόδου ενώ απλοποιούμε τη διαδικασία.",
      relatedCategory: "Σχετικά εργαλεία",
      removeFile: "Αφαίρεση αρχείου",
      convertedImages: "Μετατρεμμένες εικόνες",
      downloadAll: "Λήψη όλων",
      downloadPage: "Λήψη σελίδας",
      pageLabel: "Σελίδα",
      convertingPdf: "Μετατροπή PDF...",
      convertingPdfToImages: "Μετατροπή PDF σε εικόνες...",
      complete: "ολοκληρώθηκε",
      completed: "τελείωσε",
      convertToPng: "Μετατροπή σε PNG",
      convertToPngDescription: "Μετατρέψτε σελίδες PDF σε εικόνες PNG υψηλής ποιότητας με υποστήριξη διαφάνειας.",
      convertToJpg: "Μετατροπή σε JPG",
      convertToJpgDescription: "Μετατρέψτε σελίδες PDF σε εικόνες JPG υψηλής ποιότητας.",
      invalidPdfFile: "Επιλέξτε αρχείο PDF.",
      pdfToPngError: "Σφάλμα κατά τη μετατροπή PDF σε PNG",
      pdfConversionError: "Παρουσιάστηκε σφάλμα κατά τη μετατροπή PDF. Δοκιμάστε ξανά.",
      convertToWord: "Μετατροπή σε Word",
      convertToWordDescription: "Μετατρέψτε τα αρχεία PDF σας σε επεξεργάσιμα έγγραφα Word (DOCX).",
      convertToWordButton: "Μετατροπή σε Word (.docx)",
      convertingToWord: "Μετατροπή σε Word...",
      pdfToWordError: "Σφάλμα κατά τη μετατροπή PDF σε Word. Δοκιμάστε ξανά.",
      convertToPdf: "Μετατροπή σε PDF",
      convertingToPdf: "Μετατροπή σε PDF...",
      wordToPdfError: "Σφάλμα κατά τη μετατροπή Word σε PDF. Δοκιμάστε ξανά.",
      mergePdfTitle: "Συγχώνευση αρχείων PDF",
      mergePdfDescription: "Συνδυάστε πολλά αρχεία PDF σε ένα έγγραφο. Σύρετε και αποθέστε για αλλαγή σειράς.",
      mergePdfHint: "Επιλέξτε 2 ή περισσότερα αρχεία PDF για συγχώνευση",
      filesToMerge: "Αρχεία προς συγχώνευση",
      clearAll: "Καθαρισμός όλων",
      moveUp: "Μετακίνηση πάνω",
      moveDown: "Μετακίνηση κάτω",
      merging: "Συγχώνευση...",
      mergePdfs: "Συγχώνευση PDF",
      mergePdfError: "Σφάλμα κατά τη συγχώνευση PDF. Βεβαιωθείτε ότι όλα τα αρχεία είναι έγκυρα PDF.",
    },
  },
  uk: {
    landing: {
      toolsDescription: "Ознайомтеся з нашими найпопулярнішими безкоштовними онлайн-інструментами. Швидко, безпечно та зручно.",
      useCasesTitle: "Сценарії використання",
      useCasesDescription: "Подивіться, як Dogufy допомагає різним групам користувачів працювати ефективніше.",
      useCases: [
        item("Для студентів і академічної роботи", "Об'єднуйте завдання, стискайте дипломні роботи та перетворюйте дослідницькі документи на редаговані формати."),
        item("Для бізнес-професіоналів", "Підписуйте контракти, об'єднуйте звіти та перетворюйте таблиці на PDF, які легко поширювати."),
        item("Для дизайнерів і креативних команд", "Оптимізуйте зображення, видаляйте фон і швидше конвертуйте assets."),
        item("Для юридичних команд", "Працюйте з чутливими документами через більш приватні workflow та кращу організацію."),
        item("Для агентів з нерухомості", "Готуйте брошури, файли об'єктів і матеріали для listing швидше та зручніше."),
      ],
      useCasesCta: "Спробувати інструменти",
      processDescription: "Просто, швидко й безпечно. Підготуйте свої документи за 4 кроки.",
      processSteps: [
        step("01", "Оберіть інструмент", "Виберіть потрібний workflow з нашої колекції PDF, image і text інструментів."),
        step("02", "Завантажте файли", "Перетягніть файл у браузер і налаштуйте доступні параметри."),
        step("03", "Обробка за секунди", "Запускайте задачу одразу без встановлення додаткового ПЗ."),
        step("04", "Завантажте та поділіться", "Отримайте результат миттєво й продовжуйте роботу."),
      ],
      featuresDescription: "Ми пропонуємо безкоштовні онлайн-інструменти, створені для швидкості, приватності та практичних workflow.",
      features: [
        item("Назавжди безкоштовно", "Користуйтеся інструментами без підписок, прихованих платежів і paywall."),
        item("Безпечно та приватно", "Workflow з акцентом на приватність допомагають краще контролювати чутливі файли."),
        item("Дуже швидко", "Workflow у браузері скорочують час на повторювані завдання."),
        item("Легко користуватися", "Інтерфейс спроєктований так, щоб бути зрозумілим навіть нетехнічним користувачам."),
        item("Зручно на мобільних", "Сервіс добре працює на desktop, tablet і mobile."),
        item("Висока якість", "Ми прагнемо зберігати корисну якість результату, водночас спрощуючи процес."),
      ],
      testimonialsDescription: "Подивіться, що користувачі говорять про Dogufy.",
      testimonials: [
        quote("Dogufy допоміг мені швидко об'єднати розділи дипломної роботи без зайвої складності.", "Sarah J.", "Студентка магістратури"),
        quote("Я регулярно використовую image tools для веброботи, бо вони швидкі й зручні.", "Mike T.", "Frontend розробник"),
        quote("Інструменти конвертації документів економлять час, коли потрібно підготувати редаговані версії.", "Emily R.", "Юридична асистентка"),
      ],
      landingContactDescription: "Зв'яжіться з нами, якщо хочете обговорити продукт, запропонувати покращення або поставити запитання.",
      sayHi: "Привітатися",
      getQuote: "Отримати пропозицію",
      name: "Ім'я",
      email: "Email",
      message: "Повідомлення",
      send: "Надіслати повідомлення",
    },
    about: {
      intro: "Ласкаво просимо до Dogufy — вашого зручного сервісу для документів, зображень і тексту.",
      missionBody: "Ми вважаємо, що потужні інструменти продуктивності мають бути доступними для всіх. Наша місія — надавати безкоштовні якісні онлайн-інструменти, які допомагають працювати швидше без дорогого софту чи складного налаштування.",
      offers: [
        "PDF-інструменти для конвертації, об'єднання, поділу, стиснення та редагування документів.",
        "Image tools для зміни розміру, стиснення, конвертації та очищення візуальних asset.",
        "Text tools для форматування, конвертації та аналізу контенту.",
        "Developer utilities на кшталт QR generator, UUID generator та інших швидких helpers.",
      ],
      privacyTitle: "Приватність передусім",
      privacyBody: "Більшість обробки відбувається прямо в браузері. Ваші файли залишаються під вашим контролем, що допомагає зберігати workflow швидким, приватним і безпечним.",
      freeTitle: "100% безкоштовно",
      freeBody: "Наші інструменти доступні без підписок, прихованих платежів і бар'єрів реєстрації.",
    },
    contact: {
      sentTitle: "Повідомлення надіслано!",
      sentBody: "Дякуємо, що написали нам. Ми відповімо якнайшвидше.",
      labels: { name: "Ім'я", email: "Email", subject: "Тема", message: "Повідомлення" },
      placeholders: {
        name: "Ваше ім'я",
        email: "your.email@example.com",
        subject: "Про що це?",
        message: "Розкажіть більше...",
      },
      github: "GitHub",
      githubBody: "Знайшли баг або хочете допомогти? Перегляньте репозиторій.",
      viewRepo: "Переглянути репозиторій",
    },
    privacy: {
      sections: [
        section("Ваша приватність важлива", "Ми серйозно ставимося до приватності та намагаємося мінімізувати зайвий збір даних."),
        section("Обробка даних", "Більшість інструментів обробляють файли локально в браузері. Деякі складні конвертації можуть вимагати тимчасової серверної обробки.", [
          "Файли зазвичай залишаються на вашому пристрої під час обробки.",
          "Тимчасові серверні задачі видаляються після завершення.",
          "Ми навмисно не зберігаємо вміст ваших документів.",
        ]),
        section("Яку інформацію ми збираємо", undefined, [
          "Анонімна аналітика лише після згоди.",
          "Для основних інструментів не потрібен акаунт.",
          "Немає постійного зберігання завантажених файлів.",
        ]),
        section("Cookies", undefined, [
          "Зберігання вибору згоди.",
          "Безпека та основна функціональність сайту.",
          "Опціональна аналітика після явного дозволу.",
        ]),
        section("Ваші права", "Ви можете відмовитися від аналітики, очистити локальні дані в браузері та припинити користування сервісом у будь-який момент."),
      ],
    },
    terms: {
      sections: [
        section("1. Прийняття умов", "Користуючись Dogufy, ви погоджуєтеся з цими умовами."),
        section("2. Використання сервісу", "Сервіс надається для особистих і комерційних задач продуктивності.", [
          "Використовуйте сервіс законно.",
          "Не перевантажуйте, не експлуатуйте й не зловживайте платформою.",
          "Не використовуйте інструменти для шкідливих або зловмисних цілей.",
        ]),
        section("3. Доступність сервісу", "Ми прагнемо надійності, але не можемо гарантувати безперервний доступ або роботу без помилок."),
        section("4. Обмеження відповідальності", "Використання сервісу відбувається на ваш ризик, включно з перевіркою якості файлів і придатності workflow."),
        section("5. Відповідальність користувача", "Ви залишаєтеся відповідальними за свої файли та право на їх обробку.", [
          "Зберігайте резервні копії важливих оригіналів.",
          "Перевіряйте якість результату перед критичним використанням.",
          "Поважайте авторське право та інші юридичні зобов'язання.",
        ]),
        section("6. Контакт", "Якщо у вас є питання щодо цих умов, зв'яжіться з нами через сайт."),
      ],
    },
    blog: {
      description: "Читайте наші останні статті про PDF-інструменти, обробку зображень і продуктивність.",
      intro: "Досліджуйте практичні статті про документи, зображення та цифрові workflow.",
      noTools: "Результатів не знайдено.",
      clear: "Очистити пошук",
    },
    toolsPage: {
      description: "Перегляньте всю нашу колекцію безкоштовних онлайн-інструментів і знайдіть саме той workflow, який вам потрібен.",
      intro: "Ця сторінка-хаб допомагає користувачам і пошуковим системам зрозуміти всю бібліотеку інструментів Dogufy та швидко перейти на потрібну сторінку.",
      searchPlaceholder: "Шукати інструмент (наприклад: merge, image, pdf)...",
      noResultsTitle: "Інструменти не знайдено",
      noResultsBody: "Ми не знайшли інструментів, що відповідають вашому запиту. Спробуйте інше ключове слово або категорію.",
      didYouKnow: "Чи знали ви?",
      didYouKnowBody: "Багато workflow відбуваються прямо в браузері, що допомагає робити роботу з документами швидшою та приватнішою.",
      whatMakesUseful: "Що робить цей інструмент корисним?",
      howToOnline: "Як використовувати цей інструмент онлайн",
      uploadOrEnter: "Завантажте або введіть дані",
      configure: "Налаштуйте параметри",
      processDownload: "Обробіть і завантажте",
      bestUseCases: "Найкращі сценарії використання",
      whyChoose: "Чому варто обрати Dogufy для цього інструмента?",
      fastFree: "Швидко та безкоштовно",
      fastFreeBody: "Використовуйте workflow швидко й без бар'єрів реєстрації.",
      securePrivate: "Безпечно та приватно",
      securePrivateBody: "Досвід побудований так, щоб зменшувати непотрібне розкриття файлів користувача.",
      highQuality: "Висока якість",
      highQualityBody: "Ми прагнемо зберігати корисну якість результату, спрощуючи сам процес.",
      relatedCategory: "Пов'язані інструменти",
      removeFile: "Видалити файл",
      convertedImages: "Конвертовані зображення",
      downloadAll: "Завантажити все",
      downloadPage: "Завантажити сторінку",
      pageLabel: "Сторінка",
      convertingPdf: "Конвертація PDF...",
      convertingPdfToImages: "Конвертація PDF у зображення...",
      complete: "готово",
      completed: "завершено",
      convertToPng: "Конвертувати в PNG",
      convertToPngDescription: "Перетворюйте сторінки PDF на PNG-зображення високої якості з підтримкою прозорості.",
      convertToJpg: "Конвертувати в JPG",
      convertToJpgDescription: "Перетворюйте сторінки PDF на JPG-зображення високої якості.",
      invalidPdfFile: "Будь ласка, виберіть PDF-файл.",
      pdfToPngError: "Помилка під час конвертації PDF у PNG",
      pdfConversionError: "Сталася помилка під час конвертації PDF. Спробуйте ще раз.",
      convertToWord: "Конвертувати в Word",
      convertToWordDescription: "Перетворюйте PDF-файли на редаговані документи Word (DOCX).",
      convertToWordButton: "Конвертувати в Word (.docx)",
      convertingToWord: "Конвертація у Word...",
      pdfToWordError: "Помилка під час конвертації PDF у Word. Спробуйте ще раз.",
      convertToPdf: "Конвертувати в PDF",
      convertingToPdf: "Конвертація у PDF...",
      wordToPdfError: "Помилка під час конвертації Word у PDF. Спробуйте ще раз.",
      mergePdfTitle: "Об'єднати PDF-файли",
      mergePdfDescription: "Об'єднайте кілька PDF-файлів в один документ. Перетягніть, щоб змінити порядок файлів.",
      mergePdfHint: "Оберіть 2 або більше PDF-файлів для об'єднання",
      filesToMerge: "Файли для об'єднання",
      clearAll: "Очистити все",
      moveUp: "Перемістити вгору",
      moveDown: "Перемістити вниз",
      merging: "Об'єднання...",
      mergePdfs: "Об'єднати PDF",
      mergePdfError: "Помилка під час об'єднання PDF. Переконайтеся, що всі файли є дійсними PDF.",
    },
  },
  ru: {
    landing: {
      toolsDescription: "Изучите наши самые популярные бесплатные онлайн-инструменты. Быстро, безопасно и удобно.",
      useCasesTitle: "Сценарии использования",
      useCasesDescription: "Посмотрите, как Dogufy помогает разным группам пользователей быстрее достигать результата.",
      useCases: [
        item("Для студентов и академической работы", "Объединяйте задания, сжимайте дипломные работы и переводите исследовательские документы в редактируемые форматы."),
        item("Для бизнес-профессионалов", "Подписывайте контракты, объединяйте отчеты и преобразуйте таблицы в удобные для обмена PDF."),
        item("Для дизайнеров и креативных команд", "Оптимизируйте изображения, удаляйте фон и быстрее конвертируйте assets."),
        item("Для юридических команд", "Работайте с чувствительными документами через более приватные workflow и аккуратную организацию."),
        item("Для риелторов", "Готовьте брошюры, файлы объектов и материалы для listing более эффективно."),
      ],
      useCasesCta: "Попробовать инструменты",
      processDescription: "Просто, быстро и безопасно. Подготовьте документы за 4 шага.",
      processSteps: [
        step("01", "Выберите инструмент", "Выберите нужный workflow из нашей коллекции PDF, image и text tools."),
        step("02", "Загрузите файлы", "Перетащите файл в браузер и настройте доступные параметры."),
        step("03", "Обработка за секунды", "Запускайте задачу сразу без установки дополнительного ПО."),
        step("04", "Скачайте и поделитесь", "Получите результат моментально и продолжайте работу."),
      ],
      featuresDescription: "Мы предлагаем бесплатные онлайн-инструменты, созданные для скорости, приватности и практичных workflow.",
      features: [
        item("Всегда бесплатно", "Пользуйтесь инструментами без подписки, скрытых платежей и paywall."),
        item("Безопасно и приватно", "Workflow с акцентом на приватность помогают лучше контролировать чувствительные файлы."),
        item("Очень быстро", "Browser-based workflow сокращают время на повторяющиеся задачи."),
        item("Легко использовать", "Интерфейс спроектирован так, чтобы им было удобно пользоваться даже нетехническим пользователям."),
        item("Удобно на мобильных", "Сервис отлично работает на desktop, tablet и mobile."),
        item("Высокое качество", "Мы стремимся сохранять полезное качество результата, упрощая процесс."),
      ],
      testimonialsDescription: "Посмотрите, что пользователи говорят о Dogufy.",
      testimonials: [
        quote("Dogufy помог мне быстро объединить главы дипломной работы без лишней сложности.", "Sarah J.", "Студентка магистратуры"),
        quote("Я регулярно использую инструменты для изображений в веб-работе, потому что они быстрые и удобные.", "Mike T.", "Frontend-разработчик"),
        quote("Инструменты конвертации документов экономят время, когда нужно подготовить редактируемые версии файлов.", "Emily R.", "Юридический ассистент"),
      ],
      landingContactDescription: "Свяжитесь с нами, если хотите обсудить продукт, предложить улучшения или задать вопрос.",
      sayHi: "Поздороваться",
      getQuote: "Запросить предложение",
      name: "Имя",
      email: "Email",
      message: "Сообщение",
      send: "Отправить сообщение",
    },
    about: {
      intro: "Добро пожаловать в Dogufy — удобный сервис для работы с документами, изображениями и текстом.",
      missionBody: "Мы считаем, что мощные инструменты продуктивности должны быть доступны каждому. Наша миссия — давать бесплатные качественные онлайн-инструменты, которые помогают работать быстрее без дорогого софта и сложной настройки.",
      offers: [
        "PDF-инструменты для конвертации, объединения, разделения, сжатия и редактирования документов.",
        "Инструменты для изображений: изменение размера, сжатие, конвертация и очистка visual assets.",
        "Text tools для форматирования, преобразования и анализа контента.",
        "Developer utilities вроде QR generator, UUID generator и других быстрых helpers.",
      ],
      privacyTitle: "Приватность прежде всего",
      privacyBody: "Большая часть обработки происходит прямо в браузере. Ваши файлы остаются под вашим контролем, что помогает сохранять workflow быстрым, приватным и безопасным.",
      freeTitle: "100% бесплатно",
      freeBody: "Наши инструменты доступны без подписок, скрытых платежей и регистрационных барьеров.",
    },
    contact: {
      sentTitle: "Сообщение отправлено!",
      sentBody: "Спасибо, что написали нам. Мы ответим как можно скорее.",
      labels: { name: "Имя", email: "Email", subject: "Тема", message: "Сообщение" },
      placeholders: {
        name: "Ваше имя",
        email: "your.email@example.com",
        subject: "О чем это?",
        message: "Расскажите подробнее...",
      },
      github: "GitHub",
      githubBody: "Нашли баг или хотите помочь? Загляните в репозиторий.",
      viewRepo: "Открыть репозиторий",
    },
    privacy: {
      sections: [
        section("Ваша приватность важна", "Мы серьезно относимся к приватности и стараемся минимизировать ненужный сбор данных."),
        section("Обработка данных", "Большинство инструментов обрабатывает файлы локально в браузере. Некоторые сложные конвертации могут требовать временной серверной обработки.", [
          "Файлы обычно остаются на вашем устройстве во время обработки.",
          "Временные серверные задачи удаляются после завершения.",
          "Мы намеренно не сохраняем содержимое ваших документов.",
        ]),
        section("Какие данные мы собираем", undefined, [
          "Анонимная аналитика только после согласия.",
          "Для основных инструментов аккаунт не требуется.",
          "Нет постоянного хранения загруженных файлов.",
        ]),
        section("Cookies", undefined, [
          "Сохранение выбора согласия.",
          "Безопасность и базовая функциональность сайта.",
          "Дополнительная аналитика после явного разрешения.",
        ]),
        section("Ваши права", "Вы можете отказаться от аналитики, очистить локальные данные браузера и прекратить использование сервиса в любой момент."),
      ],
    },
    terms: {
      sections: [
        section("1. Принятие условий", "Используя Dogufy, вы соглашаетесь с этими условиями."),
        section("2. Использование сервиса", "Сервис предоставляется для личных и коммерческих задач продуктивности.", [
          "Используйте сервис законно.",
          "Не перегружайте, не эксплуатируйте и не злоупотребляйте платформой.",
          "Не используйте инструменты во вредоносных целях.",
        ]),
        section("3. Доступность сервиса", "Мы стремимся к надежности, но не можем гарантировать непрерывный доступ или работу без ошибок."),
        section("4. Ограничение ответственности", "Использование сервиса осуществляется на ваш риск, включая проверку качества результатов и пригодности workflow."),
        section("5. Ответственность пользователя", "Вы по-прежнему отвечаете за свои файлы и право их обрабатывать.", [
          "Храните резервные копии важных оригиналов.",
          "Проверяйте качество результата перед критичным использованием.",
          "Соблюдайте авторские права и другие юридические обязательства.",
        ]),
        section("6. Контакт", "Если у вас есть вопросы по этим условиям, свяжитесь с нами через сайт."),
      ],
    },
    blog: {
      description: "Читайте наши последние статьи о PDF-инструментах, обработке изображений и продуктивности.",
      intro: "Изучайте практические статьи о документах, изображениях и цифровых workflow.",
      noTools: "Результаты не найдены.",
      clear: "Очистить поиск",
    },
    toolsPage: {
      description: "Просмотрите всю нашу коллекцию бесплатных онлайн-инструментов и найдите workflow, который нужен именно вам.",
      intro: "Эта хаб-страница помогает пользователям и поисковым системам понять всю библиотеку инструментов Dogufy и быстро перейти на нужную страницу.",
      searchPlaceholder: "Найти инструмент (например: merge, image, pdf)...",
      noResultsTitle: "Инструменты не найдены",
      noResultsBody: "Мы не нашли инструментов, соответствующих вашему запросу. Попробуйте другое ключевое слово или категорию.",
      didYouKnow: "Знаете ли вы?",
      didYouKnowBody: "Многие workflow работают прямо в браузере, что делает работу с документами быстрее и более приватной.",
      whatMakesUseful: "Что делает этот инструмент полезным?",
      howToOnline: "Как использовать этот инструмент онлайн",
      uploadOrEnter: "Загрузите или введите данные",
      configure: "Настройте параметры",
      processDownload: "Обработайте и скачайте",
      bestUseCases: "Лучшие сценарии использования",
      whyChoose: "Почему стоит выбрать Dogufy для этого инструмента?",
      fastFree: "Быстро и бесплатно",
      fastFreeBody: "Используйте workflow быстро и без регистрационных барьеров.",
      securePrivate: "Безопасно и приватно",
      securePrivateBody: "Опыт построен так, чтобы уменьшать ненужное раскрытие пользовательских файлов.",
      highQuality: "Высокое качество",
      highQualityBody: "Мы стремимся сохранять полезное качество результата, упрощая процесс.",
      relatedCategory: "Похожие инструменты",
      removeFile: "Удалить файл",
      convertedImages: "Преобразованные изображения",
      downloadAll: "Скачать все",
      downloadPage: "Скачать страницу",
      pageLabel: "Страница",
      convertingPdf: "Конвертация PDF...",
      convertingPdfToImages: "Конвертация PDF в изображения...",
      complete: "готово",
      completed: "завершено",
      convertToPng: "Конвертировать в PNG",
      convertToPngDescription: "Преобразуйте страницы PDF в PNG-изображения высокого качества с поддержкой прозрачности.",
      convertToJpg: "Конвертировать в JPG",
      convertToJpgDescription: "Преобразуйте страницы PDF в JPG-изображения высокого качества.",
      invalidPdfFile: "Пожалуйста, выберите PDF-файл.",
      pdfToPngError: "Ошибка при конвертации PDF в PNG",
      pdfConversionError: "Ошибка при конвертации PDF. Попробуйте еще раз.",
      convertToWord: "Конвертировать в Word",
      convertToWordDescription: "Преобразуйте PDF-файлы в редактируемые документы Word (DOCX).",
      convertToWordButton: "Конвертировать в Word (.docx)",
      convertingToWord: "Конвертация в Word...",
      pdfToWordError: "Ошибка при конвертации PDF в Word. Попробуйте еще раз.",
      convertToPdf: "Конвертировать в PDF",
      convertingToPdf: "Конвертация в PDF...",
      wordToPdfError: "Ошибка при конвертации Word в PDF. Попробуйте еще раз.",
      mergePdfTitle: "Объединить PDF-файлы",
      mergePdfDescription: "Объедините несколько PDF-файлов в один документ. Перетаскивайте, чтобы менять порядок файлов.",
      mergePdfHint: "Выберите 2 или более PDF-файла для объединения",
      filesToMerge: "Файлы для объединения",
      clearAll: "Очистить все",
      moveUp: "Переместить вверх",
      moveDown: "Переместить вниз",
      merging: "Объединение...",
      mergePdfs: "Объединить PDF",
      mergePdfError: "Ошибка при объединении PDF. Убедитесь, что все файлы являются корректными PDF.",
    },
  },
  ar: {
    landing: {
      toolsDescription: "استكشف أكثر أدواتنا المجانية استخدامًا عبر الإنترنت. سريعة وآمنة وسهلة الاستخدام.",
      useCasesTitle: "حالات الاستخدام",
      useCasesDescription: "اكتشف كيف تساعد Dogufy مجموعات مختلفة من المستخدمين على إنهاء العمل بشكل أسرع.",
      useCases: [
        item("للطلاب والعمل الأكاديمي", "ادمج الواجبات واضغط ملفات الرسائل العلمية وحوّل مستندات البحث إلى صيغ قابلة للتحرير."),
        item("للمهنيين في الأعمال", "وقّع العقود وادمج التقارير وحوّل الجداول إلى ملفات PDF سهلة المشاركة."),
        item("للمصممين والمبدعين", "حسّن الصور وأزل الخلفيات وحوّل الأصول بسرعة أكبر."),
        item("للفرق القانونية", "تعامل مع المستندات الحساسة من خلال workflow أكثر خصوصية وتنظيمًا."),
        item("لوكلاء العقارات", "حضّر الكتيبات وملفات العقارات وأصول الإعلانات بكفاءة أعلى."),
      ],
      useCasesCta: "جرّب الأدوات",
      processDescription: "بسيط وسريع وآمن. جهّز مستنداتك في 4 خطوات.",
      processSteps: [
        step("01", "اختر الأداة", "اختر الـ workflow المناسب من مجموعتنا الخاصة بـ PDF والصور والنصوص."),
        step("02", "ارفع الملفات", "اسحب الملف إلى المتصفح واضبط الخيارات المتاحة."),
        step("03", "عالج خلال ثوانٍ", "شغّل المهمة فورًا من دون تثبيت أي برنامج إضافي."),
        step("04", "نزّل وشارك", "احصل على النتيجة مباشرة وتابع عملك."),
      ],
      featuresDescription: "نوفّر أدوات مجانية مبنية للسرعة والخصوصية وسير العمل العملي.",
      features: [
        item("مجاني دائمًا", "استخدم الأدوات من دون اشتراك أو رسوم مخفية أو جدار دفع."),
        item("آمن وخاص", "تساعد مسارات العمل المراعية للخصوصية على إبقاء الملفات الحساسة تحت السيطرة."),
        item("سريع جدًا", "تقلل workflow داخل المتصفح الوقت الضائع في المهام المتكررة."),
        item("سهل الاستخدام", "صُممت الواجهة لتكون مريحة حتى للمستخدمين غير التقنيين."),
        item("ملائم للجوال", "تعمل التجربة على سطح المكتب والجهاز اللوحي والجوال."),
        item("جودة عالية", "نسعى للحفاظ على جودة مخرجات مفيدة مع تبسيط العملية."),
      ],
      testimonialsDescription: "اطلع على ما يقوله المستخدمون عن Dogufy.",
      testimonials: [
        quote("ساعدني Dogufy على دمج فصول رسالتي بسرعة من دون تعقيد غير ضروري.", "Sarah J.", "طالبة دراسات عليا"),
        quote("أستخدم أدوات الصور باستمرار في أعمال الويب لأنها سريعة وعملية.", "Mike T.", "مطور Frontend"),
        quote("توفر أدوات تحويل المستندات الكثير من الوقت عندما أحتاج إلى نسخ قابلة للتحرير.", "Emily R.", "مساعدة قانونية"),
      ],
      landingContactDescription: "تواصل معنا إذا أردت مناقشة المنتج أو اقتراح تحسينات أو طرح سؤال.",
      sayHi: "قل مرحبًا",
      getQuote: "اطلب عرض سعر",
      name: "الاسم",
      email: "البريد الإلكتروني",
      message: "الرسالة",
      send: "إرسال الرسالة",
    },
    about: {
      intro: "مرحبًا بك في Dogufy، وجهتك الشاملة للتعامل مع المستندات والصور والنصوص.",
      missionBody: "نؤمن بأن أدوات الإنتاجية القوية يجب أن تكون متاحة للجميع. مهمتنا هي تقديم أدوات مجانية عالية الجودة عبر الإنترنت تساعد المستخدمين على العمل بسرعة أكبر من دون برامج مكلفة أو إعداد معقد.",
      offers: [
        "أدوات PDF للتحويل والدمج والتقسيم والضغط وتحرير المستندات.",
        "أدوات للصور لتغيير الحجم والضغط والتحويل وتنظيف الأصول البصرية.",
        "أدوات للنصوص للتنسيق والتحويل وتحليل المحتوى.",
        "أدوات للمطورين مثل مولد QR ومولد UUID ومساعدات سريعة أخرى.",
      ],
      privacyTitle: "الخصوصية أولًا",
      privacyBody: "تتم معظم عمليات المعالجة مباشرة داخل المتصفح. تبقى ملفاتك تحت سيطرتك مما يساعد على بقاء workflow سريعًا وخاصًا وآمنًا.",
      freeTitle: "مجاني 100%",
      freeBody: "أدواتنا متاحة من دون اشتراك أو رسوم مخفية أو عوائق تسجيل.",
    },
    contact: {
      sentTitle: "تم إرسال الرسالة!",
      sentBody: "شكرًا لتواصلك معنا. سنرد عليك في أقرب وقت.",
      labels: { name: "الاسم", email: "البريد الإلكتروني", subject: "الموضوع", message: "الرسالة" },
      placeholders: {
        name: "اسمك",
        email: "your.email@example.com",
        subject: "ما موضوع الرسالة؟",
        message: "أخبرنا بالمزيد...",
      },
      github: "GitHub",
      githubBody: "هل وجدت خطأ أو تريد المساهمة؟ اطّلع على المستودع.",
      viewRepo: "عرض المستودع",
    },
    privacy: {
      sections: [
        section("خصوصيتك مهمة", "نأخذ الخصوصية بجدية ونسعى إلى تقليل جمع البيانات غير الضروري."),
        section("معالجة البيانات", "تعالج معظم الأدوات الملفات محليًا داخل المتصفح. قد تتطلب بعض التحويلات المتقدمة معالجة مؤقتة على الخادم.", [
          "تبقى الملفات عادة على جهازك أثناء المعالجة.",
          "يتم حذف المهام المؤقتة على الخادم بعد الانتهاء.",
          "لا نقوم عمدًا بتخزين محتوى مستنداتك.",
        ]),
        section("المعلومات التي نجمعها", undefined, [
          "تحليلات مجهولة فقط بعد الموافقة.",
          "لا حاجة إلى إنشاء حساب لاستخدام الأدوات الأساسية.",
          "لا يوجد تخزين دائم للملفات المرفوعة.",
        ]),
        section("ملفات تعريف الارتباط", undefined, [
          "تخزين تفضيل الموافقة.",
          "الأمان والوظائف الأساسية للموقع.",
          "تحليلات اختيارية بعد إذن صريح.",
        ]),
        section("حقوقك", "يمكنك رفض التحليلات ومسح بيانات المتصفح المحلية والتوقف عن استخدام الخدمة في أي وقت."),
      ],
    },
    terms: {
      sections: [
        section("1. قبول الشروط", "باستخدام Dogufy فإنك توافق على هذه الشروط."),
        section("2. استخدام الخدمة", "الخدمة مخصصة لاستخدامات الإنتاجية الشخصية والتجارية.", [
          "استخدم الخدمة بشكل قانوني.",
          "لا تقم بتحميل المنصة فوق طاقتها أو استغلالها أو إساءة استخدامها.",
          "لا تستخدم الأدوات لأغراض ضارة أو خبيثة.",
        ]),
        section("3. توفر الخدمة", "نسعى إلى الاعتمادية، لكننا لا نستطيع ضمان الوصول المستمر أو التشغيل الخالي من الأخطاء."),
        section("4. تحديد المسؤولية", "استخدام الخدمة يكون على مسؤوليتك الخاصة، بما في ذلك التحقق من جودة الملفات وملاءمة workflow."),
        section("5. مسؤوليات المستخدم", "تظل مسؤولًا عن ملفاتك وعن حقك في معالجتها.", [
          "احتفظ بنسخ احتياطية من الملفات الأصلية المهمة.",
          "تحقق من جودة النتيجة قبل الاستخدام الحرج.",
          "احترم حقوق النشر والالتزامات القانونية الأخرى.",
        ]),
        section("6. التواصل", "إذا كانت لديك أسئلة حول هذه الشروط، فيرجى التواصل معنا عبر الموقع."),
      ],
    },
    blog: {
      description: "اقرأ أحدث مقالاتنا حول أدوات PDF ومعالجة الصور والإنتاجية.",
      intro: "استكشف مقالات عملية حول المستندات والصور وسير العمل الرقمي.",
      noTools: "لم يتم العثور على نتائج.",
      clear: "مسح البحث",
    },
    toolsPage: {
      description: "تصفح مجموعتنا الكاملة من الأدوات المجانية عبر الإنترنت واعثر على workflow المناسب لك تمامًا.",
      intro: "تساعد هذه الصفحة المركزية الزوار ومحركات البحث على فهم مكتبة أدوات Dogufy بالكامل والوصول سريعًا إلى الصفحة الصحيحة.",
      searchPlaceholder: "ابحث عن أداة (مثل: merge, image, pdf)...",
      noResultsTitle: "لم يتم العثور على أدوات",
      noResultsBody: "لم نعثر على أدوات تطابق بحثك. جرّب كلمة مفتاحية أو فئة أخرى.",
      didYouKnow: "هل تعلم؟",
      didYouKnowBody: "تعمل العديد من مسارات العمل مباشرة داخل المتصفح، مما يجعل التعامل مع المستندات أسرع وأكثر خصوصية.",
      whatMakesUseful: "ما الذي يجعل هذه الأداة مفيدة؟",
      howToOnline: "كيفية استخدام هذه الأداة عبر الإنترنت",
      uploadOrEnter: "ارفع الملف أو أدخل البيانات",
      configure: "اضبط الإعدادات",
      processDownload: "عالج ثم نزّل",
      bestUseCases: "أفضل حالات الاستخدام",
      whyChoose: "لماذا تختار Dogufy لهذه الأداة؟",
      fastFree: "سريع ومجاني",
      fastFreeBody: "استخدم workflow بسرعة ومن دون حواجز تسجيل.",
      securePrivate: "آمن وخاص",
      securePrivateBody: "تم تصميم التجربة لتقليل كشف ملفات المستخدمين دون داعٍ.",
      highQuality: "جودة عالية",
      highQualityBody: "نسعى للحفاظ على جودة مخرجات مفيدة مع تبسيط العملية.",
      relatedCategory: "أدوات ذات صلة",
      removeFile: "إزالة الملف",
      convertedImages: "الصور المحوّلة",
      downloadAll: "تنزيل الكل",
      downloadPage: "تنزيل الصفحة",
      pageLabel: "صفحة",
      convertingPdf: "جارٍ تحويل PDF...",
      convertingPdfToImages: "جارٍ تحويل PDF إلى صور...",
      complete: "مكتمل",
      completed: "تم",
      convertToPng: "تحويل إلى PNG",
      convertToPngDescription: "حوّل صفحات PDF إلى صور PNG عالية الجودة مع دعم الشفافية.",
      convertToJpg: "تحويل إلى JPG",
      convertToJpgDescription: "حوّل صفحات PDF إلى صور JPG عالية الجودة.",
      invalidPdfFile: "يرجى اختيار ملف PDF.",
      pdfToPngError: "حدث خطأ أثناء تحويل PDF إلى PNG",
      pdfConversionError: "حدث خطأ أثناء تحويل PDF. يرجى المحاولة مرة أخرى.",
      convertToWord: "تحويل إلى Word",
      convertToWordDescription: "حوّل ملفات PDF إلى مستندات Word قابلة للتحرير (DOCX).",
      convertToWordButton: "تحويل إلى Word (.docx)",
      convertingToWord: "جارٍ التحويل إلى Word...",
      pdfToWordError: "حدث خطأ أثناء تحويل PDF إلى Word. يرجى المحاولة مرة أخرى.",
      convertToPdf: "تحويل إلى PDF",
      convertingToPdf: "جارٍ التحويل إلى PDF...",
      wordToPdfError: "حدث خطأ أثناء تحويل Word إلى PDF. يرجى المحاولة مرة أخرى.",
      mergePdfTitle: "دمج ملفات PDF",
      mergePdfDescription: "اجمع عدة ملفات PDF في مستند واحد. اسحب وأفلت لإعادة ترتيب الملفات.",
      mergePdfHint: "اختر ملفين PDF أو أكثر للدمج",
      filesToMerge: "الملفات المراد دمجها",
      clearAll: "مسح الكل",
      moveUp: "نقل لأعلى",
      moveDown: "نقل لأسفل",
      merging: "جارٍ الدمج...",
      mergePdfs: "دمج PDF",
      mergePdfError: "حدث خطأ أثناء دمج PDF. تأكد من أن جميع الملفات PDF صالحة.",
    },
  },
  ko: {
    landing: {
      toolsDescription: "가장 많이 사용되는 무료 온라인 도구를 살펴보세요. 안전하고 빠르며 사용하기 쉽습니다.",
      useCasesTitle: "활용 사례",
      useCasesDescription: "Dogufy가 다양한 사용자 그룹의 작업 속도를 어떻게 높여주는지 확인해 보세요.",
      useCases: [
        item("학생과 학술 작업용", "과제를 합치고 논문 파일을 압축하며 연구 문서를 편집 가능한 형식으로 변환하세요."),
        item("비즈니스 전문가용", "계약서에 서명하고 보고서를 병합하며 스프레드시트를 공유하기 쉬운 PDF로 바꾸세요."),
        item("디자이너와 크리에이터용", "이미지를 최적화하고 배경을 제거하며 asset을 더 빠르게 변환하세요."),
        item("법률 팀용", "민감한 문서를 더 사적인 workflow와 정돈된 구조로 관리하세요."),
        item("부동산 중개사용", "브로슈어, 매물 자료, listing asset을 더 효율적으로 준비하세요."),
      ],
      useCasesCta: "도구 사용해보기",
      processDescription: "간단하고 빠르며 안전합니다. 4단계로 문서를 준비하세요.",
      processSteps: [
        step("01", "도구 선택", "PDF, 이미지, 텍스트 도구 모음에서 적합한 workflow를 선택하세요."),
        step("02", "파일 업로드", "파일을 브라우저에 끌어놓고 제공되는 옵션을 설정하세요."),
        step("03", "몇 초 안에 처리", "추가 소프트웨어 설치 없이 작업을 바로 실행하세요."),
        step("04", "다운로드 및 공유", "결과를 바로 받고 계속 작업하세요."),
      ],
      featuresDescription: "속도, 개인정보 보호, 실용적인 workflow를 위해 만들어진 무료 도구를 제공합니다.",
      features: [
        item("항상 무료", "구독, 숨겨진 비용, 결제 장벽 없이 도구를 사용하세요."),
        item("안전하고 비공개", "개인정보를 고려한 workflow가 민감한 파일을 더 잘 관리하도록 도와줍니다."),
        item("매우 빠름", "브라우저 기반 workflow가 반복 작업에 드는 시간을 줄여줍니다."),
        item("사용하기 쉬움", "비기술 사용자도 편하게 쓸 수 있도록 인터페이스를 설계했습니다."),
        item("모바일 친화적", "데스크톱, 태블릿, 모바일에서 모두 잘 작동합니다."),
        item("높은 품질", "과정을 단순하게 유지하면서도 실용적인 결과 품질을 유지하려고 합니다."),
      ],
      testimonialsDescription: "사용자들이 Dogufy에 대해 어떻게 말하는지 확인해 보세요.",
      testimonials: [
        quote("Dogufy 덕분에 논문 장들을 불필요한 복잡함 없이 빠르게 합칠 수 있었습니다.", "Sarah J.", "대학원생"),
        quote("웹 작업용으로 이미지 도구를 자주 사용하는데 빠르고 편리해서 좋습니다.", "Mike T.", "프론트엔드 개발자"),
        quote("문서 변환 도구 덕분에 편집 가능한 버전을 준비할 때 시간을 크게 절약합니다.", "Emily R.", "법률 어시스턴트"),
      ],
      landingContactDescription: "제품에 대해 이야기하고 싶거나 개선점을 제안하거나 질문이 있다면 언제든 연락하세요.",
      sayHi: "인사하기",
      getQuote: "견적 요청",
      name: "이름",
      email: "이메일",
      message: "메시지",
      send: "메시지 보내기",
    },
    about: {
      intro: "문서, 이미지, 텍스트 작업을 한곳에서 처리할 수 있는 Dogufy에 오신 것을 환영합니다.",
      missionBody: "강력한 생산성 도구는 누구나 접근할 수 있어야 한다고 믿습니다. 우리의 목표는 비싼 소프트웨어나 복잡한 설정 없이 더 빠르게 일할 수 있도록 돕는 무료 고품질 온라인 도구를 제공하는 것입니다.",
      offers: [
        "문서 변환, 병합, 분할, 압축, 편집을 위한 PDF 도구.",
        "크기 조정, 압축, 변환, 시각 자료 정리를 위한 이미지 도구.",
        "서식 지정, 변환, 분석을 위한 텍스트 도구.",
        "QR 생성기, UUID 생성기 등 개발자를 위한 빠른 유틸리티.",
      ],
      privacyTitle: "개인정보 우선",
      privacyBody: "대부분의 파일 처리는 브라우저에서 직접 이루어집니다. 파일이 사용자 통제 아래에 남아 있어 workflow를 더 빠르고 안전하며 비공개로 유지하는 데 도움이 됩니다.",
      freeTitle: "100% 무료",
      freeBody: "우리 도구는 구독, 숨겨진 비용, 가입 장벽 없이 사용할 수 있습니다.",
    },
    contact: {
      sentTitle: "메시지가 전송되었습니다!",
      sentBody: "문의해 주셔서 감사합니다. 가능한 한 빨리 답변드리겠습니다.",
      labels: { name: "이름", email: "이메일", subject: "제목", message: "메시지" },
      placeholders: {
        name: "이름을 입력하세요",
        email: "your.email@example.com",
        subject: "무엇에 관한 내용인가요?",
        message: "자세히 알려주세요...",
      },
      github: "GitHub",
      githubBody: "버그를 찾았거나 기여하고 싶다면 저장소를 확인해 보세요.",
      viewRepo: "저장소 보기",
    },
    privacy: {
      sections: [
        section("당신의 개인정보는 중요합니다", "우리는 개인정보 보호를 중요하게 여기며 불필요한 데이터 수집을 최소화하려고 합니다."),
        section("데이터 처리", "대부분의 도구는 브라우저에서 로컬로 파일을 처리합니다. 일부 고급 변환은 일시적인 서버 처리가 필요할 수 있습니다.", [
          "파일은 일반적으로 처리 중에도 기기에 남아 있습니다.",
          "임시 서버 작업은 완료 후 삭제됩니다.",
          "문서 내용을 의도적으로 저장하지 않습니다.",
        ]),
        section("수집하는 정보", undefined, [
          "동의 후에만 익명 분석이 활성화됩니다.",
          "핵심 도구 사용에 계정이 필요하지 않습니다.",
          "업로드된 파일은 영구 저장되지 않습니다.",
        ]),
        section("쿠키", undefined, [
          "동의 선택 저장.",
          "보안 및 필수 사이트 기능.",
          "명시적 허가 후 선택적 분석.",
        ]),
        section("사용자의 권리", "분석을 거부하고 브라우저 로컬 데이터를 삭제하며 언제든 서비스 사용을 중단할 수 있습니다."),
      ],
    },
    terms: {
      sections: [
        section("1. 약관 동의", "Dogufy를 사용하면 이 약관에 동의한 것으로 간주됩니다."),
        section("2. 서비스 이용", "이 서비스는 개인 및 상업적 생산성 목적을 위해 제공됩니다.", [
          "서비스를 합법적으로 사용하세요.",
          "플랫폼을 과부하시키거나 악용하지 마세요.",
          "도구를 해롭거나 악의적인 목적으로 사용하지 마세요.",
        ]),
        section("3. 서비스 가용성", "우리는 안정성을 추구하지만 중단 없는 접근이나 무오류 운영을 보장할 수는 없습니다."),
        section("4. 책임의 제한", "서비스 사용은 결과 품질과 workflow 적합성 확인을 포함해 사용자 본인의 책임입니다."),
        section("5. 사용자 책임", "파일과 그 처리 권한에 대한 책임은 여전히 사용자에게 있습니다.", [
          "중요한 원본은 백업해 두세요.",
          "중요한 용도로 사용하기 전에 결과 품질을 확인하세요.",
          "저작권 및 기타 법적 의무를 준수하세요.",
        ]),
        section("6. 문의", "이 약관에 대한 질문이 있다면 웹사이트를 통해 문의해 주세요."),
      ],
    },
    blog: {
      description: "PDF 도구, 이미지 처리, 생산성에 관한 최신 글을 읽어보세요.",
      intro: "문서, 이미지, 디지털 workflow에 관한 실용적인 글을 살펴보세요.",
      noTools: "검색 결과가 없습니다.",
      clear: "검색 지우기",
    },
    toolsPage: {
      description: "무료 온라인 도구 전체 컬렉션을 둘러보고 필요한 workflow를 정확히 찾아보세요.",
      intro: "이 허브 페이지는 사용자와 검색엔진이 Dogufy의 전체 도구 라이브러리를 이해하고 적절한 페이지로 빠르게 이동하도록 돕습니다.",
      searchPlaceholder: "도구 검색 (예: merge, image, pdf)...",
      noResultsTitle: "도구를 찾을 수 없습니다",
      noResultsBody: "검색과 일치하는 도구를 찾지 못했습니다. 다른 키워드나 카테고리를 시도해 보세요.",
      didYouKnow: "알고 계셨나요?",
      didYouKnowBody: "많은 workflow가 브라우저에서 직접 실행되어 문서 처리를 더 빠르고 비공개로 유지하는 데 도움이 됩니다.",
      whatMakesUseful: "이 도구가 유용한 이유는 무엇인가요?",
      howToOnline: "이 도구를 온라인에서 사용하는 방법",
      uploadOrEnter: "파일 업로드 또는 데이터 입력",
      configure: "설정 구성",
      processDownload: "처리 후 다운로드",
      bestUseCases: "가장 적합한 활용 사례",
      whyChoose: "이 도구에 Dogufy를 선택해야 하는 이유",
      fastFree: "빠르고 무료",
      fastFreeBody: "가입 장벽 없이 workflow를 빠르게 사용할 수 있습니다.",
      securePrivate: "안전하고 비공개",
      securePrivateBody: "사용자 파일이 불필요하게 노출되지 않도록 설계되었습니다.",
      highQuality: "높은 품질",
      highQualityBody: "과정을 단순화하면서도 유용한 출력 품질을 유지하려고 합니다.",
      relatedCategory: "관련 도구",
      removeFile: "파일 제거",
      convertedImages: "변환된 이미지",
      downloadAll: "모두 다운로드",
      downloadPage: "페이지 다운로드",
      pageLabel: "페이지",
      convertingPdf: "PDF 변환 중...",
      convertingPdfToImages: "PDF를 이미지로 변환 중...",
      complete: "완료",
      completed: "처리됨",
      convertToPng: "PNG로 변환",
      convertToPngDescription: "PDF 페이지를 투명도 지원이 포함된 고품질 PNG 이미지로 변환합니다.",
      convertToJpg: "JPG로 변환",
      convertToJpgDescription: "PDF 페이지를 고품질 JPG 이미지로 변환합니다.",
      invalidPdfFile: "PDF 파일을 선택해 주세요.",
      pdfToPngError: "PDF를 PNG로 변환하는 중 오류가 발생했습니다.",
      pdfConversionError: "PDF 변환 중 오류가 발생했습니다. 다시 시도해 주세요.",
      convertToWord: "Word로 변환",
      convertToWordDescription: "PDF 파일을 편집 가능한 Word 문서(DOCX)로 변환합니다.",
      convertToWordButton: "Word로 변환 (.docx)",
      convertingToWord: "Word로 변환 중...",
      pdfToWordError: "PDF를 Word로 변환하는 중 오류가 발생했습니다. 다시 시도해 주세요.",
      convertToPdf: "PDF로 변환",
      convertingToPdf: "PDF로 변환 중...",
      wordToPdfError: "Word를 PDF로 변환하는 중 오류가 발생했습니다. 다시 시도해 주세요.",
      mergePdfTitle: "PDF 파일 병합",
      mergePdfDescription: "여러 PDF 파일을 하나의 문서로 합치세요. 드래그 앤 드롭으로 순서를 바꿀 수 있습니다.",
      mergePdfHint: "병합하려면 PDF 파일을 2개 이상 선택하세요.",
      filesToMerge: "병합할 파일",
      clearAll: "모두 지우기",
      moveUp: "위로 이동",
      moveDown: "아래로 이동",
      merging: "병합 중...",
      mergePdfs: "PDF 병합",
      mergePdfError: "PDF 병합 중 오류가 발생했습니다. 모든 파일이 유효한 PDF인지 확인해 주세요.",
    },
  },
  ja: {
    landing: {
      toolsDescription: "よく使われる無料オンラインツールをまとめて確認できます。安全で高速、しかも使いやすい設計です。",
      useCasesTitle: "活用シーン",
      useCasesDescription: "Dogufy がさまざまなユーザーの作業をどう効率化するかをご覧ください。",
      useCases: [
        item("学生・研究用途に", "課題の結合、論文ファイルの圧縮、研究資料の編集可能形式への変換に役立ちます。"),
        item("ビジネス用途に", "契約書への署名、レポートの結合、表計算データの共有しやすい PDF 化が行えます。"),
        item("デザイナー・クリエイターに", "画像の最適化、背景除去、asset 変換を素早く行えます。"),
        item("法務チームに", "機密文書をよりプライベートで整理された workflow で扱えます。"),
        item("不動産エージェントに", "パンフレット、物件資料、listing 用 asset を効率よく準備できます。"),
      ],
      useCasesCta: "ツールを試す",
      processDescription: "シンプルで高速、しかも安全。4ステップで文書をすぐに整えられます。",
      processSteps: [
        step("01", "ツールを選ぶ", "PDF・画像・テキストツールの中から目的に合った workflow を選択します。"),
        step("02", "ファイルをアップロード", "ファイルをブラウザにドラッグし、利用できる設定を調整します。"),
        step("03", "数秒で処理", "追加ソフトなしでそのまま処理を実行できます。"),
        step("04", "ダウンロードして共有", "結果をすぐ受け取り、そのまま次の作業へ進めます。"),
      ],
      featuresDescription: "速度、プライバシー、実用的な workflow を重視した無料ツールを提供しています。",
      features: [
        item("ずっと無料", "サブスクリプション、隠れた料金、課金壁なしで利用できます。"),
        item("安全でプライベート", "プライバシーを意識した workflow が機密ファイルの管理を助けます。"),
        item("とても高速", "ブラウザ上の workflow により、繰り返し作業の時間を短縮できます。"),
        item("使いやすい", "非技術ユーザーでも扱いやすいように設計されています。"),
        item("モバイル対応", "デスクトップ、タブレット、スマホでも快適に動作します。"),
        item("高品質", "プロセスを簡単にしながら、実用的な出力品質を保つことを目指しています。"),
      ],
      testimonialsDescription: "Dogufy に対するユーザーの声をご覧ください。",
      testimonials: [
        quote("Dogufy のおかげで、余計な複雑さなく論文の章をすばやく結合できました。", "Sarah J.", "大学院生"),
        quote("画像ツールは速くて便利なので、Web の仕事でよく使っています。", "Mike T.", "フロントエンド開発者"),
        quote("文書変換ツールのおかげで、編集可能な版を準備する時間を大きく短縮できました。", "Emily R.", "法務アシスタント"),
      ],
      landingContactDescription: "製品について話したいとき、改善提案があるとき、質問があるときはぜひご連絡ください。",
      sayHi: "相談する",
      getQuote: "見積もりを依頼",
      name: "名前",
      email: "メール",
      message: "メッセージ",
      send: "メッセージを送信",
    },
    about: {
      intro: "Dogufy へようこそ。文書、画像、テキスト作業をまとめて進められる場所です。",
      missionBody: "強力な生産性ツールは誰でも使えるべきだと私たちは考えています。高価なソフトや複雑な設定なしで、より速く作業できる無料の高品質オンラインツールを提供することが私たちの使命です。",
      offers: [
        "文書の変換、結合、分割、圧縮、編集を行う PDF ツール。",
        "サイズ変更、圧縮、変換、整理に使える画像ツール。",
        "整形、変換、分析のためのテキストツール。",
        "QR 生成、UUID 生成などの開発者向けユーティリティ。",
      ],
      privacyTitle: "プライバシーを最優先",
      privacyBody: "多くの処理はブラウザ内で直接行われます。ファイルはユーザーの管理下に残るため、workflow を高速かつ安全に保ちやすくなります。",
      freeTitle: "100% 無料",
      freeBody: "サブスクリプション、隠れた料金、登録の壁なしで利用できます。",
    },
    contact: {
      sentTitle: "メッセージを送信しました",
      sentBody: "お問い合わせありがとうございます。できるだけ早く返信します。",
      labels: { name: "名前", email: "メール", subject: "件名", message: "メッセージ" },
      placeholders: {
        name: "お名前",
        email: "your.email@example.com",
        subject: "どのような内容ですか？",
        message: "詳しくお聞かせください...",
      },
      github: "GitHub",
      githubBody: "バグを見つけた、または貢献したい場合はリポジトリをご覧ください。",
      viewRepo: "リポジトリを見る",
    },
    privacy: {
      sections: [
        section("あなたのプライバシーは重要です", "私たちはプライバシーを重視し、不要なデータ収集を最小限に抑えるよう努めています。"),
        section("データ処理", "ほとんどのツールはブラウザ内でローカル処理されます。一部の高度な変換では、一時的なサーバー処理が必要になる場合があります。", [
          "通常、処理中もファイルはお使いの端末に残ります。",
          "一時的なサーバージョブは完了後に削除されます。",
          "文書の内容を意図的に保存することはありません。",
        ]),
        section("収集する情報", undefined, [
          "匿名分析は同意後のみ有効になります。",
          "主要ツールの利用にアカウントは不要です。",
          "アップロードファイルを恒久的に保存することはありません。",
        ]),
        section("Cookie", undefined, [
          "同意設定の保存。",
          "セキュリティおよび必須機能。",
          "明示的な許可後の任意分析。",
        ]),
        section("あなたの権利", "分析を拒否し、ブラウザのローカルデータを削除し、いつでもサービス利用を停止できます。"),
      ],
    },
    terms: {
      sections: [
        section("1. 規約への同意", "Dogufy を利用することで、これらの規約に同意したものとみなされます。"),
        section("2. サービスの利用", "本サービスは個人および商用の生産性向上のために提供されます。", [
          "法令に従ってサービスを利用してください。",
          "プラットフォームを過負荷にしたり、悪用したりしないでください。",
          "有害または悪意ある目的でツールを使用しないでください。",
        ]),
        section("3. サービスの可用性", "私たちは信頼性向上に努めていますが、無停止アクセスや無エラー動作を保証するものではありません。"),
        section("4. 責任の制限", "サービスの利用は、出力品質や workflow の適合性確認を含め、利用者自身の責任で行われます。"),
        section("5. ユーザーの責任", "ファイルおよびその処理権限については引き続きユーザーが責任を負います。", [
          "重要な元ファイルはバックアップしてください。",
          "重要用途の前に出力品質を確認してください。",
          "著作権やその他の法的義務を尊重してください。",
        ]),
        section("6. お問い合わせ", "本規約に関するご質問は、ウェブサイトを通じてご連絡ください。"),
      ],
    },
    blog: {
      description: "PDF ツール、画像処理、生産性に関する最新記事をお読みください。",
      intro: "文書、画像、デジタル workflow に関する実践的な記事をチェックしましょう。",
      noTools: "結果が見つかりませんでした。",
      clear: "検索をクリア",
    },
    toolsPage: {
      description: "無料オンラインツールの全コレクションを確認し、必要な workflow を正確に見つけましょう。",
      intro: "このハブページは、ユーザーと検索エンジンが Dogufy のツール全体を理解し、適切なページへすばやく移動するのに役立ちます。",
      searchPlaceholder: "ツールを検索 (例: merge, image, pdf)...",
      noResultsTitle: "ツールが見つかりません",
      noResultsBody: "検索条件に一致するツールが見つかりませんでした。別のキーワードやカテゴリを試してください。",
      didYouKnow: "ご存じでしたか？",
      didYouKnowBody: "多くの workflow はブラウザ内で直接実行されるため、文書処理をより高速かつプライベートに保てます。",
      whatMakesUseful: "このツールが役立つ理由",
      howToOnline: "このツールをオンラインで使う方法",
      uploadOrEnter: "ファイルをアップロードまたはデータを入力",
      configure: "設定を調整",
      processDownload: "処理してダウンロード",
      bestUseCases: "最適な活用シーン",
      whyChoose: "このツールで Dogufy を選ぶ理由",
      fastFree: "高速で無料",
      fastFreeBody: "登録の壁なしで workflow をすぐ使えます。",
      securePrivate: "安全でプライベート",
      securePrivateBody: "ユーザーファイルが不必要に露出しないように設計されています。",
      highQuality: "高品質",
      highQualityBody: "処理を簡単にしながら、実用的な出力品質を保つことを目指しています。",
      relatedCategory: "関連ツール",
      removeFile: "ファイルを削除",
      convertedImages: "変換済み画像",
      downloadAll: "すべてダウンロード",
      downloadPage: "ページをダウンロード",
      pageLabel: "ページ",
      convertingPdf: "PDF を変換中...",
      convertingPdfToImages: "PDF を画像に変換中...",
      complete: "完了",
      completed: "済み",
      convertToPng: "PNG に変換",
      convertToPngDescription: "PDF ページを透明度対応の高品質 PNG 画像に変換します。",
      convertToJpg: "JPG に変換",
      convertToJpgDescription: "PDF ページを高品質 JPG 画像に変換します。",
      invalidPdfFile: "PDF ファイルを選択してください。",
      pdfToPngError: "PDF から PNG への変換中にエラーが発生しました。",
      pdfConversionError: "PDF の変換中にエラーが発生しました。もう一度お試しください。",
      convertToWord: "Word に変換",
      convertToWordDescription: "PDF ファイルを編集可能な Word ドキュメント (DOCX) に変換します。",
      convertToWordButton: "Word に変換 (.docx)",
      convertingToWord: "Word に変換中...",
      pdfToWordError: "PDF から Word への変換中にエラーが発生しました。もう一度お試しください。",
      convertToPdf: "PDF に変換",
      convertingToPdf: "PDF に変換中...",
      wordToPdfError: "Word から PDF への変換中にエラーが発生しました。もう一度お試しください。",
      mergePdfTitle: "PDF ファイルを結合",
      mergePdfDescription: "複数の PDF ファイルを 1 つの文書にまとめます。ドラッグして順番を変更できます。",
      mergePdfHint: "結合する PDF ファイルを 2 つ以上選択してください",
      filesToMerge: "結合するファイル",
      clearAll: "すべてクリア",
      moveUp: "上へ移動",
      moveDown: "下へ移動",
      merging: "結合中...",
      mergePdfs: "PDF を結合",
      mergePdfError: "PDF の結合中にエラーが発生しました。すべてのファイルが有効な PDF か確認してください。",
    },
  },
  ro: {
    landing: {
      toolsDescription: "Descoperă cele mai folosite unelte online gratuite ale noastre. Sigure, rapide și ușor de folosit.",
      useCasesTitle: "Cazuri de utilizare",
      useCasesDescription: "Vezi cum Dogufy ajută diferite tipuri de utilizatori să lucreze mai eficient.",
      useCases: [
        item("Pentru studenți și mediul academic", "Unește teme, comprimă lucrări de licență și transformă documente de cercetare în formate editabile."),
        item("Pentru profesioniști din business", "Semnează contracte, combină rapoarte și transformă tabele în fișiere PDF ușor de distribuit."),
        item("Pentru designeri și creativi", "Optimizează imagini, elimină fundaluri și convertește asset-uri mai rapid."),
        item("Pentru echipe juridice", "Gestionează documente sensibile prin workflow-uri mai private și mai ordonate."),
        item("Pentru agenți imobiliari", "Pregătește broșuri, dosare de proprietăți și asset-uri pentru listări mai eficient."),
      ],
      useCasesCta: "Încearcă uneltele",
      processDescription: "Simplu, rapid și sigur. Pregătește documentele în 4 pași.",
      processSteps: [
        step("01", "Alege unealta", "Selectează workflow-ul potrivit din colecția noastră de unelte PDF, imagine și text."),
        step("02", "Încarcă fișierele", "Trage fișierul în browser și ajustează opțiunile disponibile."),
        step("03", "Procesează în câteva secunde", "Rulează taskul imediat, fără software suplimentar."),
        step("04", "Descarcă și distribuie", "Primești rezultatul pe loc și continui fără întreruperi."),
      ],
      featuresDescription: "Oferim unelte gratuite create pentru viteză, confidențialitate și workflow-uri practice.",
      features: [
        item("Gratuit pentru totdeauna", "Folosește uneltele fără abonament, costuri ascunse sau paywall."),
        item("Sigur și privat", "Workflow-urile orientate spre confidențialitate ajută la controlul fișierelor sensibile."),
        item("Foarte rapid", "Workflow-urile din browser reduc timpul petrecut pe sarcini repetitive."),
        item("Ușor de folosit", "Interfața este gândită să fie comodă și pentru utilizatorii non-tehnici."),
        item("Compatibil mobil", "Experiența funcționează bine pe desktop, tabletă și mobil."),
        item("Calitate înaltă", "Încercăm să păstrăm o calitate utilă a rezultatului, simplificând în același timp procesul."),
      ],
      testimonialsDescription: "Vezi ce spun utilizatorii despre Dogufy.",
      testimonials: [
        quote("Dogufy m-a ajutat să unesc rapid capitolele lucrării mele fără complicații inutile.", "Sarah J.", "Studentă master"),
        quote("Folosesc regulat uneltele pentru imagini în munca web pentru că sunt rapide și practice.", "Mike T.", "Dezvoltator frontend"),
        quote("Uneltele de conversie a documentelor economisesc timp când pregătesc versiuni editabile.", "Emily R.", "Asistentă juridică"),
      ],
      landingContactDescription: "Contactează-ne dacă vrei să discuți despre produs, să propui îmbunătățiri sau să pui o întrebare.",
      sayHi: "Spune salut",
      getQuote: "Solicită ofertă",
      name: "Nume",
      email: "Email",
      message: "Mesaj",
      send: "Trimite mesajul",
    },
    about: {
      intro: "Bine ai venit la Dogufy, locul tău pentru documente, imagini și text într-o singură platformă.",
      missionBody: "Credem că uneltele puternice de productivitate trebuie să fie accesibile tuturor. Misiunea noastră este să oferim unelte online gratuite și de calitate, care ajută utilizatorii să lucreze mai repede fără software scump sau configurări complicate.",
      offers: [
        "Unelte PDF pentru conversie, îmbinare, separare, comprimare și editare de documente.",
        "Unelte pentru imagini: redimensionare, comprimare, conversie și curățare de asset-uri vizuale.",
        "Unelte pentru text: formatare, conversie și analiză de conținut.",
        "Utilitare pentru dezvoltatori precum generator QR, generator UUID și alte ajutoare rapide.",
      ],
      privacyTitle: "Confidențialitatea pe primul loc",
      privacyBody: "Cea mai mare parte a procesării are loc direct în browser. Fișierele rămân sub controlul tău, ceea ce ajută la păstrarea unui workflow rapid, privat și sigur.",
      freeTitle: "100% gratuit",
      freeBody: "Uneltele noastre sunt disponibile fără abonamente, costuri ascunse sau bariere de înregistrare.",
    },
    contact: {
      sentTitle: "Mesaj trimis!",
      sentBody: "Mulțumim pentru mesaj. Îți vom răspunde cât mai curând.",
      labels: { name: "Nume", email: "Email", subject: "Subiect", message: "Mesaj" },
      placeholders: {
        name: "Numele tău",
        email: "your.email@example.com",
        subject: "Despre ce este vorba?",
        message: "Spune-ne mai multe...",
      },
      github: "GitHub",
      githubBody: "Ai găsit un bug sau vrei să contribui? Aruncă o privire la repository.",
      viewRepo: "Vezi repository-ul",
    },
    privacy: {
      sections: [
        section("Confidențialitatea ta contează", "Tratăm confidențialitatea cu seriozitate și încercăm să minimizăm colectarea inutilă de date."),
        section("Procesarea datelor", "Majoritatea uneltelor procesează fișierele local în browser. Unele conversii avansate pot necesita procesare temporară pe server.", [
          "Fișierele rămân de obicei pe dispozitivul tău în timpul procesării.",
          "Joburile temporare de pe server sunt șterse după finalizare.",
          "Nu stocăm intenționat conținutul documentelor tale.",
        ]),
        section("Ce informații colectăm", undefined, [
          "Analitică anonimă doar după consimțământ.",
          "Nu este nevoie de cont pentru uneltele de bază.",
          "Nu există stocare permanentă pentru fișierele încărcate.",
        ]),
        section("Cookie-uri", undefined, [
          "Stocarea preferinței de consimțământ.",
          "Securitate și funcționalitate esențială a site-ului.",
          "Analitică opțională după permisiune explicită.",
        ]),
        section("Drepturile tale", "Poți refuza analitica, poți șterge datele locale din browser și poți înceta oricând folosirea serviciului."),
      ],
    },
    terms: {
      sections: [
        section("1. Acceptarea termenilor", "Prin utilizarea Dogufy, accepți acești termeni."),
        section("2. Utilizarea serviciului", "Serviciul este oferit pentru nevoi de productivitate personale și comerciale.", [
          "Folosește serviciul în mod legal.",
          "Nu supraîncărca, nu exploata și nu abuza platforma.",
          "Nu folosi uneltele în scopuri dăunătoare sau malițioase.",
        ]),
        section("3. Disponibilitatea serviciului", "Ne dorim fiabilitate, dar nu putem garanta acces neîntrerupt sau funcționare fără erori."),
        section("4. Limitarea răspunderii", "Utilizarea serviciului se face pe propriul risc, inclusiv verificarea calității rezultatului și a potrivirii workflow-ului."),
        section("5. Responsabilitățile utilizatorului", "Rămâi responsabil pentru fișierele tale și pentru dreptul de a le procesa.", [
          "Păstrează copii de siguranță pentru fișierele importante.",
          "Verifică rezultatul înainte de utilizări critice.",
          "Respectă drepturile de autor și celelalte obligații legale.",
        ]),
        section("6. Contact", "Dacă ai întrebări despre acești termeni, contactează-ne prin intermediul site-ului."),
      ],
    },
    blog: {
      description: "Citește cele mai noi articole despre unelte PDF, procesare de imagini și productivitate.",
      intro: "Explorează articole practice despre documente, imagini și workflow-uri digitale.",
      noTools: "Nu s-au găsit rezultate.",
      clear: "Șterge căutarea",
    },
    toolsPage: {
      description: "Răsfoiește întreaga noastră colecție de unelte online gratuite și găsește exact workflow-ul de care ai nevoie.",
      intro: "Această pagină hub îi ajută pe vizitatori și pe motoarele de căutare să înțeleagă întreaga bibliotecă de unelte Dogufy și să ajungă rapid la pagina potrivită.",
      searchPlaceholder: "Caută o unealtă (ex.: merge, image, pdf)...",
      noResultsTitle: "Nu s-au găsit unelte",
      noResultsBody: "Nu am găsit unelte care să corespundă căutării tale. Încearcă alt cuvânt-cheie sau altă categorie.",
      didYouKnow: "Știai că?",
      didYouKnowBody: "Multe workflow-uri rulează direct în browser, ceea ce face lucrul cu documente mai rapid și mai privat.",
      whatMakesUseful: "Ce face această unealtă utilă?",
      howToOnline: "Cum folosești această unealtă online",
      uploadOrEnter: "Încarcă sau introdu date",
      configure: "Configurează setările",
      processDownload: "Procesează și descarcă",
      bestUseCases: "Cele mai bune utilizări",
      whyChoose: "De ce să alegi Dogufy pentru această unealtă?",
      fastFree: "Rapid și gratuit",
      fastFreeBody: "Folosește workflow-ul rapid, fără bariere de înregistrare.",
      securePrivate: "Sigur și privat",
      securePrivateBody: "Experiența este gândită pentru a reduce expunerea inutilă a fișierelor utilizatorului.",
      highQuality: "Calitate înaltă",
      highQualityBody: "Încercăm să păstrăm o calitate utilă a rezultatului în timp ce simplificăm procesul.",
      relatedCategory: "Unelte similare",
      removeFile: "Elimină fișierul",
      convertedImages: "Imagini convertite",
      downloadAll: "Descarcă tot",
      downloadPage: "Descarcă pagina",
      pageLabel: "Pagină",
      convertingPdf: "Se convertește PDF-ul...",
      convertingPdfToImages: "Se convertește PDF-ul în imagini...",
      complete: "gata",
      completed: "finalizat",
      convertToPng: "Convertește în PNG",
      convertToPngDescription: "Transformă paginile PDF în imagini PNG de înaltă calitate cu suport pentru transparență.",
      convertToJpg: "Convertește în JPG",
      convertToJpgDescription: "Transformă paginile PDF în imagini JPG de înaltă calitate.",
      invalidPdfFile: "Te rugăm să selectezi un fișier PDF.",
      pdfToPngError: "A apărut o eroare la conversia PDF în PNG",
      pdfConversionError: "A apărut o eroare la conversia PDF. Încearcă din nou.",
      convertToWord: "Convertește în Word",
      convertToWordDescription: "Transformă fișierele PDF în documente Word editabile (DOCX).",
      convertToWordButton: "Convertește în Word (.docx)",
      convertingToWord: "Se convertește în Word...",
      pdfToWordError: "A apărut o eroare la conversia PDF în Word. Încearcă din nou.",
      convertToPdf: "Convertește în PDF",
      convertingToPdf: "Se convertește în PDF...",
      wordToPdfError: "A apărut o eroare la conversia Word în PDF. Încearcă din nou.",
      mergePdfTitle: "Unește fișiere PDF",
      mergePdfDescription: "Combină mai multe fișiere PDF într-un singur document. Trage și rearanjează fișierele.",
      mergePdfHint: "Selectează 2 sau mai multe fișiere PDF pentru unire",
      filesToMerge: "Fișiere de unit",
      clearAll: "Șterge tot",
      moveUp: "Mută în sus",
      moveDown: "Mută în jos",
      merging: "Se unesc...",
      mergePdfs: "Unește PDF-uri",
      mergePdfError: "A apărut o eroare la unirea PDF-urilor. Asigură-te că toate fișierele sunt PDF-uri valide.",
    },
  },
};

export const siteContentCompletions: Partial<Record<Locale, unknown>> = {
  ...firstHalf,
  ...secondHalf,
};
